<template>

  <div class="qwrap"  v-bind:class="{activeoffer:isOffers}"  >

    <header
      v-if="!agecheckpop"
      class="fixed-top align-items-center bg-white border-bottom shadow-sm"
    >
      <nav class="navbar px-md-4">
        <a class="navbar-brand" href="javascript:;" v-on:click="setLogoLocation();clearMarker();">Qnabes</a>
        <div class="d-flex headersearch" v-if="!displaySelectLocation">
          <div class="location-search-wrap" v-bind:class="{ mob_search:  is_show_location }">

            <div class="location-wrap" v-on:click="clearMarker()">
              <div class="location-search">
                <i v-on:click="setMylocation();clearMarker();" class="fi flaticon-gps"></i>

                <vue-bootstrap-typeahead
                  :data="addresses"
                  v-model="addressSearch"
                  size="lg"
                  ref="townTypeahead"
                  :serializer="s => s.title"
                  placeholder="Select City/State"
                  @hit="selectedAddress = $event"
                >
                  <template slot="suggestion" slot-scope="{ data, htmlText }">
                    <i class="fi flaticon-map"></i>
                    <span v-html="htmlText"></span>&nbsp;
                    <small>{{ data.code }}</small>
                  </template>

              

                </vue-bootstrap-typeahead>
              </div>
            </div>
          </div>

          <div class="brand-search-wrap" v-bind:class="{ mob_search:  is_show_namesearch}">
            <div class="brand-wrap">
              <div class="brand-search" v-on:click="clearMarker()">
                <i class="fi flaticon-search"></i>
                <vue-bootstrap-typeahead
                  :data="brand"
                  v-model="brandSearch"
                  size="lg"
                   ref="brandTypeahead"
                  backgroundVariant="lp"
                  :serializer="s => s.title"
                  @hit="setbrandevent($event)"
                  placeholder="Search by Name"
                >
                  <template slot="suggestion" slot-scope="{ data, htmlText }">
                    <span v-html="htmlText"></span>&nbsp;
                    <small>{{ data.code }}</small>
                    <div class="cat_name">{{data.city}}, {{data.state}}</div>
                  </template>
                </vue-bootstrap-typeahead>
              </div>
            </div>
          </div>

          <a  href="javascript:;" @click="switchType()" class="view-button">
            <i class :class="[ defaultType=='List' ? 'fi flaticon-list' : 'fi flaticon-place' ]"></i>
            {{defaultType}}
          </a>
          <div class="mobile_icons">
            <ul>
              <li v-bind:class="{ 'active':  is_show_location }" v-on:click="searchTogle('location')" ><a href="#"><img src="../assets/images/pin_mob.svg"></a></li>
              <li   v-bind:class="{ 'active':  is_show_namesearch}" v-on:click="searchTogle('name')" ><a href="#"><img src="../assets/images/search_mob.svg"></a></li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="cat_selector">
        <label> <input  type="checkbox" value="Retail Store"   />Retail Stores</label>
                <label> <input  type="checkbox" value="Manufacturers"   />Manufacturers</label>

       </div>


          <transition name="slide" mode="in-out">

	<div class="side_menu storelistwrap" v-bind:class="{activemenu:  storeSeleector, side_menu_mob:  mobilebrowse }" v-if="storeSeleector" >
    <!-- <div class="side_menu"> -->
		
                    <template v-for="(item, i) in storeSeleector" >

    	<div class="side_menu_title storelist" @click="setMarker(item)" >
				<div class="menu_title_details">
					<h2><a @click="setMobileMenu()" class="mob_return"></a> {{item.title}}</h2>
					<p><span><img src="../assets/images/pointer.svg"></span><em>{{item.address}}</em></p>
					<p><span><img src="../assets/images/telephone.svg"></span><em>{{item.phone}}</em></p>
					<a v-if="item.website!=''"  target="_blank" :href="item.website"><span><img src="../assets/images/global.svg"></span>{{item.website}}</a>
				</div>
				<figure class="flower_logo"><img src="../assets/images/flower_icon.png"></figure>
				<div class="mob_actions">
					<a class="call"  v-on:click="openTel(item.phone)"
                      :href="`tel:${ item.phone }`" ><img src="../assets/images/phone.svg"> Call</a>
					<a  target="_blank"
                      v-bind:href="'https://www.google.com/maps?saddr=My+Location&daddr='+item.address" ><img src="../assets/images/location.svg">Start</a>
				</div>
			</div>

      				<span @click="clearMarker();storeSeleector=null" class="side_menu_close"><em></em></span>
                    </template>

		
		</div>

      </transition>

      <transition name="slide" mode="in-out">

	<div class="side_menu" v-bind:class="{activemenu:  selectedMarker, side_menu_mob:  mobilebrowse }" v-if="selectedMarker" >
    <!-- <div class="side_menu"> -->
			<div class="side_menu_title">
				<div class="menu_title_details">
					<h2><a @click="setMobileMenu()" class="mob_return"></a> {{selectedMarker.title}}</h2>
					<p><span><img src="../assets/images/pointer.svg"></span><em>{{selectedMarker.address}}</em></p>
					<p><span><img src="../assets/images/telephone.svg"></span><em>{{selectedMarker.phone}}</em></p>
					<a v-if="selectedMarker.website!=''"  target="_blank" :href="selectedMarker.website"><span><img src="../assets/images/global.svg"></span>{{selectedMarker.website}}</a>
				</div>
				<figure class="flower_logo"><img src="../assets/images/flower_icon.png"></figure>
				<div class="mob_actions">
					<a class="call"  v-on:click="openTel(selectedMarker.phone)"
                      :href="`tel:${ selectedMarker.phone }`" ><img src="../assets/images/phone.svg"> Call</a>
					<a  target="_blank"
                      v-bind:href="'https://www.google.com/maps?saddr=My+Location&daddr='+selectedMarker.address" ><img src="../assets/images/location.svg">Start</a>
				</div>
			</div>
			<div class="products_list_wrap">
				<div class="products_title" v-if="productsloaded && selectedMarker.products.length > 0"  >
					<h3   v-if="productsloaded && selectedMarker.products.length > 0" class="product_title" @click="setMobileMenu()"  >BROWSE PRODUCTS</h3>
				
 
				</div>
				<div class="products_list"    >
          <div class="loadingproducts" v-if="!productsloaded && selectedMarker.products==null">
            Loading
          </div>
            <div  class="noproducts"  v-if="productsloaded && selectedMarker.products.length == 0">
            No Products Found
          </div>
					<ul v-if="selectedMarker.products" >
						<li    v-for="(product, i) in selectedMarker.products"
            v-if="product"  >
							<figure>
								<img src="../assets/images/product_dp.png" >
							</figure>
							<p>
                  <span v-for="(element, index) in product.categories">
    <span v-if="index != 0">, </span><span>{{ element.name }}</span>
  </span>
                
                {{product.name}}</p>
						</li>
					</ul>
				</div>
				<span @click="clearMarker()" class="side_menu_close"><em></em></span>
			</div>
		</div>

      </transition>

  <transition name="fade">

    <div class="vue-map" v-show="defaultType=='List'" v-bind:class="{map_menu:  selectedMarker }">
      <vue-gmap
        @click.native="clearMarkerMap($event);"
        :options="{
   zoomControl: true,
   mapTypeControl: false,
   scaleControl: false,
   streetViewControl: false,
   rotateControl: false,
   fullscreenControl: false,
   disableDefaultUi: true,
   maxZoom:19,
   clickableIcons:false,
 }"
        :center="mapCenter"
        :zoom="mapzoom"
        ref="mapRef"
        map-type-id="roadmap"
        style="width: 100%;"
      >
        <cluster :zoom-on-click="onClusterClick()"   ref="clusterRef">
          <gmap-custom-marker
            alignment="topright"
            v-for="(marker, i) in markers"
            v-if="marker"
            :marker="{lat: marker.latitude, lng: marker.longitude, custom:marker}"
            @click.native="onMapClick(marker);"
          >

                

            <div  class="custom_marker" :class="[ marker.isActive ? 'active' : '' ]">

              <div class="offer_icon"  v-if="marker.offers && marker.offers == 1" > 
             <span>  $  </span>
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 22 22"><defs>
  </defs><path class="ad" d="M31.3,11.283a.621.621,0,0,1,0-.57l.855-1.679A1.873,1.873,0,0,0,31.295,6.5l-1.72-.876a.647.647,0,0,1-.349-.461l-.336-1.84a1.982,1.982,0,0,0-2.248-1.567l-1.928.262a.69.69,0,0,1-.565-.176l-1.4-1.3a2.051,2.051,0,0,0-2.779,0l-1.4,1.3a.69.69,0,0,1-.565.176l-1.928-.262a1.982,1.982,0,0,0-2.248,1.567l-.336,1.84a.647.647,0,0,1-.349.461l-1.72.876a1.873,1.873,0,0,0-.859,2.536l.855,1.679a.621.621,0,0,1,0,.57l-.855,1.679a1.873,1.873,0,0,0,.859,2.536l1.72.876a.647.647,0,0,1,.349.461l.336,1.84a1.968,1.968,0,0,0,1.962,1.587,2.13,2.13,0,0,0,.286-.019l1.928-.262a.69.69,0,0,1,.565.176l1.4,1.3a2.051,2.051,0,0,0,2.779,0l1.4-1.3a.691.691,0,0,1,.565-.176l1.928.262a1.982,1.982,0,0,0,2.248-1.567l.336-1.84a.647.647,0,0,1,.349-.461l1.72-.876a1.873,1.873,0,0,0,.859-2.536Z" transform="translate(-10.359 0.002)"/></svg>
                </div>

              <div class="svg_icon"> 
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="58.938" viewBox="0 0 36 58.938">
  <g id="Group_7907" data-name="Group 7907" transform="translate(-633.096 -294)">
    <circle id="Ellipse_200" data-name="Ellipse 200" cx="5" cy="5" r="5" transform="translate(645.996 340.438)" fill="#88c936" stroke="rgba(136,201,54,0.5)" stroke-width="5"/>
    <g id="taxi" transform="translate(633.096 294)">
      <path id="Path_15238" data-name="Path 15238" d="M121.665,31.4a18,18,0,0,0-4.32,35.476l3.627,17.039a.709.709,0,0,0,1.387,0l3.625-17.038A18,18,0,0,0,121.665,31.4Z" transform="translate(-103.665 -31.4)" fill="#88c936"/>
    </g>
    <path id="Subtraction_1" data-name="Subtraction 1" d="M8391,3489.487h0l-8.233-1.49a9.161,9.161,0,0,1-2.837.451,8.726,8.726,0,1,1,8.929-8.722,8.528,8.528,0,0,1-1.477,4.8l3.619,4.959Zm-9.7-9.615a2.379,2.379,0,1,0,2.437,2.38A2.41,2.41,0,0,0,8381.306,3479.872Zm-3.266-4.634a1.339,1.339,0,0,0-1.321,1.071,1.284,1.284,0,0,0,.206.973,1.338,1.338,0,0,0,.868.558,1.485,1.485,0,0,0,.251.023,1.33,1.33,0,0,0,1.315-1.072,1.276,1.276,0,0,0-.2-.968,1.34,1.34,0,0,0-.87-.563A1.4,1.4,0,0,0,8378.04,3475.238Z" transform="translate(-7729.482 -3168.356)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1"/>
  </g>
</svg>

              </div>

              <div class="svg_icon_active">
               
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="58.938" viewBox="0 0 36 58.938">
  <g id="Group_7908" data-name="Group 7908" transform="translate(-682.566 -294)">
    <g id="Group_7900" data-name="Group 7900" transform="translate(41 -13.3)">
      <circle id="Ellipse_200" data-name="Ellipse 200" cx="5" cy="5" r="5" transform="translate(654.996 353.738)" stroke="rgba(0,0,0,0.5)" stroke-width="5"/>
      <g id="taxi" transform="translate(641.566 307.3)">
        <path id="Path_15238" data-name="Path 15238" d="M121.665,31.4a18,18,0,0,0-4.32,35.476l3.627,17.039a.709.709,0,0,0,1.387,0l3.625-17.038A18,18,0,0,0,121.665,31.4Z" transform="translate(-103.665 -31.4)"/>
      </g>
    </g>
    <path id="Subtraction_2" data-name="Subtraction 2" d="M8391,3489.487h0l-8.233-1.49a9.161,9.161,0,0,1-2.837.451,8.726,8.726,0,1,1,8.929-8.722,8.528,8.528,0,0,1-1.477,4.8l3.619,4.959Zm-9.7-9.615a2.379,2.379,0,1,0,2.437,2.38A2.41,2.41,0,0,0,8381.306,3479.872Zm-3.266-4.634a1.339,1.339,0,0,0-1.321,1.071,1.284,1.284,0,0,0,.206.973,1.338,1.338,0,0,0,.868.558,1.485,1.485,0,0,0,.251.023,1.33,1.33,0,0,0,1.315-1.072,1.276,1.276,0,0,0-.2-.968,1.34,1.34,0,0,0-.87-.563A1.4,1.4,0,0,0,8378.04,3475.238Z" transform="translate(-7680.482 -3168.356)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1"/>
  </g>
</svg>

              </div>
            </div>
          </gmap-custom-marker>
        </cluster>

        <gmap-custom-marker
          v-if="currentLocationmarker"
          alignment="bottomright"
          :marker="currentLocationmarker"
        >
          <div class="mymarker">

  <div class="marker">
    <div class="pin"></div>
    <div class="pin-effect"></div>
  </div>

          </div>
        </gmap-custom-marker>
      </vue-gmap>
      <div class="slickSlider mapview-card-wrap">
        <div class="map-wrap" v-if="!hidelist">
          <div class="sliskc_players">
            <div
              class="slick_prev"
              @mouseover="previoushover = true"
              @mouseleave="previoushover = false"
            ></div>
            <div class="slick_next" @mouseover="nexthover = true" @mouseleave="nexthover = false"></div>
          </div>

          <slick v-if="markers.length > 0" :options="slickOptions" ref="slick">
            <div class="store_card" v-for="item of markers">
              <div class="custom_card" v-if="bindEvents" @click="setMarker(item)">
                <div
                  class="slideImg"
                  v-bind:style="{ 'background-image': 'url(https://qanbes.com/content/wp-content/uploads/qanbes_default_store.jpg)' }"
                >
                  <img v-bind:src="item.storeImage" class="img-fluid" />
                </div>
                <div class="slideCard">
                  <div class="carddetails">
                    <h3>{{item.title}}</h3>
                    <div class="address d-flex">
                      <i class="fi flaticon-phone"></i>
                      {{item.phone}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </div>

      
    </div>

          </transition>

  <transition name="fade">

    <div class="list-wrapper" id="list-view">
      <perfect-scrollbar>
        <div class="container">
          <div class="list-view_wrap" v-if="defaultType=='Map'">
            <div  v-show="selectedAddress && selectedAddress.title!='USA'" class="list_item" v-for="item of listmarkers">
              <div class="list_left">
                <div v-bind:style="{ 'background-image': 'url(../assets/images/flower_icon.png)' }"
                  class="list_flower" >
                  <img v-bind:src="item.storeImage" class="img-fluid" />
                </div>
                <div class="list_details">
                  <h2>{{item.title}}
                    <a target="_blank" v-bind:href="'https://www.google.com/maps?saddr=My+Location&daddr='+item.address"><em><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="9.997"
                  viewBox="0 0 10 9.997"
                >
                  <defs />
                  <path
                    class="directions"
                    d="M5.185,9.645,3.973,6.1.421,4.881A.621.621,0,0,1,.387,3.717L9.139.117A.623.623,0,0,1,9.952.93l-3.6,8.75A.622.622,0,0,1,5.185,9.645Z"
                    transform="translate(0 -0.068)"
                  />
                </svg></em></a>
                  </h2>
                  <p><span><img src="../assets/images/pointer.svg"></span><em>{{item.address}}</em></p>
                  <p><span><img src="../assets/images/telephone.svg"></span><em>{{item.phone}}</em></p>
                  <a  v-if="item.website" href="#"><span><img src="../assets/images/global.svg"></span>www.weed-crew.net</a>
                </div>
              </div>
              <div class="list_right">
                <!-- <a target="_blank" v-bind:href="'https://www.google.com/maps?saddr=My+Location&daddr='+item.address" class="directionsbtn" >
                  Directions &nbsp;&nbsp;</a> -->
                <a class="browse_products"  @click="setMarker(item)" href="javascript:;">BROWSE PRODUCTS</a>
              </div>







            </div>


            <div class="nostores" v-show="selectedAddress && selectedAddress.title=='USA'" >

              <h2> Select State/City/Name to search stores </h2>
            </div>

            
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </transition>
    <div class="agechecker" v-if="agecheckpop">
      <div class="backdrop"></div>
      <a class="navbar-brand" href>Qnabes</a>

      <div class="ageslector">
        <div class="headerpop">Are you 21+?</div>

        <div class="popcontent">
          <div class="d-flex">
            <div class="column">
              <div class="ageyes" v-on:click="setAge()">
                <i></i>
              </div>
            </div>

            <div class="column" v-on:click="exitPage()">
              <div class="ageno">
                <i></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nostorefound" v-if="displaySelectLocation && !agecheckpop">
      <div class="backdrop"></div>

      <div class="nostorepopup">
        <p>No stores available in your area. Choose City to discover the best cannabis</p>
        <div class="location-search-wrap">
          <div class="location-wrap">
            <div class="location-search">
              <i v-on:click="setMylocation();clearMarker();" class="fi flaticon-gps"></i>

              <vue-bootstrap-typeahead
                :data="addresses"
                v-model="addressSearch"
                size="lg"
                ref="nosletypehead"
                :serializer="s => s.title"
                placeholder="Select City/State"
                @hit="selectedAddress = $event"
              >
                <template slot="suggestion" slot-scope="{ data, htmlText }">
                  <i class="fi flaticon-map"></i>
                  <span v-html="htmlText"></span>&nbsp;
                  <small>{{ data.code }}</small>
                </template>
              </vue-bootstrap-typeahead>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offer_block" v-if="offerbanner.length > 0 && !agecheckpop" v-bind:class="{ offers_open: isOffers }">
				<span class="offer_button" v-on:click="isOffers = !isOffers" >OFFERS<img src="../assets/images/down-arrow.svg"></span>
        <div class="offers_banner" >

           <carousel v-if="showSlider"  @updated="offerbanner"  ref="carousel" :autoplay="offerbanner.length > 1" :nav="false" :items="1" :loop="offerbanner.length > 1" :dots="false">
            <figure v-for="(offer, i) in offerbanner">
              <a target="_blank" v-if="offer.link"   v-bind:href="offer.link"><img v-bind:src="offer.image"></a>
            
                <a   v-if="offer.link=='' && offer.vendor.length == 1" style="cursor:pointer" @click="selectOffer(offer.vendor[0])"  ><img v-bind:src="offer.image"></a>

               <a   v-if="offer.link=='' && offer.vendor.length == 0" href="javascript:;"    ><img v-bind:src="offer.image"></a>
               <a   v-if="offer.link=='' && offer.vendor.length > 1" href="javascript:;" @click="showVendors(offer.vendor)"  ><img v-bind:src="offer.image"></a>

            </figure>


          </carousel>

         
        </div>
			</div>      
  </div>
  
</template>

<script>
function loadMapShapes() {
  // load US state outline polygons from a GeoJson file
  map.data.loadGeoJson(
    "https://storage.googleapis.com/mapsdevsite/json/states.js",
    { idPropertyName: "STATE" }
  );

  // wait for the request to complete by listening for the first feature to be
  // added
  google.maps.event.addListenerOnce(map.data, "addfeature", function() {});
}
import axios from "axios";
import geodist from "geodist";
import carousel from 'vue-owl-carousel'

import { Map } from "vue2-google-maps";
import { VueAgile } from "vue-agile";
import _ from "underscore";
import Slick from "vue-slick";
import JQuery from "jquery";
let $ = JQuery;
import json from "../json/data.json";
import cities from "../json/cities.json";

import GmapCustomMarker from "vue2-gmap-custom-marker";
import { setTimeout } from "timers";
let API_URL = "https://qanbes.com/content/wp-json/api/v2/brands/?search=:query";
let CITIES_API_URL =
  "https://qanbes.com/content/wp-json/api/v6/cities/?search=:query";
let GOOGLE_FEATURES_URL = "https://qanbes.com/content/wp-json/api/v3/cities/";
let MARKERS_API_URL =
  "https://qanbes.com/content/wp-json/api/v3/stores/?search=:query";
let RADIUS_API_URL =
  "https://qanbes.com/content/wp-json/api/v2/geosearch/?latitude=:latitude&longitude=:longitude&dist=:dist";
var interval;
var rinterval;
export default {
  name: "GoogleMap",
  components: {
    carousel,
    GmapCustomMarker,
    agile: VueAgile,
    "vue-gmap": Map,
    Slick
  },
  data() {
    return {
      is_show_location:true,
      is_show_namesearch:false,
      isOffers: true,
      previoushover: false,
      nexthover: false,
      mobilebrowse:false,
      addresses: [],
      cityclicked: false,
      addressSearch: "",
      fromlocation: 0,
      markerszero: 0,
      brand: [],
      hidelist: true,
      brandSearch: "",
      selectedBrand: null,
      zoomswitcher: null,
      googlecircle: null,
      datastarts: false,
      selectedAddress: null,
      markersloaded: false,
      isActive: true,
      slickOptions: {
        slidesToShow: 7,
        variableWidth: true,
        centerMode: true,
        arrows: false,
        autoplaySpeed: 500,
        initialSlide: 8,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 2
            }
          }
        ]
      },
      mapCenter: { lat: 34.75898762, lng: -114.6012072 },
      markers: [],
      listmarkers:[],
      bindEvents: false,
      selectedMarker: "",
      productsloaded:false,
      offerbanner:[],
      clickedalready: false,
      defaultType: "List",
      places: [],
      mapzoom: 5,
      currentLocation: null,
      currentLocationmarker:null,
      mapfeatures: null,
      icon: null,
      markerClicked: false,
      agecheckpop: false,
      mylocationFormated: null,
      displaySelectLocation: false,
      locationnearfound: false,
      showSlider:false,
      storeSeleector:null
    };
  },

  mounted() {
    var self = this;
     this.showSlider = false;
           axios({
          method: "GET",
          url: 'https://qanbes.com/content/wp-json/api/v2/offers'}).then(
          result => {
           this.offerbanner= result.data;
           this.showSlider = true;
          })

    setInterval(function(){
             navigator.geolocation.getCurrentPosition(position => {

        if (position) {
          
              self.currentLocationmarker = {
                lat: position.coords.latitude,
                lng: position.coords.longitude  
              };

                      
        }
      });

    },5000)

    /*  check users already accpeted age verification ot not */
    var mapdata = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-81.67859476088988, 24.597646847168296],
                  [-81.79405699999998, 24.585999999999995],
                  [-81.81033299999999, 24.544700999999996],
                  [-81.69157499999999, 24.559885999999995],
                  [-81.60299799999997, 24.586444000000004],
                  [-81.48095099999998, 24.645120999999996],
                  [-81.41418699999998, 24.647166999999992],
                  [-81.39509599999998, 24.621062000000002],
                  [-81.30311299999998, 24.651665],
                  [-81.31928199999999, 24.701237999999993],
                  [-81.39294675658216, 24.74337092542559],
                  [-81.45188113085699, 24.714517636243997],
                  [-81.56291656739998, 24.692912346405596],
                  [-81.582922540963, 24.658731937461],
                  [-81.67859476088988, 24.597646847168296]
                ]
              ],
              [
                [
                  [-87.53958546140831, 30.997822447855157],
                  [-87.548543, 30.997926999999983],
                  [-87.59416399999998, 30.97757199999999],
                  [-87.59304599999999, 30.972965999999992],
                  [-87.63493799999996, 30.865885999999993],
                  [-87.594297, 30.816983999999994],
                  [-87.58186899999997, 30.812402999999996],
                  [-87.54536399999996, 30.77410499999999],
                  [-87.54226, 30.76750399999999],
                  [-87.53958546140831, 30.76493343187897],
                  [-87.53708499999996, 30.76252999999999],
                  [-87.53536499999998, 30.749774999999996],
                  [-87.47957899999999, 30.71286499999999],
                  [-87.47039699999998, 30.705280999999996],
                  [-87.40656099999998, 30.67401899999999],
                  [-87.40587399999998, 30.66661599999999],
                  [-87.39594099999997, 30.643967999999994],
                  [-87.39377499999996, 30.62700599999999],
                  [-87.42092499999998, 30.560667999999996],
                  [-87.42280499999998, 30.561378999999995],
                  [-87.44658599999997, 30.527067999999993],
                  [-87.42957799999996, 30.470595999999997],
                  [-87.41467699999998, 30.457295999999996],
                  [-87.44182299999999, 30.37630399999999],
                  [-87.45137799999998, 30.367198999999992],
                  [-87.504701, 30.324038999999996],
                  [-87.51832399999996, 30.28043499999999],
                  [-87.29542199999999, 30.323503000000006],
                  [-87.15539199999998, 30.327747999999993],
                  [-86.90967899999998, 30.372422999999994],
                  [-86.75090599999999, 30.391880999999987],
                  [-86.63295299999999, 30.396298999999996],
                  [-86.41207599999997, 30.380346],
                  [-86.2987, 30.363048999999982],
                  [-86.08996299999997, 30.303568999999996],
                  [-85.87813799999996, 30.215618999999997],
                  [-85.77540499999998, 30.156290000000006],
                  [-85.69680999999999, 30.096889999999977],
                  [-85.58824199999997, 30.055542999999993],
                  [-85.54117599999996, 29.99579099999999],
                  [-85.48776399999998, 29.961226999999997],
                  [-85.40505199999997, 29.93848699999999],
                  [-85.36373099999999, 29.898914999999995],
                  [-85.30133099999998, 29.797116999999997],
                  [-85.31138987741838, 29.697557490644094],
                  [-85.25971854973078, 29.68129560023349],
                  [-85.10168199999997, 29.718747999999994],
                  [-84.99326399999998, 29.714960999999995],
                  [-84.94013115373589, 29.761438315112958],
                  [-84.91510999999998, 29.783302999999993],
                  [-84.82419699999997, 29.758287999999993],
                  [-84.69205299999997, 29.82905899999999],
                  [-84.66972799999998, 29.828909999999993],
                  [-84.53587299999998, 29.91009199999999],
                  [-84.45170499999996, 29.92908499999999],
                  [-84.37893699999998, 29.893111999999995],
                  [-84.33374599999996, 29.92372099999999],
                  [-84.36196199999998, 29.98773899999999],
                  [-84.35892301390608, 30.05822424250839],
                  [-84.27716799999999, 30.060262999999992],
                  [-84.26936317251338, 30.09766039412279],
                  [-84.15727799999998, 30.072713999999994],
                  [-84.02427399999998, 30.103270999999992],
                  [-83.84542699999997, 29.998067999999993],
                  [-83.68642299999996, 29.923734999999983],
                  [-83.63797999999998, 29.886072999999993],
                  [-83.58608886430567, 29.784643883858596],
                  [-83.53764499999997, 29.723059999999997],
                  [-83.41276823348649, 29.66848531537349],
                  [-83.40025219569668, 29.517241948824704],
                  [-83.31154599999996, 29.475665999999993],
                  [-83.29474714550837, 29.43792347774239],
                  [-83.21807499999997, 29.42049199999999],
                  [-83.17551799999998, 29.344689999999996],
                  [-83.16957599999998, 29.290354999999995],
                  [-83.089013, 29.26650199999999],
                  [-83.08783899999997, 29.216419999999992],
                  [-83.03045295115568, 29.13402287958599],
                  [-82.99614399999997, 29.17807399999999],
                  [-82.82707299999998, 29.158424999999994],
                  [-82.7597039200126, 29.0541923354963],
                  [-82.76055099999998, 28.993086999999996],
                  [-82.68886399999998, 28.905608999999995],
                  [-82.73024538510919, 28.85015464793119],
                  [-82.69828058419068, 28.75700990546968],
                  [-82.71237259319777, 28.7209206141101],
                  [-82.66872173602948, 28.69565811015849],
                  [-82.65413799999997, 28.590836999999993],
                  [-82.67011647801748, 28.47566791083694],
                  [-82.67478699999998, 28.441955999999994],
                  [-82.76264299999998, 28.219012999999993],
                  [-82.80847399999996, 28.15480299999999],
                  [-82.78132399999997, 28.127591],
                  [-82.78272399999997, 28.05589399999999],
                  [-82.80546180066278, 27.96020123722479],
                  [-82.85112599999998, 27.88629999999999],
                  [-82.82856099999998, 27.82225399999999],
                  [-82.71362899999997, 27.698660999999994],
                  [-82.63361999999998, 27.710607],
                  [-82.62272299999997, 27.779867999999997],
                  [-82.58651899999997, 27.816702999999993],
                  [-82.62806299999998, 27.910396999999993],
                  [-82.72412199999998, 27.948097999999984],
                  [-82.67860647056729, 27.993715093564692],
                  [-82.62958957384718, 27.998474015576292],
                  [-82.55391799999998, 27.966997999999997],
                  [-82.52991799999998, 27.87750099999999],
                  [-82.55394599999998, 27.84846199999999],
                  [-82.47243999999996, 27.82255899999999],
                  [-82.48981699999997, 27.919599999999996],
                  [-82.41391499999999, 27.90140099999999],
                  [-82.39338299999999, 27.83751899999999],
                  [-82.43463499999999, 27.76435499999999],
                  [-82.47833899999998, 27.74625],
                  [-82.58462899999998, 27.596021000000004],
                  [-82.68642099999997, 27.49721499999999],
                  [-82.69100399999998, 27.44433099999999],
                  [-82.56924799999999, 27.29858799999999],
                  [-82.47701899999998, 27.14123099999999],
                  [-82.44571799999999, 27.060634],
                  [-82.26949899999998, 26.784673999999992],
                  [-82.17869048865667, 26.77255457162149],
                  [-82.14706825063426, 26.789803067113994],
                  [-82.17524079847159, 26.916867034418292],
                  [-82.07634939014638, 26.958263428056995],
                  [-82.09072313267619, 26.88869448658099],
                  [-82.05910087237028, 26.876620515224293],
                  [-82.06657523452999, 26.74265716754989],
                  [-82.12579508316716, 26.699535912105894],
                  [-82.18156524161937, 26.681712462678295],
                  [-82.13786903224027, 26.6374413272186],
                  [-82.10567183471198, 26.483929668311394],
                  [-82.04357723311209, 26.51957657830829],
                  [-81.91170999999999, 26.427158],
                  [-81.86898299999997, 26.37864799999999],
                  [-81.83314199999997, 26.294518],
                  [-81.80166299999996, 26.088226999999993],
                  [-81.749724, 25.960462999999987],
                  [-81.68953999999998, 25.852709999999984],
                  [-81.64455346782107, 25.897952740545797],
                  [-81.54118295143026, 25.900338222475995],
                  [-81.42429475289728, 25.867736754233295],
                  [-81.34915236486967, 25.816846647692696],
                  [-81.36187488380028, 25.77271538607539],
                  [-81.24067699999998, 25.613628999999985],
                  [-81.20820099999997, 25.504936999999998],
                  [-81.16865199999997, 25.463847999999995],
                  [-81.11726499999999, 25.35495299999999],
                  [-81.15191599999997, 25.324765999999993],
                  [-81.17204399999999, 25.22227599999999],
                  [-81.14102399999999, 25.163867999999994],
                  [-81.07985899999997, 25.11879699999999],
                  [-80.90057699999998, 25.139668999999987],
                  [-80.84639499999999, 25.177059999999997],
                  [-80.77749915510188, 25.135047008099296],
                  [-80.669235592219, 25.13783658938719],
                  [-80.56912351609019, 25.19011734025439],
                  [-80.49534099999997, 25.19946299999999],
                  [-80.41887227693158, 25.235532114443192],
                  [-80.37411637447359, 25.31735048898259],
                  [-80.33526940938839, 25.338701493888895],
                  [-80.32578009239128, 25.39800981993969],
                  [-80.33942099203958, 25.49942705984279],
                  [-80.30205674817918, 25.5676316615228],
                  [-80.24452766116367, 25.717088671444092],
                  [-80.19767407731977, 25.744370493726993],
                  [-80.16446141611048, 25.7218333241961],
                  [-80.12798678889448, 25.772245409097096],
                  [-80.11968362359218, 25.841043092371194],
                  [-80.10956599999999, 26.08716499999999],
                  [-80.07986499999997, 26.26435799999999],
                  [-80.06056399999999, 26.44465199999999],
                  [-80.03886299999998, 26.569346999999997],
                  [-80.03136199999999, 26.796338999999993],
                  [-80.09390899999998, 27.018586999999993],
                  [-80.159554, 27.163324999999997],
                  [-80.16146999999998, 27.192813999999984],
                  [-80.25366499999997, 27.37979],
                  [-80.29317099999999, 27.500313999999992],
                  [-80.38369499999999, 27.74004499999999],
                  [-80.50887099999998, 27.970477],
                  [-80.56643199999996, 28.095629999999993],
                  [-80.60421399999997, 28.257733],
                  [-80.60349644839278, 28.348507953689293],
                  [-80.60337399999999, 28.36398299999999],
                  [-80.58781299999998, 28.410856],
                  [-80.52509399999997, 28.45945399999999],
                  [-80.57486799999998, 28.58516599999999],
                  [-80.70972499999998, 28.756691999999983],
                  [-80.96617599999998, 29.147959999999994],
                  [-81.16358099999997, 29.555289999999996],
                  [-81.25671099999997, 29.784692999999994],
                  [-81.27654, 29.90046],
                  [-81.30897799999998, 29.969439999999988],
                  [-81.385505, 30.27384099999999],
                  [-81.41080899999999, 30.482038999999997],
                  [-81.43406399999998, 30.52256899999999],
                  [-81.44309899999996, 30.600937999999992],
                  [-81.42741999999998, 30.698019999999993],
                  [-81.44412399999999, 30.709713999999995],
                  [-81.54092267808036, 30.713343053029792],
                  [-81.69477799999997, 30.748413999999983],
                  [-81.80852899999998, 30.790014000000003],
                  [-81.86860799999998, 30.79275399999999],
                  [-81.94978699999999, 30.82749299999999],
                  [-81.97906099999999, 30.776414999999993],
                  [-82.03963444757508, 30.747727351635195],
                  [-82.04950699999998, 30.655547999999992],
                  [-82.01210899999997, 30.593772999999995],
                  [-82.01777912816777, 30.475081213622396],
                  [-82.04791699999998, 30.363264999999984],
                  [-82.17005399999998, 30.358928999999996],
                  [-82.21029099999997, 30.42458999999999],
                  [-82.21285199999998, 30.49875099999999],
                  [-82.21851399999998, 30.50418699999999],
                  [-82.2185794923239, 30.56440252986949],
                  [-82.214385, 30.56695799999999],
                  [-82.21483899999998, 30.568590999999987],
                  [-82.24984099999998, 30.570862999999992],
                  [-83.13136999999998, 30.623582999999993],
                  [-83.49987599999999, 30.645670999999997],
                  [-84.05722799999997, 30.674704999999992],
                  [-84.864693, 30.711542],
                  [-84.91432199999998, 30.75359099999999],
                  [-84.93997404263598, 30.88672788993959],
                  [-84.94013115373588, 30.886839548724694],
                  [-84.94132499999998, 30.887687999999994],
                  [-84.98362699999997, 30.936985999999994],
                  [-85.00236799999998, 31.000681999999994],
                  [-85.89354299999997, 30.993466999999995],
                  [-86.38864600043148, 30.994181020768195],
                  [-86.39193699999997, 30.994171999999995],
                  [-86.51283399999997, 30.993699999999993],
                  [-86.56343599999997, 30.995222999999992],
                  [-86.72839199999999, 30.996738999999994],
                  [-86.785692460564, 30.99697418537949],
                  [-87.06863299999998, 30.999142999999993],
                  [-87.12496899999996, 30.998801999999994],
                  [-87.30402999999997, 30.99819099999999],
                  [-87.33397299999997, 30.998271999999993],
                  [-87.51951999999997, 30.99758599999999],
                  [-87.53958546140831, 30.997822447855157]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US12",
            STATE: "12",
            NAME: "Florida",
            CENSUSAREA: 53624.759,
            gx_id: "10",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-155.85329299999998, 20.271547999999992],
                  [-155.90145199999998, 20.235786999999995],
                  [-155.89914899999997, 20.145727999999995],
                  [-155.82818199999994, 20.03542399999999],
                  [-155.85658799999996, 19.968884999999997],
                  [-155.94031099999995, 19.85230499999999],
                  [-155.98282099999997, 19.845650999999997],
                  [-156.04965099999995, 19.780451999999997],
                  [-156.06436399999998, 19.730765999999992],
                  [-155.99772799999994, 19.642815999999993],
                  [-155.97096899999997, 19.586327999999998],
                  [-155.95289699999995, 19.488804999999996],
                  [-155.92260899999997, 19.478610999999994],
                  [-155.88735599999998, 19.337100999999993],
                  [-155.921389, 19.121182999999995],
                  [-155.88154999999995, 19.036643999999995],
                  [-155.80610899999994, 19.01396699999999],
                  [-155.72604299999998, 18.969436999999996],
                  [-155.67200534705998, 18.917466137221798],
                  [-155.59652099999997, 18.980653999999987],
                  [-155.55737099999996, 19.046564999999994],
                  [-155.557817, 19.082129999999996],
                  [-155.50528099999994, 19.137907999999992],
                  [-155.45351599999998, 19.151951999999998],
                  [-155.36063099999996, 19.208929999999995],
                  [-155.29676099999998, 19.266288999999997],
                  [-155.20589199999998, 19.26090699999999],
                  [-155.13369999999998, 19.27609899999999],
                  [-154.98086099999995, 19.349290999999997],
                  [-154.82296799999995, 19.481289999999994],
                  [-154.81441699999996, 19.530089999999984],
                  [-154.90354199999996, 19.570622000000004],
                  [-154.98377799999997, 19.641646999999995],
                  [-154.98110199999994, 19.690686999999993],
                  [-155.00642299999996, 19.739285999999996],
                  [-155.09338699999998, 19.737750999999992],
                  [-155.08435699999998, 19.849735999999996],
                  [-155.14439399999998, 19.920522999999985],
                  [-155.27031599999995, 20.014524999999995],
                  [-155.40545899999998, 20.078772],
                  [-155.55893299999997, 20.13156999999999],
                  [-155.58167999999998, 20.123616999999992],
                  [-155.73270399999998, 20.205391999999996],
                  [-155.77823399999994, 20.24574299999999],
                  [-155.85329299999998, 20.271547999999992]
                ]
              ],
              [
                [
                  [-160.23102799999992, 21.886263000000003],
                  [-160.24960999999996, 21.815144999999994],
                  [-160.205211, 21.78905299999999],
                  [-160.16161999999997, 21.86474599999999],
                  [-160.07906499999996, 21.89607999999999],
                  [-160.05854299999993, 21.99637999999999],
                  [-160.11274599999993, 21.995244999999997],
                  [-160.12499999999997, 21.959089999999993],
                  [-160.23102799999992, 21.886263000000003]
                ]
              ],
              [
                [
                  [-159.50105499999995, 22.211063999999997],
                  [-159.58396499999995, 22.226679999999995],
                  [-159.73345699999996, 22.14275599999999],
                  [-159.78654299999997, 22.06368999999999],
                  [-159.78813899999997, 22.018410999999993],
                  [-159.75821799999997, 21.980693999999993],
                  [-159.67187199999998, 21.957037999999994],
                  [-159.61024099999997, 21.898355999999993],
                  [-159.49091399999998, 21.888897999999983],
                  [-159.44659899999996, 21.871646999999992],
                  [-159.33471399999996, 21.96109899999999],
                  [-159.33799599999998, 22.046574999999994],
                  [-159.29714299999998, 22.113815],
                  [-159.31561299999996, 22.186816999999998],
                  [-159.35379499999996, 22.217668999999997],
                  [-159.43170699999996, 22.22001499999999],
                  [-159.50105499999995, 22.211063999999997]
                ]
              ],
              [
                [
                  [-157.15710299999998, 21.20070599999999],
                  [-157.24153399999997, 21.220968999999997],
                  [-157.31334299999995, 21.105754999999995],
                  [-157.25406099999998, 21.090600999999992],
                  [-157.07969599999998, 21.105834999999995],
                  [-156.87713699999998, 21.0493],
                  [-156.79413599999995, 21.075795999999997],
                  [-156.71415799999997, 21.152237999999997],
                  [-156.77149499999996, 21.180052999999994],
                  [-156.86794399999997, 21.16452],
                  [-156.94615899999994, 21.175962999999996],
                  [-156.96284699999998, 21.212131000000003],
                  [-157.01455260475097, 21.185503436607497],
                  [-157.15710299999998, 21.20070599999999]
                ]
              ],
              [
                [
                  [-156.54303357599196, 20.58011481916479],
                  [-156.57687099999993, 20.606569999999987],
                  [-156.68009999999998, 20.55702099999999],
                  [-156.66880899999998, 20.504738],
                  [-156.60384399999995, 20.524371999999996],
                  [-156.54416899999995, 20.522801999999988],
                  [-156.54303357599196, 20.58011481916479]
                ]
              ],
              [
                [
                  [-156.67863399999996, 20.870540999999992],
                  [-156.63179399999999, 20.821239999999996],
                  [-156.53775199999998, 20.77840799999999],
                  [-156.46404299999995, 20.781666999999995],
                  [-156.44288399999996, 20.613841999999995],
                  [-156.37763299999995, 20.578426999999998],
                  [-156.30269199999998, 20.586198999999993],
                  [-156.21025799999995, 20.628517999999996],
                  [-156.14266499999994, 20.623605],
                  [-156.05338499999996, 20.654319999999995],
                  [-155.987216, 20.722716999999992],
                  [-156.00353199999998, 20.795545],
                  [-156.11573499999997, 20.827300999999984],
                  [-156.15325807864735, 20.86163841739671],
                  [-156.230159, 20.931935999999997],
                  [-156.32457799999997, 20.95018399999999],
                  [-156.44752642948757, 20.90465897732466],
                  [-156.47479599999997, 20.894545999999995],
                  [-156.4848328444215, 20.910075271903704],
                  [-156.54629099999997, 21.00508199999999],
                  [-156.59225599999996, 21.03288],
                  [-156.66551399999994, 21.007053999999993],
                  [-156.69628922959143, 20.940614912672267],
                  [-156.67863399999996, 20.870540999999992]
                ]
              ],
              [
                [
                  [-157.06251099999997, 20.904384999999994],
                  [-157.01091099999996, 20.854476000000002],
                  [-156.96788999999998, 20.73507999999999],
                  [-156.83832099999998, 20.764574999999997],
                  [-156.809463, 20.809168999999997],
                  [-156.83704699999996, 20.863574999999994],
                  [-156.89716899999996, 20.915394999999997],
                  [-157.01000099999993, 20.929756999999995],
                  [-157.06251099999997, 20.904384999999994]
                ]
              ],
              [
                [
                  [-157.96797099999998, 21.327986000000003],
                  [-157.89, 21.30649999999999],
                  [-157.82109999999997, 21.260599999999993],
                  [-157.6537, 21.301999999999992],
                  [-157.70879999999997, 21.353399999999997],
                  [-157.70889999999997, 21.383299999999995],
                  [-157.77490473207195, 21.4536982399511],
                  [-157.84098999999995, 21.45948299999999],
                  [-157.83694499999996, 21.529944999999994],
                  [-157.9238, 21.629299999999997],
                  [-157.96862799999994, 21.712703999999995],
                  [-158.01812699999996, 21.699954999999992],
                  [-158.12561, 21.586738999999994],
                  [-158.25442499999994, 21.582683999999997],
                  [-158.23299999999998, 21.4876],
                  [-158.17919999999995, 21.4043],
                  [-158.14029999999997, 21.3738],
                  [-158.1127, 21.301899999999996],
                  [-158.04448531580195, 21.306010880628197],
                  [-157.96797099999998, 21.327986000000003]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US15",
            STATE: "15",
            NAME: "Hawaii",
            CENSUSAREA: 6422.628,
            gx_id: "12",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-88.11528499999997, 42.496218999999975],
                [-88.78668099999999, 42.491983],
                [-89.25075899999999, 42.497993999999984],
                [-90, 42.507594654439046],
                [-90.07366999999996, 42.508275],
                [-90.64092699999996, 42.50830199999998],
                [-90.65402699999999, 42.47850299999998],
                [-90.47727899999998, 42.38379399999998],
                [-90.41593699999999, 42.322698999999986],
                [-90.43088399999998, 42.27822999999999],
                [-90.39110799999999, 42.225472999999994],
                [-90.20947899999997, 42.15267999999999],
                [-90.16289499999998, 42.11671799999999],
                [-90.16448499999998, 42.042105],
                [-90.14006099999997, 42.00325199999999],
                [-90.15358399999998, 41.90661399999999],
                [-90.18796899999998, 41.80316299999999],
                [-90.27863299999997, 41.767357999999994],
                [-90.31521999999997, 41.734263999999996],
                [-90.34345199999998, 41.64695899999999],
                [-90.34322799999997, 41.58783299999998],
                [-90.41282999999999, 41.56533299999999],
                [-90.46143199999999, 41.52353299999999],
                [-90.59523699999997, 41.51103199999999],
                [-90.655839, 41.46213199999999],
                [-90.73753699999996, 41.450127],
                [-90.85755399999996, 41.452750999999985],
                [-90.93001599999997, 41.42140399999999],
                [-90.97516799999997, 41.43398499999999],
                [-91.04781899999996, 41.41089999999999],
                [-91.07750499999997, 41.30182799999999],
                [-91.113648, 41.241401],
                [-91.04153599999997, 41.16613799999999],
                [-90.98966299999996, 41.155715999999984],
                [-90.94662699999998, 41.09663199999998],
                [-90.94225299999997, 41.03470199999999],
                [-90.96291599999998, 40.92495699999999],
                [-90.99849999999999, 40.90811999999998],
                [-91.09684599999999, 40.81161699999999],
                [-91.09170299999998, 40.779707999999985],
                [-91.12392799999996, 40.669151999999976],
                [-91.18697999999998, 40.63729699999998],
                [-91.24785099999998, 40.63838999999999],
                [-91.34873299999997, 40.60969499999999],
                [-91.40620199999998, 40.542697999999994],
                [-91.36905899999998, 40.512531999999986],
                [-91.37574599999996, 40.39187899999998],
                [-91.41942199999998, 40.37826399999999],
                [-91.46213999999996, 40.34241399999999],
                [-91.50650099999997, 40.23630399999999],
                [-91.510322, 40.12799399999999],
                [-91.49487799999997, 40.036452999999995],
                [-91.45885199999998, 39.97901499999999],
                [-91.45510012824859, 39.97213680807589],
                [-91.45464699999998, 39.97130599999999],
                [-91.42183199999997, 39.93297299999999],
                [-91.44784399999996, 39.87795099999999],
                [-91.42951899999998, 39.837800999999985],
                [-91.36174399999999, 39.78507899999998],
                [-91.37000899999998, 39.73252399999998],
                [-91.24122499999997, 39.63006699999998],
                [-91.18592099999996, 39.60511899999999],
                [-91.14827499999998, 39.545797999999984],
                [-91.10030699999997, 39.53869499999998],
                [-91.05943899999998, 39.46885999999999],
                [-90.99378899999998, 39.422958999999985],
                [-90.84010599999999, 39.340437999999985],
                [-90.726981, 39.251173],
                [-90.682744, 39.088348],
                [-90.71254099999999, 39.05706399999999],
                [-90.66139999999997, 38.92498899999999],
                [-90.58338799999999, 38.869029999999974],
                [-90.54402999999999, 38.87504999999999],
                [-90.45079199999999, 38.96776399999998],
                [-90.30945399999999, 38.924119999999995],
                [-90.25024799999997, 38.91934399999999],
                [-90.11332699999998, 38.84930599999999],
                [-90.12310699999996, 38.798047999999994],
                [-90.21200999999998, 38.71174999999998],
                [-90.18260999999998, 38.66534999999999],
                [-90.19181099999997, 38.59895099999999],
                [-90.26031399999997, 38.52835199999999],
                [-90.29531599999997, 38.42675299999999],
                [-90.34974299999998, 38.37760899999999],
                [-90.37392899999996, 38.281852999999984],
                [-90.35390199999996, 38.21385499999999],
                [-90.27492799999997, 38.15761499999999],
                [-90.24311599999999, 38.11266899999998],
                [-90.13078799999998, 38.06234099999999],
                [-90.00835299999997, 37.97017899999999],
                [-90, 37.95771469875571],
                [-89.97422099999997, 37.91921699999999],
                [-89.90183199999997, 37.869822000000006],
                [-89.84478599999998, 37.90557199999999],
                [-89.79608699999997, 37.85950499999999],
                [-89.73987299999999, 37.84692999999999],
                [-89.58331599999997, 37.71326099999999],
                [-89.51200899999998, 37.68552499999999],
                [-89.51644699999999, 37.535557999999995],
                [-89.42246499999997, 37.397131999999985],
                [-89.43603999999996, 37.34444099999999],
                [-89.51460499999999, 37.299322999999994],
                [-89.51574099999998, 37.29536199999998],
                [-89.41447099999996, 37.125049999999995],
                [-89.375615, 37.08593599999998],
                [-89.37827699999997, 37.03960500000001],
                [-89.29212999999999, 36.99218899999999],
                [-89.19848799999998, 37.01172299999998],
                [-89.13268499999998, 36.98219999999999],
                [-89.18250899999998, 37.03727500000001],
                [-89.15450399999997, 37.088907000000006],
                [-89.02998099999998, 37.21114399999998],
                [-88.91693399999998, 37.224290999999994],
                [-88.80571999999998, 37.18859499999999],
                [-88.73210499999998, 37.14395599999999],
                [-88.630605, 37.121002999999995],
                [-88.54540299999996, 37.07000299999999],
                [-88.45894799999998, 37.07379599999999],
                [-88.42440299999998, 37.15242799999999],
                [-88.44776399999998, 37.203527],
                [-88.51593899999997, 37.28404299999999],
                [-88.51466099999996, 37.29094799999999],
                [-88.476592, 37.38687499999999],
                [-88.40880799999996, 37.42521599999999],
                [-88.36155699999996, 37.40293099999999],
                [-88.28166699999998, 37.452596],
                [-88.08766399999998, 37.47105899999999],
                [-88.06901799999999, 37.52529699999998],
                [-88.13339299999997, 37.574234999999994],
                [-88.15820699999999, 37.66454199999999],
                [-88.12503299999999, 37.707094],
                [-88.063802, 37.738644999999984],
                [-88.02802999999999, 37.79922399999997],
                [-88.05849937121748, 37.86534899605099],
                [-88.01292899999997, 37.96654399999998],
                [-88.02978979013868, 38.025045983210795],
                [-87.98493108382918, 38.0690075265212],
                [-87.92885769659567, 38.168593871218874],
                [-87.98423399999997, 38.20995999999999],
                [-87.74525399999997, 38.40899599999999],
                [-87.73952231391027, 38.475068996610595],
                [-87.65416629451647, 38.51191070006829],
                [-87.66073213726838, 38.54109223833309],
                [-87.62011999999997, 38.63948899999999],
                [-87.51960899999999, 38.69719799999999],
                [-87.49653699999996, 38.778570999999985],
                [-87.55051499999996, 38.85955999999999],
                [-87.51218699999998, 38.954416999999985],
                [-87.57831899999996, 38.98878599999999],
                [-87.572588, 39.05728599999999],
                [-87.6322494615944, 39.106802856534784],
                [-87.64043499999997, 39.166726999999995],
                [-87.57455799999997, 39.218403999999985],
                [-87.61004999999999, 39.28223199999999],
                [-87.58908399999999, 39.333830999999996],
                [-87.53164599999997, 39.34788799999998],
                [-87.53322699999998, 39.883127],
                [-87.53285813507851, 39.95507657559064],
                [-87.53277599999997, 39.971076999999994],
                [-87.52680899999999, 40.46216999999999],
                [-87.52671099999999, 41.121484999999986],
                [-87.52404399999996, 41.708335],
                [-87.60054899999999, 41.82683299999999],
                [-87.61165850420026, 41.890707804497595],
                [-87.68235899999998, 42.07572899999999],
                [-87.74166199999998, 42.12822699999998],
                [-87.80006599999999, 42.20802399999998],
                [-87.83476899999998, 42.301521999999984],
                [-87.80536999999997, 42.38472099999999],
                [-87.80047699999997, 42.491919999999986],
                [-88.11528499999997, 42.496218999999975]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US17",
            STATE: "17",
            NAME: "Illinois",
            CENSUSAREA: 55518.93,
            gx_id: "14",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-95.11487399999997, 43.500666999999986],
                [-95.74081299999999, 43.49989399999999],
                [-96.35105899999996, 43.50033299999998],
                [-96.40773576934623, 43.5003897587424],
                [-96.45304899999998, 43.500414999999975],
                [-96.598928, 43.50045699999999],
                [-96.59425399999999, 43.434153],
                [-96.52404399999996, 43.394761999999986],
                [-96.52556399999997, 43.31246699999999],
                [-96.58034640018266, 43.29820358919529],
                [-96.55493699999997, 43.22677499999999],
                [-96.48526399999999, 43.22418299999999],
                [-96.43933499999997, 43.11391599999999],
                [-96.51099499999997, 43.02470099999999],
                [-96.54109799999996, 42.92449599999999],
                [-96.52773999999997, 42.89058799999999],
                [-96.63970399999997, 42.73707099999999],
                [-96.51633799999996, 42.630434999999984],
                [-96.44340799999998, 42.489494999999984],
                [-96.40940799999997, 42.48759499999998],
                [-96.40773576934623, 42.487155078429915],
                [-96.39610699999997, 42.48409499999998],
                [-96.38760799999999, 42.43249399999999],
                [-96.40773576934623, 42.41453011604515],
                [-96.41180799999997, 42.41089399999999],
                [-96.40979146480583, 42.372021185411256],
                [-96.40799799999996, 42.33740799999999],
                [-96.36996899999998, 42.31087799999998],
                [-96.32372299999997, 42.22988699999999],
                [-96.34775199999999, 42.166805999999994],
                [-96.26731799999996, 42.11026499999999],
                [-96.27142699999996, 42.04498799999998],
                [-96.12950499999998, 41.97167299999999],
                [-96.16175599999997, 41.90182],
                [-96.06966199999997, 41.803508999999984],
                [-96.11775099999997, 41.69422099999999],
                [-96.09504599999997, 41.64736499999998],
                [-96.10938699999997, 41.596870999999986],
                [-96.08971399999999, 41.53177799999998],
                [-96.00470799999998, 41.47234199999998],
                [-95.93292099999998, 41.46379799999998],
                [-95.91139099999997, 41.23799799999998],
                [-95.86478899999999, 41.18829799999998],
                [-95.882088, 41.14399799999999],
                [-95.86258699999996, 41.08839899999998],
                [-95.86349199999997, 40.99734],
                [-95.81208299999997, 40.884238999999994],
                [-95.84778499999997, 40.864327999999986],
                [-95.83690299999999, 40.77647699999999],
                [-95.88890699999997, 40.73185499999999],
                [-95.84280099999998, 40.67749599999999],
                [-95.78948499999997, 40.65938799999999],
                [-95.76564499999996, 40.585207999999994],
                [-95.05986884626412, 40.57673828350463],
                [-94.99166099999998, 40.575692],
                [-94.48927999999997, 40.57070699999999],
                [-94.03413399999998, 40.57358500000001],
                [-93.26061199999997, 40.58079699999998],
                [-92.75740699999999, 40.588907999999975],
                [-92.09638699999998, 40.60183000000001],
                [-91.72911499999996, 40.61363999999999],
                [-91.681714, 40.55303499999999],
                [-91.62516099999996, 40.54349999999999],
                [-91.61694799999997, 40.50479399999999],
                [-91.48025099999997, 40.381782999999984],
                [-91.41942199999998, 40.37826399999999],
                [-91.37574599999996, 40.39187899999998],
                [-91.36905899999998, 40.512531999999986],
                [-91.40620199999998, 40.542697999999994],
                [-91.34873299999997, 40.60969499999999],
                [-91.24785099999998, 40.63838999999999],
                [-91.18697999999998, 40.63729699999998],
                [-91.12392799999996, 40.669151999999976],
                [-91.09170299999998, 40.779707999999985],
                [-91.09684599999999, 40.81161699999999],
                [-90.99849999999999, 40.90811999999998],
                [-90.96291599999998, 40.92495699999999],
                [-90.94225299999997, 41.03470199999999],
                [-90.94662699999998, 41.09663199999998],
                [-90.98966299999996, 41.155715999999984],
                [-91.04153599999997, 41.16613799999999],
                [-91.113648, 41.241401],
                [-91.07750499999997, 41.30182799999999],
                [-91.04781899999996, 41.41089999999999],
                [-90.97516799999997, 41.43398499999999],
                [-90.93001599999997, 41.42140399999999],
                [-90.85755399999996, 41.452750999999985],
                [-90.73753699999996, 41.450127],
                [-90.655839, 41.46213199999999],
                [-90.59523699999997, 41.51103199999999],
                [-90.46143199999999, 41.52353299999999],
                [-90.41282999999999, 41.56533299999999],
                [-90.34322799999997, 41.58783299999998],
                [-90.34345199999998, 41.64695899999999],
                [-90.31521999999997, 41.734263999999996],
                [-90.27863299999997, 41.767357999999994],
                [-90.18796899999998, 41.80316299999999],
                [-90.15358399999998, 41.90661399999999],
                [-90.14006099999997, 42.00325199999999],
                [-90.16448499999998, 42.042105],
                [-90.16289499999998, 42.11671799999999],
                [-90.20947899999997, 42.15267999999999],
                [-90.39110799999999, 42.225472999999994],
                [-90.43088399999998, 42.27822999999999],
                [-90.41593699999999, 42.322698999999986],
                [-90.47727899999998, 42.38379399999998],
                [-90.65402699999999, 42.47850299999998],
                [-90.64092699999996, 42.50830199999998],
                [-90.64562699999998, 42.54409999999999],
                [-90.72020899999997, 42.640758],
                [-90.95241499999997, 42.68677799999999],
                [-91.05127499999996, 42.73700099999999],
                [-91.10056499999996, 42.88307799999999],
                [-91.14617699999998, 42.90984999999999],
                [-91.17469199999996, 43.03871299999999],
                [-91.17793199999998, 43.12887499999998],
                [-91.05790999999996, 43.253968],
                [-91.12912099999998, 43.326349999999984],
                [-91.20184699999997, 43.34910299999999],
                [-91.19766999999997, 43.39533399999999],
                [-91.23224099999999, 43.460017999999984],
                [-91.21770599999998, 43.50054999999999],
                [-91.94987899999998, 43.500485],
                [-92.79031699999997, 43.499566999999985],
                [-93.2718, 43.499355999999985],
                [-93.79579299999996, 43.499519999999976],
                [-94.47041999999998, 43.50033999999999],
                [-95.054289, 43.50085999999998],
                [-95.05986884626412, 43.50084356221112],
                [-95.11487399999997, 43.500666999999986]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US19",
            STATE: "19",
            NAME: "Iowa",
            CENSUSAREA: 55857.13,
            gx_id: "16",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-89.52450399999996, 30.180752999999992],
                [-89.57015399999997, 30.180296999999996],
                [-89.61705599999998, 30.22749499999999],
                [-89.641705, 30.303798999999994],
                [-89.62972699999997, 30.339286999999995],
                [-89.68368599999998, 30.405872999999996],
                [-89.68340999999997, 30.45179299999999],
                [-89.76813299999999, 30.515019999999993],
                [-89.81969599999996, 30.59678499999999],
                [-89.84720099999997, 30.67003799999999],
                [-89.83153699999997, 30.76760999999999],
                [-89.77201099999996, 30.890239999999995],
                [-89.77326529763931, 30.895626555300687],
                [-89.77355299999996, 30.896861999999995],
                [-89.72769799999996, 30.993329000000003],
                [-89.75264210585999, 31.00185300016108],
                [-90, 31.00143524458905],
                [-90.38053599999998, 30.999871999999996],
                [-91.06021295225278, 30.998952963604392],
                [-91.62511799999997, 30.999167000000007],
                [-91.56439699999997, 31.038965000000008],
                [-91.56764799999996, 31.070185999999993],
                [-91.62599399999998, 31.11689599999999],
                [-91.59005099999997, 31.19369299999999],
                [-91.64435599999999, 31.23441399999999],
                [-91.63767199999997, 31.267679999999995],
                [-91.51857799999998, 31.275282999999995],
                [-91.51597799999998, 31.370285999999986],
                [-91.47206540821477, 31.395925139338893],
                [-91.51336599999999, 31.444395999999994],
                [-91.51580999999999, 31.530893999999996],
                [-91.45001699999997, 31.539665999999993],
                [-91.48521799999997, 31.586165999999988],
                [-91.49766499999997, 31.645370999999987],
                [-91.42111599999997, 31.61156499999999],
                [-91.39571499999997, 31.64416499999999],
                [-91.39711499999999, 31.711363999999993],
                [-91.36503422812608, 31.748184189803695],
                [-91.338414, 31.85126099999999],
                [-91.22695099999999, 31.885104999999996],
                [-91.20880999999999, 31.90045899999999],
                [-91.18830999999997, 31.960958],
                [-91.11740899999998, 31.987056999999993],
                [-91.05317499999997, 32.124236999999994],
                [-91.16282199999996, 32.132693999999994],
                [-91.16417099999997, 32.196888],
                [-91.04650699999996, 32.24114899999999],
                [-90.99429318049587, 32.213768079146796],
                [-90.98298499999997, 32.27029399999999],
                [-90.91615699999998, 32.30358199999999],
                [-90.91236299999997, 32.33945399999999],
                [-91.00450599999998, 32.368143999999994],
                [-90.96645699999996, 32.43386799999999],
                [-91.02960599999999, 32.43354199999999],
                [-91.09530799999999, 32.45874099999999],
                [-91.11670799999999, 32.500139],
                [-91.09374099999997, 32.54912799999998],
                [-91.15269899999998, 32.640756999999994],
                [-91.06394599999997, 32.70292599999999],
                [-91.06076599999997, 32.72749399999999],
                [-91.16532799999997, 32.751300999999984],
                [-91.14500199999996, 32.842869999999984],
                [-91.07060199999998, 32.88865899999999],
                [-91.08680199999998, 32.97626599999999],
                [-91.15997499999999, 32.89987899999999],
                [-91.21159699999998, 32.91962399999999],
                [-91.21283699999998, 32.92210399999999],
                [-91.21281999999997, 32.93607599999999],
                [-91.21070499999996, 32.93984499999999],
                [-91.16607299999997, 33.00410599999999],
                [-91.31201599999999, 33.005261999999995],
                [-91.32503699999998, 33.00536399999999],
                [-91.46040005144657, 33.00590956593519],
                [-91.50011799999999, 33.00678399999999],
                [-91.95000099999997, 33.00751999999999],
                [-92.06910499999998, 33.00816299999999],
                [-92.50377599999999, 33.01216099999999],
                [-93.15435099999998, 33.017855999999995],
                [-93.30818099999998, 33.01815599999999],
                [-93.48950599999996, 33.01844299999999],
                [-93.490893, 33.01844199999999],
                [-94.04296399999998, 33.01921899999999],
                [-94.04298599999998, 32.435506999999994],
                [-94.04271999999999, 31.999264999999987],
                [-93.97746099999996, 31.92641899999998],
                [-93.90955711494487, 31.89314361942949],
                [-93.87091699999996, 31.816836999999992],
                [-93.82259799999997, 31.77355899999999],
                [-93.80447899999999, 31.685664],
                [-93.83805699999996, 31.606794999999984],
                [-93.81858199999998, 31.554825999999995],
                [-93.72592458225976, 31.504091651519293],
                [-93.74947599999997, 31.46869],
                [-93.70092975112597, 31.437783629835998],
                [-93.6636981756018, 31.360018811902297],
                [-93.68785099999998, 31.309835000000007],
                [-93.62034299999998, 31.27102499999999],
                [-93.60030799999998, 31.176157999999994],
                [-93.54893099999997, 31.186600999999996],
                [-93.54664377229508, 31.082989189009094],
                [-93.5169426208219, 31.023661529978195],
                [-93.56797199999998, 30.977980999999993],
                [-93.52624499999997, 30.93941099999999],
                [-93.56778775233258, 30.888301832311893],
                [-93.554057, 30.824940999999992],
                [-93.58938099999996, 30.786680999999994],
                [-93.62109299999997, 30.695158999999993],
                [-93.68309999999998, 30.640762999999996],
                [-93.67982811797779, 30.599758343304998],
                [-93.72784399999998, 30.574069999999992],
                [-93.69782799999997, 30.443837999999992],
                [-93.75855399999996, 30.387076999999994],
                [-93.76582199999997, 30.33331799999999],
                [-93.71431943011598, 30.294282471059095],
                [-93.72094599999997, 30.209851999999998],
                [-93.69774799999996, 30.152943999999994],
                [-93.74107799999999, 30.021570999999994],
                [-93.78693499999997, 29.99057999999999],
                [-93.85513999999998, 29.864098999999992],
                [-93.92274399999997, 29.81880799999999],
                [-93.83797099999997, 29.69061899999999],
                [-93.74194799999998, 29.736342999999994],
                [-93.475252, 29.76924199999999],
                [-93.34210399999998, 29.763401999999992],
                [-93.22693399999999, 29.77751899999999],
                [-93.08818199999996, 29.749124999999996],
                [-92.97430499999999, 29.713979999999996],
                [-92.74412599999998, 29.61760799999999],
                [-92.65365099999997, 29.588064999999993],
                [-92.30935699999999, 29.533025999999996],
                [-92.25185968352449, 29.539354046748795],
                [-92.15862399999997, 29.581615999999997],
                [-92.04631599999996, 29.584361999999995],
                [-91.96931199999999, 29.536892999999992],
                [-91.86232399999997, 29.502392999999994],
                [-91.82157599999998, 29.47392499999999],
                [-91.71165399999997, 29.554269999999995],
                [-91.82169299999998, 29.606048999999985],
                [-91.84129399999996, 29.629619999999996],
                [-91.92282499999999, 29.633172999999992],
                [-91.93990299999999, 29.610290999999997],
                [-92.02531999999997, 29.62564699999999],
                [-92.11178699999996, 29.62176999999999],
                [-92.14934899999997, 29.697051999999996],
                [-92.10748599999997, 29.744428999999997],
                [-92.03566599999996, 29.781661999999994],
                [-91.88911799999997, 29.836022999999994],
                [-91.85467661713618, 29.807435580505803],
                [-91.88074999999999, 29.710838999999993],
                [-91.85863999999997, 29.703120999999992],
                [-91.73725299999997, 29.749369999999985],
                [-91.62151199999998, 29.735428999999993],
                [-91.62511399999997, 29.626194999999996],
                [-91.55353699999998, 29.63276600000001],
                [-91.51727369877206, 29.529739922432594],
                [-91.44734499999997, 29.544748999999992],
                [-91.40221399999999, 29.511913999999983],
                [-91.26564899999997, 29.472361999999993],
                [-91.22116599999997, 29.436420999999996],
                [-91.19746471115658, 29.369881713429393],
                [-91.26658899999997, 29.361217999999994],
                [-91.29182099999997, 29.311356999999994],
                [-91.27879199999998, 29.24777599999999],
                [-91.199647, 29.221286999999997],
                [-91.12914099999998, 29.21586299999999],
                [-91.09401499999998, 29.187710999999986],
                [-91.00009599999997, 29.169480999999994],
                [-90.96127799999996, 29.18081699999999],
                [-90.89821499999998, 29.131341999999982],
                [-90.84459299999997, 29.067279999999993],
                [-90.73123899999999, 29.122885999999983],
                [-90.64704199999998, 29.128579999999996],
                [-90.64561199999997, 29.17586699999999],
                [-90.56543599999998, 29.28511099999999],
                [-90.51055499999998, 29.29092499999999],
                [-90.45067399999996, 29.263738999999994],
                [-90.48578599999996, 29.209842999999992],
                [-90.39946499999998, 29.20104599999999],
                [-90.36716599999998, 29.274127999999997],
                [-90.33279599999999, 29.27695599999999],
                [-90.27125099999996, 29.204638999999993],
                [-90.30284599999997, 29.175098],
                [-90.23440499999998, 29.128823999999994],
                [-90.22358699999998, 29.08507499999999],
                [-90.10416199999997, 29.150406999999994],
                [-90.07062238682319, 29.20869820492049],
                [-90.09603844689586, 29.24067325562659],
                [-90.03427466995747, 29.322660551821496],
                [-90.03229751847798, 29.427004777139693],
                [-90, 29.456258424014667],
                [-89.99196105785568, 29.46353590627919],
                [-89.95542989921928, 29.42852690383339],
                [-89.84964181378648, 29.47799618361159],
                [-89.81691598663278, 29.3843851117284],
                [-89.85030499999998, 29.31176799999999],
                [-89.72616199999999, 29.304025999999993],
                [-89.60665099999999, 29.25202299999999],
                [-89.48284399999999, 29.21505299999999],
                [-89.40937099999996, 29.127854999999993],
                [-89.40565399999998, 29.086935999999994],
                [-89.33473499999998, 29.04033500000001],
                [-89.21720099999997, 29.067274999999988],
                [-89.16478819404838, 29.00870310488789],
                [-89.12154199999998, 29.06907399999999],
                [-89.06233499999996, 29.070233999999996],
                [-89.00067399999998, 29.18009099999999],
                [-89.02910299999998, 29.22095599999999],
                [-89.09072399999997, 29.19999199999999],
                [-89.10010599999998, 29.25021999999999],
                [-89.20059899999998, 29.347671999999992],
                [-89.24086999999997, 29.310080999999993],
                [-89.283028, 29.35646699999999],
                [-89.38000099999996, 29.391784999999995],
                [-89.50855099999998, 29.38616799999999],
                [-89.63532995833958, 29.489294382539978],
                [-89.69387665306398, 29.50855875337029],
                [-89.66864776611328, 29.580322265624996],
                [-89.62110900878906, 29.65710067749019],
                [-89.65123748779297, 29.749479293823185],
                [-89.53025817871087, 29.74374961853029],
                [-89.42420959472656, 29.697637557983395],
                [-89.42820739746088, 29.741550445556594],
                [-89.36328887939447, 29.845760345459],
                [-89.280143737793, 29.9249153137207],
                [-89.23117828369138, 29.925483703613295],
                [-89.21807098388666, 29.972749710082997],
                [-89.27331542968749, 29.993820190429695],
                [-89.31545257568358, 29.923208236694293],
                [-89.36801910400386, 29.911491394043],
                [-89.37922668457028, 29.963804244995096],
                [-89.4327850341797, 30.00802230834959],
                [-89.37237548828126, 30.036670684814492],
                [-89.48192596435547, 30.079128265380895],
                [-89.49406433105467, 30.040971755981392],
                [-89.58135986328128, 29.994722366332994],
                [-89.59812927246088, 29.881408691406286],
                [-89.69200399999998, 29.868721999999984],
                [-89.77545899999997, 29.937415999999995],
                [-89.83849999999998, 29.94581599999999],
                [-89.85755799999997, 30.004438999999994],
                [-89.81856099999999, 30.043327999999992],
                [-89.76321599999997, 30.042108],
                [-89.68371199999999, 30.076017999999998],
                [-89.67816299999997, 30.108286000000007],
                [-89.61754199999997, 30.156421999999992],
                [-89.61016435086573, 30.15835421398634],
                [-89.52450399999996, 30.180752999999992]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US22",
            STATE: "22",
            NAME: "Louisiana",
            CENSUSAREA: 43203.905,
            gx_id: "19",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-167.14196599999997, 53.826931999999985],
                  [-166.87808699999997, 53.429883999999994],
                  [-166.11131699999996, 53.77685599999999],
                  [-166.27940699999994, 53.982531999999985],
                  [-166.72891799999996, 54.00311099999999],
                  [-167.14196599999997, 53.826931999999985]
                ]
              ],
              [
                [
                  [-166.17490599999996, 60.40100299999998],
                  [-166.76252199999993, 60.30983699999998],
                  [-167.34288499999997, 60.074978999999985],
                  [-166.20329299999997, 59.79167599999998],
                  [-165.57581499999992, 59.90467199999999],
                  [-165.72138899999996, 60.16961999999998],
                  [-166.17490599999996, 60.40100299999998]
                ]
              ],
              [
                [
                  [-131.95791399999996, 54.79123899999998],
                  [-131.97981799999997, 55.21178699999999],
                  [-132.31856999999997, 55.46920799999998],
                  [-132.63529099999997, 55.921765999999984],
                  [-133.16321199999996, 56.317444999999985],
                  [-133.58211599999996, 56.352505999999984],
                  [-133.70055711311596, 55.778616854360884],
                  [-133.11620302492898, 55.37721102388148],
                  [-133.23969499999995, 55.09241499999998],
                  [-132.69396999999998, 54.669063999999985],
                  [-131.95791399999996, 54.79123899999998]
                ]
              ],
              [
                [
                  [-134.73179799999997, 57.72192099999999],
                  [-134.46403199999997, 57.392183999999986],
                  [-133.87065699999997, 57.35828699999999],
                  [-133.90487399999998, 57.807405999999986],
                  [-134.21598099999997, 58.16212799999999],
                  [-134.71398657560297, 58.22074770296829],
                  [-134.73179799999997, 57.72192099999999]
                ]
              ],
              [
                [
                  [-152.08924999999996, 58.36764399999999],
                  [-152.83923399999998, 58.37247699999998],
                  [-153.41293299999998, 58.06981099999998],
                  [-152.947547, 57.98351899999998],
                  [-151.97924769653602, 58.22205053563255],
                  [-152.08924999999996, 58.36764399999999]
                ]
              ],
              [
                [
                  [-153.45264499999996, 57.96350899999998],
                  [-154.629678, 57.51019699999999],
                  [-154.74308999999997, 57.31476999999998],
                  [-154.52469499999998, 56.99162299999998],
                  [-153.68871299999998, 56.871974999999985],
                  [-152.91137099999997, 57.12681299999999],
                  [-152.46101799999994, 57.606310999999984],
                  [-152.41742399999993, 57.815463999999984],
                  [-153.45264499999996, 57.96350899999998]
                ]
              ],
              [
                [
                  [-133.75964997464797, 56.675912887262086],
                  [-134.08329099999997, 56.931578999999985],
                  [-134.41979099999998, 56.83838499999998],
                  [-134.04093799999995, 56.42152999999998],
                  [-134.09221236437918, 56.218635732904225],
                  [-133.75964997464797, 56.675912887262086]
                ]
              ],
              [
                [
                  [-132.81804299999996, 56.494933999999986],
                  [-132.54128199999997, 56.58457299999999],
                  [-133.10461099999998, 57.00570099999998],
                  [-133.88795699999997, 57.097743999999985],
                  [-133.679352204088, 56.81076405227549],
                  [-133.66309399999997, 56.44807299999999],
                  [-133.20358399999998, 56.447656999999985],
                  [-133.26448701726423, 56.814606464799354],
                  [-132.81804299999996, 56.494933999999986]
                ]
              ],
              [
                [
                  [-135.68769599999996, 57.367476999999994],
                  [-135.31277999999998, 57.044983999999985],
                  [-135.41298899999995, 56.81007899999998],
                  [-134.80616299999997, 56.23553299999998],
                  [-134.63399699999997, 56.72872199999998],
                  [-134.84947699999998, 57.409669999999984],
                  [-135.30413641566835, 57.490554068464505],
                  [-135.68769599999996, 57.367476999999994]
                ]
              ],
              [
                [
                  [-135.02336999999994, 57.78053699999998],
                  [-134.91285399999995, 57.979286999999985],
                  [-135.78337999999997, 58.28670899999997],
                  [-136.40004574789998, 58.27199066410238],
                  [-136.573288, 57.92684399999999],
                  [-135.89213099999998, 57.408047999999994],
                  [-134.82489099999998, 57.50006699999998],
                  [-134.92160399999997, 57.742375999999986],
                  [-135.58796076152498, 57.89732002246189],
                  [-135.02336999999994, 57.78053699999998]
                ]
              ],
              [
                [
                  [-148.31765312681566, 70.35341483456452],
                  [-148.61056599999998, 70.42258799999998],
                  [-149.86669799999996, 70.51076899999998],
                  [-151.55464699999996, 70.43589499999997],
                  [-152.42077499999996, 70.60898299999998],
                  [-152.25996599999996, 70.84281999999999],
                  [-153.23847999999995, 70.92246699999998],
                  [-154.18186299999996, 70.76832499999998],
                  [-155.03173999999999, 71.14647299999999],
                  [-156.80965299999994, 71.28688599999998],
                  [-157.50245899999996, 70.94865899999998],
                  [-158.65610099999998, 70.78795499999998],
                  [-159.64838299999994, 70.79436799999998],
                  [-160.732703, 70.37438199999998],
                  [-161.92294899999993, 70.29159899999998],
                  [-163.01259499999998, 69.75746199999999],
                  [-163.11031799999998, 69.37534299999999],
                  [-164.25315699999996, 68.93093799999998],
                  [-166.21443299999996, 68.87952399999999],
                  [-166.23377999999997, 68.56426299999998],
                  [-166.70613899999998, 68.37178299999998],
                  [-165.49354999999997, 68.05928299999998],
                  [-164.07951399999996, 67.58585599999998],
                  [-163.74134499999994, 67.12912299999998],
                  [-162.90134799999993, 67.00683299999999],
                  [-161.67435899999992, 66.96196499999998],
                  [-161.88167099999995, 66.71679599999999],
                  [-161.12951199999998, 66.33624799999998],
                  [-161.3104755742162, 66.25717669775612],
                  [-161.83801799999998, 66.02258199999999],
                  [-163.76751049854, 66.06080342624257],
                  [-163.7545008934602, 66.53938292893447],
                  [-163.75417099999996, 66.55128399999998],
                  [-163.95961790814025, 66.56105786566236],
                  [-164.40072399999994, 66.58110999999998],
                  [-165.407204380127, 66.42044144907508],
                  [-168.10370791279195, 65.68555248878609],
                  [-167.474024, 65.41274399999999],
                  [-166.48596799999996, 65.33089999999999],
                  [-166.69081399999996, 64.98537199999998],
                  [-166.23693899999995, 64.58355799999998],
                  [-165.016519, 64.43439199999999],
                  [-163.21775668370498, 64.63206178857237],
                  [-162.53999599999997, 64.53093099999998],
                  [-161.66726099999997, 64.78898099999998],
                  [-160.93597399999996, 64.82236999999998],
                  [-160.80204799999996, 64.61035199999998],
                  [-161.26351899999997, 64.39816599999999],
                  [-160.97603799999996, 64.23576099999998],
                  [-160.76555999999997, 63.77355199999999],
                  [-161.13675799999993, 63.50452499999999],
                  [-162.27108899999996, 63.48771099999999],
                  [-163.04049999999995, 63.06215099999999],
                  [-164.14009599999994, 63.25933599999999],
                  [-164.63394299999993, 63.097819999999984],
                  [-165.096155, 62.52245199999998],
                  [-165.67203699999996, 62.13988999999999],
                  [-165.612337, 61.87190699999999],
                  [-166.13940871497798, 61.63231515215608],
                  [-165.754317, 61.49870399999998],
                  [-165.590682, 61.11116899999998],
                  [-165.11978099999993, 61.078639999999986],
                  [-165.19044899999994, 60.49800099999999],
                  [-164.1916, 60.024495999999985],
                  [-164.11511699999997, 59.83668799999999],
                  [-163.55914799999996, 59.80139099999999],
                  [-162.503647, 59.99922999999999],
                  [-162.100708108538, 59.94467476778419],
                  [-161.70252990722696, 59.49090576171879],
                  [-161.95652770996097, 59.361770629882784],
                  [-161.682907104492, 58.56467056274409],
                  [-160.31777954101594, 59.070476531982386],
                  [-159.90838623046898, 58.779903411865185],
                  [-159.39066399999996, 58.76236199999998],
                  [-159.06334599999997, 58.423138999999985],
                  [-158.70405199999996, 58.48275899999998],
                  [-158.76774799999995, 58.86426399999999],
                  [-158.14030699999995, 58.61501999999998],
                  [-157.11686599999996, 58.86753299999998],
                  [-157.45191799999998, 58.505617999999984],
                  [-157.69129099999995, 57.611130999999986],
                  [-159.32442099999997, 56.67035599999999],
                  [-160.35715599999997, 56.279581999999984],
                  [-160.93059099999994, 55.814357999999984],
                  [-161.290776816213, 55.983129712185296],
                  [-161.81622499999995, 55.888992999999985],
                  [-162.24697199999994, 55.68001299999999],
                  [-162.95718199999996, 55.17127099999998],
                  [-164.55025599999993, 54.888784999999984],
                  [-164.84493099999997, 54.41758299999999],
                  [-164.08489399999993, 54.620130999999986],
                  [-163.58596699999995, 54.611643999999984],
                  [-163.03606199999996, 54.94254399999999],
                  [-161.96086599999998, 55.10673399999999],
                  [-161.50765699999997, 55.362785999999986],
                  [-158.42445099999998, 56.06889899999998],
                  [-158.12743999999998, 56.460804999999986],
                  [-157.37877099999997, 56.86169599999998],
                  [-156.53558699999994, 57.047904999999986],
                  [-156.33942499999998, 57.41764099999999],
                  [-155.73277899999997, 57.54973199999999],
                  [-155.56843699999996, 57.78951099999998],
                  [-155.09709499999997, 57.865355999999984],
                  [-154.14527699999996, 58.21093099999998],
                  [-153.89715499999994, 58.606236999999986],
                  [-153.29472627454098, 58.86543166816629],
                  [-153.69566399999994, 59.07399399999998],
                  [-154.21481799999998, 59.15156199999999],
                  [-154.04456299999995, 59.388294999999985],
                  [-152.70643099999995, 59.91528399999999],
                  [-152.30922099999998, 60.50638399999999],
                  [-151.48029999999997, 61.01090199999999],
                  [-150.71129099999993, 61.251088999999986],
                  [-150.07545099999993, 61.15626899999998],
                  [-151.06255799999997, 60.78742899999998],
                  [-151.42170199999995, 60.21293099999998],
                  [-151.86771299999995, 59.778410999999984],
                  [-151.27245850827498, 59.55582342019049],
                  [-151.88651299999998, 59.42103299999998],
                  [-151.74845099999993, 59.15860099999998],
                  [-150.94221199999996, 59.23313599999999],
                  [-150.296351104967, 59.45579380516809],
                  [-149.74636369092596, 59.860881143427],
                  [-149.20485299999999, 60.009211999999984],
                  [-148.03717276077998, 59.95666399999999],
                  [-147.94210576077998, 60.444028999999986],
                  [-148.14869476078, 60.82870099999999],
                  [-147.13728076078, 60.98096799999998],
                  [-145.91440299999996, 60.49234999999998],
                  [-145.041549419692, 60.357133634176485],
                  [-143.897028675887, 59.985937717266985],
                  [-142.90885899999998, 60.09032799999999],
                  [-141.595376044947, 59.961905161108184],
                  [-140.92721999999998, 59.74570899999999],
                  [-140.28555699999995, 59.69871699999998],
                  [-138.63670199999999, 59.13058499999998],
                  [-138.11885299999997, 59.021306999999986],
                  [-137.68081099999998, 58.62183499999998],
                  [-137.26159546615213, 58.451652889579655],
                  [-136.70125000000002, 58.21941599999999],
                  [-135.63042499999997, 58.42857999999999],
                  [-135.27719799999997, 58.23363399999998],
                  [-134.08767429608298, 58.18195172543769],
                  [-133.50598199999996, 57.57845899999998],
                  [-133.51719699999995, 57.17777599999999],
                  [-132.91648699999996, 57.04008599999998],
                  [-132.45208106920597, 56.67247303034499],
                  [-132.34067799999997, 56.34175399999998],
                  [-132.71834199999998, 56.21770399999998],
                  [-132.15906399999997, 55.92255999999998],
                  [-132.18320699999995, 55.58812799999998],
                  [-131.16049199999998, 55.19748099999998],
                  [-130.91593599999996, 54.789616999999986],
                  [-130.33950399999998, 54.92137599999998],
                  [-129.98005799999996, 55.284229999999994],
                  [-130.15059499999998, 55.76703099999998],
                  [-130.10276099999996, 56.11669599999998],
                  [-131.58122099999997, 56.61327499999998],
                  [-131.83513299999996, 56.60184899999998],
                  [-132.25218699999996, 57.215654999999984],
                  [-133.84039199999998, 58.72799099999998],
                  [-134.25052599999998, 58.85804599999999],
                  [-134.48124099999998, 59.12807099999999],
                  [-134.96197199999997, 59.28037599999999],
                  [-135.0203903181074, 59.482118757500984],
                  [-135.0263485345428, 59.502559023272305],
                  [-135.47743599999998, 59.79962599999998],
                  [-135.63435217920556, 59.7647173926961],
                  [-136.25688899999997, 59.62364599999998],
                  [-136.58152099999998, 59.16490899999998],
                  [-137.44738299999997, 58.90951299999997],
                  [-137.60427699999997, 59.24305699999999],
                  [-139.20034599999994, 60.09070099999999],
                  [-139.08666899999997, 60.35765399999998],
                  [-139.69836099999998, 60.340420999999985],
                  [-139.989142, 60.18523999999999],
                  [-141.00183999999996, 60.30610499999998],
                  [-141.00207860918306, 61.80272473065634],
                  [-141.002133, 62.12468599999998],
                  [-141.00246494155996, 65.8394210006307],
                  [-141.00269399999996, 68.49839099999998],
                  [-141.00267199999996, 69.64560899999998],
                  [-142.74680699999996, 70.04253099999998],
                  [-143.91149399999998, 70.12983699999998],
                  [-144.61867099999995, 69.96931499999998],
                  [-145.79038599999998, 70.14856899999997],
                  [-147.68172199999998, 70.19995399999998],
                  [-148.31765312681566, 70.35341483456452]
                ]
              ],
              [
                [
                  [-170.04711399999997, 63.49013499999998],
                  [-170.48819199999997, 63.69672299999999],
                  [-171.10085499999994, 63.423419999999986],
                  [-169.82991199999995, 63.078549999999986],
                  [-169.267598120419, 63.34399518283009],
                  [-170.04711399999997, 63.49013499999998]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US02",
            STATE: "2",
            NAME: "Alaska",
            CENSUSAREA: 570640.95,
            gx_id: "2",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-68.495511, 44.16242899999998],
                  [-68.427534, 44.119265999999975],
                  [-68.38490299999998, 44.154954999999994],
                  [-68.45323599999999, 44.18999799999999],
                  [-68.495511, 44.16242899999998]
                ]
              ],
              [
                [
                  [-68.72043534219507, 44.16918503626819],
                  [-68.64300200457087, 44.15766007377248],
                  [-68.60590605313007, 44.23077154958839],
                  [-68.68077324466638, 44.279242418314],
                  [-68.72043534219507, 44.16918503626819]
                ]
              ],
              [
                [
                  [-68.82506699999998, 44.186337999999985],
                  [-68.91728599999998, 44.14823899999999],
                  [-68.94310499999999, 44.109729999999985],
                  [-68.88971699999998, 44.032516],
                  [-68.78560099999999, 44.053502999999985],
                  [-68.82506699999998, 44.186337999999985]
                ]
              ],
              [
                [
                  [-70.67311399999998, 43.07031399999999],
                  [-70.57578699999998, 43.22185899999998],
                  [-70.59390699999999, 43.249295],
                  [-70.54831628550473, 43.31730249202223],
                  [-70.53524399999996, 43.33677099999999],
                  [-70.46597499999999, 43.340245999999986],
                  [-70.37051399999997, 43.43413299999999],
                  [-70.38488499999998, 43.496039999999994],
                  [-70.36121399999999, 43.52918999999999],
                  [-70.2724966038162, 43.562615790515196],
                  [-70.19691099999999, 43.565145999999984],
                  [-70.21120399999998, 43.62576499999999],
                  [-70.2518117198447, 43.68325148340669],
                  [-70.19001441824308, 43.77186648747199],
                  [-70.05359396126948, 43.828416840164806],
                  [-69.99820956960659, 43.79868417863809],
                  [-69.86973234854189, 43.77565597732629],
                  [-69.83532299999999, 43.72112499999999],
                  [-69.75280099999998, 43.755939999999995],
                  [-69.70583828236148, 43.82302421850279],
                  [-69.65333699999998, 43.79102999999999],
                  [-69.60461603092128, 43.85800382893829],
                  [-69.55260599999998, 43.841346999999985],
                  [-69.42332399999998, 43.915506999999984],
                  [-69.39845499999997, 43.971804000000006],
                  [-69.20366799999998, 43.941805999999985],
                  [-69.19380508261658, 43.97554252324918],
                  [-69.06429857777218, 44.069910789538],
                  [-69.10086299999999, 44.104528999999985],
                  [-69.05454599999999, 44.17154199999999],
                  [-69.04019299999999, 44.233672999999996],
                  [-68.95888899999997, 44.31435299999999],
                  [-68.94816399999998, 44.355881999999994],
                  [-68.99076699999998, 44.41503299999999],
                  [-68.90093399999998, 44.452062000000005],
                  [-68.82915299999998, 44.462241999999996],
                  [-68.81481099999999, 44.36219399999999],
                  [-68.827197, 44.31215999999998],
                  [-68.73300399999998, 44.32838799999998],
                  [-68.60338495427978, 44.2747104686671],
                  [-68.53452185442379, 44.397810556871995],
                  [-68.45509549661959, 44.44749789980009],
                  [-68.39803499999998, 44.37619099999999],
                  [-68.430852558527, 44.312608678540585],
                  [-68.40126799999999, 44.25224399999999],
                  [-68.31758799999999, 44.22510099999999],
                  [-68.29822310259108, 44.27630340397278],
                  [-68.23343499999999, 44.28857799999999],
                  [-68.17360799999999, 44.32839699999998],
                  [-68.18453199999998, 44.36914499999999],
                  [-68.29822311072458, 44.44922544152179],
                  [-68.21386066952199, 44.49245596361759],
                  [-68.12320251898737, 44.47881524752559],
                  [-68.11228995424727, 44.401587926350196],
                  [-68.04933399999999, 44.330729999999974],
                  [-67.98566799999999, 44.38691699999999],
                  [-67.86887499999999, 44.45688099999999],
                  [-67.85668434162008, 44.52393444317689],
                  [-67.75385448285219, 44.543660985935084],
                  [-67.64850636556528, 44.525403440868885],
                  [-67.56815899999998, 44.53111699999998],
                  [-67.55239196316118, 44.619629150400385],
                  [-67.50580373321719, 44.63683741837259],
                  [-67.45774653201508, 44.598013893419186],
                  [-67.30962699999996, 44.65931599999999],
                  [-67.27412181595038, 44.62634455567569],
                  [-67.18942699999998, 44.645532999999986],
                  [-66.97970799999999, 44.80735999999999],
                  [-66.98446599999998, 44.91255699999999],
                  [-67.03829899999998, 44.945433],
                  [-67.11241399999999, 45.11232299999999],
                  [-67.15791899999999, 45.161003999999984],
                  [-67.27107599999998, 45.19108099999999],
                  [-67.33986899999998, 45.125593999999985],
                  [-67.40462899999999, 45.15992599999998],
                  [-67.46647899999998, 45.29381699999999],
                  [-67.41874699999998, 45.37725999999999],
                  [-67.47719999999998, 45.43158999999999],
                  [-67.50308799999998, 45.48968799999999],
                  [-67.42771299999998, 45.50133599999999],
                  [-67.42545199999998, 45.57908599999998],
                  [-67.64580999999998, 45.613596999999984],
                  [-67.72040099999998, 45.66252199999998],
                  [-67.80331299999999, 45.677885999999994],
                  [-67.80198899999998, 45.80354599999998],
                  [-67.75506799999998, 45.82366999999999],
                  [-67.80331799999998, 45.88371799999999],
                  [-67.781095, 45.94303199999999],
                  [-67.78211399999998, 46.27938099999999],
                  [-67.78840599999998, 46.60179499999998],
                  [-67.79051499999998, 47.067920999999984],
                  [-67.87812399999999, 47.102425999999994],
                  [-67.95226899999999, 47.19614199999999],
                  [-68.22289299999998, 47.34452599999999],
                  [-68.33623599999999, 47.359794999999984],
                  [-68.38410499999998, 47.30150599999999],
                  [-68.43255499999998, 47.28192999999998],
                  [-68.57855099999998, 47.28755099999999],
                  [-68.61974899999998, 47.24321799999999],
                  [-68.71786699999998, 47.24091899999999],
                  [-68.89568499999999, 47.18288299999999],
                  [-69.04019999999998, 47.24509999999997],
                  [-69.05388499999998, 47.37787799999999],
                  [-69.03688199999998, 47.40797699999998],
                  [-69.17841199999997, 47.456614999999985],
                  [-69.22441999999998, 47.459685999999984],
                  [-69.56638299999999, 47.125032],
                  [-69.99708599999998, 46.69522999999998],
                  [-70.05643299999998, 46.41658999999999],
                  [-70.20873299999998, 46.32896099999999],
                  [-70.29273599999998, 46.19159899999998],
                  [-70.23794699999998, 46.147378],
                  [-70.31060899999999, 46.06454399999999],
                  [-70.31296999999998, 45.96185599999998],
                  [-70.26540999999997, 45.96269199999999],
                  [-70.25911699999999, 45.89075499999998],
                  [-70.34243999999998, 45.85219199999999],
                  [-70.41692199999999, 45.79527900000001],
                  [-70.38355199999998, 45.73486899999998],
                  [-70.46986899999999, 45.701638999999986],
                  [-70.64468699999998, 45.607082999999996],
                  [-70.72161099999998, 45.51505799999999],
                  [-70.71704699999998, 45.487731999999994],
                  [-70.63135399999999, 45.41633999999999],
                  [-70.71228599999998, 45.390610999999986],
                  [-70.78147099999998, 45.43115899999999],
                  [-70.81233799999997, 45.30200599999999],
                  [-70.88502899999999, 45.234872999999986],
                  [-70.95082399999998, 45.334529999999994],
                  [-71.08433399999998, 45.30529299999999],
                  [-71.03103899999998, 44.655454999999975],
                  [-71.01126999999998, 44.30184599999998],
                  [-70.98906699999996, 43.79243999999999],
                  [-70.97271599999998, 43.57025499999999],
                  [-70.95083799999998, 43.551025999999986],
                  [-70.98681199999999, 43.414263999999996],
                  [-70.98079699230868, 43.39263138792809],
                  [-70.96722899999999, 43.34377699999999],
                  [-70.81401899999999, 43.22905300000001],
                  [-70.81199525979832, 43.22835538580074],
                  [-70.81185199999999, 43.22830599999998],
                  [-70.80967, 43.224560999999994],
                  [-70.81199525979831, 43.21963359472598],
                  [-70.81311899999999, 43.21725199999999],
                  [-70.81999915569469, 43.12258558719359],
                  [-70.81199525979831, 43.11867245800084],
                  [-70.80870799999998, 43.11706499999999],
                  [-70.70469599999998, 43.07098899999999],
                  [-70.67311399999998, 43.07031399999999]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US23",
            STATE: "23",
            NAME: "Maine",
            CENSUSAREA: 30842.923,
            gx_id: "20",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-76.02216999999999, 38.17788199999998],
                  [-76.08863899999999, 38.19264899999998],
                  [-76.09554799999997, 38.12512299999999],
                  [-76.04837277753009, 38.120550300267496],
                  [-76.02216999999999, 38.17788199999998]
                ]
              ],
              [
                [
                  [-75.99390499999998, 37.953489000000005],
                  [-75.97549399999998, 38.020833999999994],
                  [-76.04166799999999, 38.03214799999999],
                  [-76.04652999999998, 37.95358599999999],
                  [-75.99390499999998, 37.953489000000005]
                ]
              ],
              [
                [
                  [-79.48437199999996, 39.3443],
                  [-79.48687299999999, 39.20596099999998],
                  [-79.43982999999997, 39.21707399999999],
                  [-79.38702299999997, 39.26554],
                  [-79.38034472384487, 39.26914288348864],
                  [-79.25389099999998, 39.33722199999999],
                  [-79.1454530727392, 39.40776687823778],
                  [-79.09615371103747, 39.465541944440794],
                  [-79.0981508095168, 39.46832052035303],
                  [-79.09824010719417, 39.46844475480341],
                  [-79.01009699999997, 39.461047999999984],
                  [-79.0071488068442, 39.45968322158847],
                  [-78.99694999999998, 39.45496099999999],
                  [-78.99118142487978, 39.45816016920474],
                  [-78.87474399999998, 39.52261099999999],
                  [-78.79585699999998, 39.60693399999998],
                  [-78.68945499999998, 39.54576999999999],
                  [-78.56592899999997, 39.51944399999999],
                  [-78.46289899999998, 39.52083999999997],
                  [-78.42054899999997, 39.62402099999999],
                  [-78.35190499999997, 39.640485999999974],
                  [-78.26683299999996, 39.61881799999999],
                  [-78.18275899999998, 39.695109999999985],
                  [-78.10783399999998, 39.68213699999998],
                  [-78.01134299999998, 39.60408299999999],
                  [-77.93904993513178, 39.58713856174429],
                  [-77.79563099999997, 39.489622999999995],
                  [-77.75308999999999, 39.423262],
                  [-77.75578899999996, 39.33389899999998],
                  [-77.75395402952141, 39.33329131411463],
                  [-77.73500899999999, 39.32701499999998],
                  [-77.71902899999998, 39.32112499999999],
                  [-77.56659599999998, 39.30612099999999],
                  [-77.54322799999998, 39.266937],
                  [-77.45767999999998, 39.22501999999999],
                  [-77.52728199999999, 39.14623599999999],
                  [-77.46261699999998, 39.076247999999985],
                  [-77.34028699999998, 39.06299099999999],
                  [-77.24460299999998, 39.02010899999999],
                  [-77.22150199999999, 38.97130999999999],
                  [-77.14660099999998, 38.964209999999994],
                  [-77.11989999999997, 38.934310999999994],
                  [-77.04099899999999, 38.99510999999999],
                  [-76.90939499999998, 38.892811999999985],
                  [-77.03859799999998, 38.79151299999998],
                  [-77.04229799999999, 38.71851499999999],
                  [-77.13250099999998, 38.67381599999998],
                  [-77.13019999999999, 38.63501699999999],
                  [-77.23772399999999, 38.55186999999999],
                  [-77.27421999999997, 38.48176999999999],
                  [-77.25017199999998, 38.382780999999994],
                  [-77.20731199999999, 38.359866999999994],
                  [-77.01637099999998, 38.44557199999999],
                  [-76.97549199999999, 38.347326999999986],
                  [-76.92093199999998, 38.291567999999984],
                  [-76.79745199999998, 38.23691799999999],
                  [-76.67346199999999, 38.23440099999999],
                  [-76.59063699999999, 38.21421199999999],
                  [-76.54037999999998, 38.15299099999999],
                  [-76.48103599999997, 38.11587299999999],
                  [-76.43984063119377, 38.138932640080085],
                  [-76.36123699999999, 38.05954199999998],
                  [-76.32013599999998, 38.13833899999999],
                  [-76.38524399999999, 38.21775099999999],
                  [-76.40289383323999, 38.311401740757084],
                  [-76.38834799999998, 38.38778099999999],
                  [-76.49269899999997, 38.482848999999995],
                  [-76.51570599999997, 38.528988],
                  [-76.51127799999998, 38.61574499999999],
                  [-76.52665499999998, 38.72442999999999],
                  [-76.55988399999998, 38.767360999999994],
                  [-76.48987799999998, 38.83871499999999],
                  [-76.51944199999997, 38.863134999999986],
                  [-76.45027999999998, 38.94111299999999],
                  [-76.47419799999997, 38.97264699999999],
                  [-76.39407999999999, 39.01131099999999],
                  [-76.43892799999998, 39.05278799999999],
                  [-76.42868099999998, 39.131708999999994],
                  [-76.53418499999998, 39.19060799999999],
                  [-76.49731225816225, 39.19254674565246],
                  [-76.44248199999997, 39.19540799999999],
                  [-76.36438999999999, 39.31183999999999],
                  [-76.29107799999998, 39.318107999999995],
                  [-76.18007399999998, 39.37760899999998],
                  [-76.07197499999998, 39.47504699999998],
                  [-76.09607199999996, 39.53691199999999],
                  [-75.97033699999999, 39.55763699999999],
                  [-75.99656957753908, 39.476658275293],
                  [-75.97660099999999, 39.44780799999999],
                  [-76.04984599999999, 39.37064399999999],
                  [-76.11052699999998, 39.37225699999999],
                  [-76.17042199999999, 39.33209399999999],
                  [-76.21933799999998, 39.261996999999994],
                  [-76.26853875641982, 39.165407604049136],
                  [-76.27852699999998, 39.14576399999999],
                  [-76.23111699999997, 39.06101699999999],
                  [-76.18420699999999, 39.04626399999999],
                  [-76.16398799999999, 38.999541],
                  [-76.20235999999998, 38.973079000000006],
                  [-76.27747799999999, 38.982491999999986],
                  [-76.30284599999999, 39.02582799999999],
                  [-76.36172699999999, 38.93917499999997],
                  [-76.33610399999998, 38.90597699999999],
                  [-76.27308299999999, 38.94192699999999],
                  [-76.20363799999998, 38.928381999999985],
                  [-76.19108999999999, 38.82965999999999],
                  [-76.26580799999998, 38.847511999999995],
                  [-76.33461899999999, 38.77291099999999],
                  [-76.31614599999997, 38.72958599999999],
                  [-76.25509299999999, 38.73647599999999],
                  [-76.20033399999998, 38.67077399999999],
                  [-76.14715799999998, 38.63683999999999],
                  [-76.21242699999998, 38.606737999999986],
                  [-76.27958862166507, 38.60952039397689],
                  [-76.29004299999998, 38.569157999999995],
                  [-76.2473, 38.523817999999984],
                  [-76.33635999999998, 38.49223499999999],
                  [-76.28301999999998, 38.41351199999999],
                  [-76.25818899999999, 38.31837299999999],
                  [-76.11129599999998, 38.28694600000001],
                  [-76.00737499999998, 38.30431799999999],
                  [-75.96345299999997, 38.25179299999999],
                  [-75.84637699999998, 38.210477000000004],
                  [-75.94237499999998, 38.18706599999999],
                  [-75.90035499999998, 38.141149999999996],
                  [-75.83756299999999, 38.11375299999999],
                  [-75.81291299999998, 38.05893199999999],
                  [-75.87529699999999, 38.01196499999999],
                  [-75.89831599999998, 37.92511399999999],
                  [-75.86072699999998, 37.91830999999999],
                  [-75.78381499999998, 37.97259399999999],
                  [-75.71314999999998, 37.97662299999998],
                  [-75.66971099999998, 37.95079599999999],
                  [-75.62434099999999, 37.994211],
                  [-75.24226599999999, 38.027209000000006],
                  [-75.19379599999998, 38.09601299999999],
                  [-75.10294699999997, 38.31152499999999],
                  [-75.08551799999998, 38.324269999999984],
                  [-75.04893899999998, 38.451263],
                  [-75.42872799999999, 38.45267099999999],
                  [-75.69352099999998, 38.46012799999999],
                  [-75.70735222602659, 38.635359213275684],
                  [-75.72202799999998, 38.82207799999999],
                  [-75.74381099999997, 39.094674],
                  [-75.74447581652163, 39.10147139051451],
                  [-75.74579299999996, 39.11493499999998],
                  [-75.78865799999998, 39.65821100000001],
                  [-75.788359, 39.72181099999998],
                  [-76.41878399999999, 39.72120399999999],
                  [-76.99090299999999, 39.71979999999999],
                  [-77.53475799999998, 39.72013399999998],
                  [-78.53770199999998, 39.72248999999999],
                  [-79.04554799999998, 39.72288299999999],
                  [-79.38034472384487, 39.72149866160318],
                  [-79.39245838263568, 39.72143054603039],
                  [-79.47666199999996, 39.72107799999999],
                  [-79.48264799999998, 39.521364],
                  [-79.48281722195964, 39.504023816379714],
                  [-79.48437199999996, 39.3443]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US24",
            STATE: "24",
            NAME: "Maryland",
            CENSUSAREA: 9707.241,
            gx_id: "21",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-70.68688099999999, 41.44133399999999],
                  [-70.768901, 41.35324599999999],
                  [-70.70982599999998, 41.341723],
                  [-70.45108399999998, 41.34816099999999],
                  [-70.54756699999999, 41.415830999999976],
                  [-70.59627999999998, 41.471904999999985],
                  [-70.68688099999999, 41.44133399999999]
                ]
              ],
              [
                [
                  [-70.25616417734078, 41.288123168499794],
                  [-70.11866899999998, 41.242351000000006],
                  [-70.01522499999999, 41.237964],
                  [-69.96027699999998, 41.278731],
                  [-70.01844633575239, 41.3686297159049],
                  [-70.09214199999998, 41.29774099999998],
                  [-70.25616417734078, 41.288123168499794]
                ]
              ],
              [
                [
                  [-73.50814199999996, 42.08625699999999],
                  [-73.48731399999998, 42.049637999999995],
                  [-73.43281199999998, 42.050586999999986],
                  [-72.99954899999999, 42.03865299999999],
                  [-72.86361899999999, 42.037708999999985],
                  [-72.813541, 42.03649399999999],
                  [-72.77475678567848, 42.00212911378219],
                  [-72.69592699999998, 42.036787999999994],
                  [-72.13568699999996, 42.030244999999994],
                  [-72.06349599999999, 42.027346999999985],
                  [-71.80064999999998, 42.02356899999999],
                  [-71.79924199999998, 42.00806499999999],
                  [-71.38140099999997, 42.01879799999999],
                  [-71.38169999999998, 41.89319899999999],
                  [-71.32789599999997, 41.78050099999999],
                  [-71.26139199999999, 41.75230099999998],
                  [-71.22479768283088, 41.71049765010409],
                  [-71.19564017911648, 41.675090493932785],
                  [-71.19438445922408, 41.67480268783479],
                  [-71.19117799999998, 41.674215999999994],
                  [-71.13288799999998, 41.66010199999998],
                  [-71.13749199999998, 41.60256099999999],
                  [-71.13161799999999, 41.593917999999995],
                  [-71.12056999999999, 41.497448],
                  [-71.03551399999998, 41.49904699999999],
                  [-70.93154499999999, 41.54016899999999],
                  [-70.92972228561219, 41.60947903836439],
                  [-70.88920899999998, 41.63290399999999],
                  [-70.81027899999998, 41.624872999999994],
                  [-70.71873859691799, 41.735739823683176],
                  [-70.62652852449428, 41.71299466017469],
                  [-70.65865899999999, 41.54338499999998],
                  [-70.49324399999998, 41.552043999999974],
                  [-70.43724599999999, 41.605329000000005],
                  [-70.36035199999998, 41.63106899999998],
                  [-70.24586699999998, 41.628479],
                  [-70.08923799999998, 41.66281299999999],
                  [-69.99635899999998, 41.66718399999999],
                  [-69.92826099999998, 41.691700000000004],
                  [-69.93595199999999, 41.80942199999999],
                  [-69.98608499999999, 41.94959699999998],
                  [-70.03350099999997, 42.017735999999985],
                  [-70.11596799999998, 42.06763799999999],
                  [-70.05446399999998, 41.927365999999985],
                  [-70.00901299999998, 41.87662499999999],
                  [-70.02473399999998, 41.78736399999999],
                  [-70.18925399999996, 41.75198199999999],
                  [-70.25920499999998, 41.71395399999998],
                  [-70.47155199999997, 41.76156299999998],
                  [-70.54102999999998, 41.81575399999999],
                  [-70.52556699999998, 41.858729999999994],
                  [-70.55294099999998, 41.929641000000004],
                  [-70.66247604642868, 41.96059160245459],
                  [-70.66751199999999, 42.01231999999999],
                  [-70.64016899999999, 42.088633],
                  [-70.77096405756359, 42.24919661436749],
                  [-70.85109299999998, 42.268269999999994],
                  [-70.98909022860677, 42.26744894150229],
                  [-71.0156801942828, 42.32601873046748],
                  [-70.97489693870529, 42.35584261549869],
                  [-70.98299399999998, 42.42399599999999],
                  [-70.85779099999996, 42.490296],
                  [-70.87138159158079, 42.546403786617276],
                  [-70.65472699999998, 42.582233999999985],
                  [-70.61841999999997, 42.62863999999999],
                  [-70.68940199999999, 42.65331899999998],
                  [-70.77045299999999, 42.70482399999998],
                  [-70.80521999999998, 42.78179799999999],
                  [-70.81729599999998, 42.87228999999999],
                  [-70.93079899999998, 42.88458899999999],
                  [-71.03120099999998, 42.85908899999999],
                  [-71.064201, 42.806288999999985],
                  [-71.13250299999999, 42.82138899999999],
                  [-71.18610399999999, 42.790688999999986],
                  [-71.18180299999999, 42.73759],
                  [-71.24550399999998, 42.742588999999974],
                  [-71.29420499999998, 42.69698999999999],
                  [-71.92881099999998, 42.71223399999998],
                  [-71.98140199999999, 42.71329399999999],
                  [-72.45851899999998, 42.726852999999984],
                  [-73.26495699999998, 42.74593999999998],
                  [-73.35252699999998, 42.51000199999999],
                  [-73.50814199999996, 42.08625699999999]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US25",
            STATE: "25",
            NAME: "Massachusetts",
            CENSUSAREA: 7800.058,
            gx_id: "22",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-86.06039599999998, 45.10461699999999],
                  [-85.98409499999998, 45.08707299999999],
                  [-85.97680299999996, 45.13836299999999],
                  [-86.03317399999997, 45.15841999999999],
                  [-86.06039599999998, 45.10461699999999]
                ]
              ],
              [
                [
                  [-88.83571399999997, 48.05675199999998],
                  [-89.17915399999998, 47.93502999999998],
                  [-89.25520199999997, 47.876101999999996],
                  [-89.19016999999998, 47.831603],
                  [-89.12413399999998, 47.828616],
                  [-88.91166499999997, 47.89134399999998],
                  [-88.96266404612406, 47.923511746099386],
                  [-88.89918399999998, 47.95330000000001],
                  [-88.67007299999997, 48.011446],
                  [-88.57978399999998, 48.05866899999999],
                  [-88.57805299999997, 48.084372999999985],
                  [-88.44950199999998, 48.16331199999998],
                  [-88.54703299999997, 48.17489099999998],
                  [-88.68443399999997, 48.11578499999998],
                  [-88.83571399999997, 48.05675199999998]
                ]
              ],
              [
                [
                  [-84.50089199999996, 45.73725899999998],
                  [-84.41890199999997, 45.72171199999998],
                  [-84.35601999999999, 45.771894999999994],
                  [-84.61284508854787, 45.83452830253719],
                  [-84.50089199999996, 45.73725899999998]
                ]
              ],
              [
                [
                  [-85.60488099999998, 45.68193199999999],
                  [-85.61804899999998, 45.582646999999994],
                  [-85.53406399999997, 45.57819799999999],
                  [-85.48702599999997, 45.62121099999999],
                  [-85.49877699999996, 45.726290999999996],
                  [-85.56644099999997, 45.760221999999985],
                  [-85.60488099999998, 45.68193199999999]
                ]
              ],
              [
                [
                  [-83.32050299999997, 44.88057099999998],
                  [-83.39395999999998, 44.90305599999999],
                  [-83.44371799999998, 44.952247],
                  [-83.45416799999997, 45.031879999999994],
                  [-83.39925499999998, 45.070363999999984],
                  [-83.27150599999997, 45.02341699999999],
                  [-83.31844199999998, 45.12892999999999],
                  [-83.35989499999998, 45.16301999999999],
                  [-83.42238899999998, 45.29077499999999],
                  [-83.49670399999997, 45.357535999999996],
                  [-83.59927299999998, 45.352560999999994],
                  [-83.72181499999998, 45.41330399999999],
                  [-83.80662199999998, 45.419158999999986],
                  [-83.90947199999998, 45.48578399999999],
                  [-84.10923799999996, 45.50517099999999],
                  [-84.13946199999997, 45.57371399999998],
                  [-84.21526799999997, 45.634767],
                  [-84.32953699999997, 45.66437999999999],
                  [-84.46167999999999, 45.65240399999999],
                  [-84.55549599999999, 45.70226799999999],
                  [-84.77276499999999, 45.78930099999998],
                  [-84.78007944381154, 45.77779533640763],
                  [-84.79955799999996, 45.747129999999984],
                  [-84.910398, 45.750009999999996],
                  [-85.01534099999996, 45.65156399999998],
                  [-85.07490999999997, 45.629242],
                  [-85.11973699999999, 45.56902599999999],
                  [-85.08838599999999, 45.476927999999994],
                  [-85.04093599999997, 45.43670099999999],
                  [-84.92200599999998, 45.421913999999994],
                  [-84.91584999999996, 45.393114999999995],
                  [-85.03281299999998, 45.36125099999998],
                  [-85.14365099999998, 45.37036899999999],
                  [-85.20967299999998, 45.35693699999999],
                  [-85.37159299999999, 45.27083399999999],
                  [-85.38859299999999, 45.23523999999999],
                  [-85.36690799999998, 45.11693799999998],
                  [-85.39580000000001, 44.931017999999995],
                  [-85.41235144683183, 44.90806910005917],
                  [-85.52721599999997, 44.748234999999994],
                  [-85.57656599999999, 44.760208],
                  [-85.56023099999999, 44.81007199999997],
                  [-85.498007, 44.86545099999999],
                  [-85.48972254393487, 44.91114697026177],
                  [-85.47520399999998, 44.991052999999994],
                  [-85.52003399999997, 44.97399599999999],
                  [-85.52776899149009, 44.9126412017288],
                  [-85.53064899999997, 44.88976299999999],
                  [-85.58171699999998, 44.80778399999998],
                  [-85.62798199999997, 44.76750799999999],
                  [-85.64893199999999, 44.874009999999984],
                  [-85.62918563358792, 44.916562139488406],
                  [-85.60235599999997, 44.974271999999985],
                  [-85.62187799999998, 45.004529],
                  [-85.56612999999997, 45.04363299999997],
                  [-85.61431899999998, 45.12756199999998],
                  [-85.74644399999997, 45.05122899999998],
                  [-85.80740299999997, 44.949813999999996],
                  [-85.86985199999998, 44.939030999999986],
                  [-85.93159999999997, 44.96878799999999],
                  [-85.96263188958021, 44.92881747996445],
                  [-85.98021899999998, 44.90613599999999],
                  [-86.06674499999997, 44.905684999999984],
                  [-86.07350599999998, 44.76980299999999],
                  [-86.12112499999998, 44.72797199999999],
                  [-86.23248199999998, 44.70604999999998],
                  [-86.25394999999996, 44.648079999999986],
                  [-86.22069699999997, 44.56674199999999],
                  [-86.24891399999997, 44.483003999999994],
                  [-86.26870999999998, 44.34532399999999],
                  [-86.42987099999996, 44.11978199999999],
                  [-86.51470199999999, 44.05811899999999],
                  [-86.46313599999998, 43.97097599999997],
                  [-86.43104299999999, 43.815974999999995],
                  [-86.46155399999996, 43.746684999999985],
                  [-86.52917899999997, 43.677888999999986],
                  [-86.53849699999998, 43.61750099999999],
                  [-86.47927599999998, 43.51533499999998],
                  [-86.39574999999998, 43.31622499999999],
                  [-86.25464599999997, 43.08340899999999],
                  [-86.22630499999998, 42.98828399999998],
                  [-86.21073699999997, 42.859128000000005],
                  [-86.206834, 42.719423999999975],
                  [-86.24970999999996, 42.48021199999999],
                  [-86.29716799999997, 42.358207],
                  [-86.356218, 42.254165999999984],
                  [-86.48522299999998, 42.118239],
                  [-86.61944199999996, 41.89382699999999],
                  [-86.71703699999996, 41.81934899999999],
                  [-86.82482799999998, 41.760239999999996],
                  [-86.51931799999998, 41.75944699999999],
                  [-85.79136299999996, 41.759050999999985],
                  [-84.80588299999998, 41.760215999999986],
                  [-84.80608199999999, 41.69608899999999],
                  [-84.36041629527847, 41.70662461933579],
                  [-83.45383199999996, 41.73264699999999],
                  [-83.44336399999999, 41.78911799999998],
                  [-83.32602399999996, 41.92496099999999],
                  [-83.26952099999998, 41.93904199999999],
                  [-83.18724599999999, 42.007573],
                  [-83.18859799999998, 42.06643099999999],
                  [-83.13351099999997, 42.08814299999998],
                  [-83.12802199999997, 42.238839],
                  [-83.06412099999997, 42.31773799999999],
                  [-82.95941599999996, 42.33963799999999],
                  [-82.88841299999999, 42.398237],
                  [-82.87441599999998, 42.52353499999999],
                  [-82.79731799999998, 42.654031999999994],
                  [-82.70096399999998, 42.68954799999999],
                  [-82.63526199999997, 42.67555199999999],
                  [-82.68983599999997, 42.62714799999999],
                  [-82.68075799999998, 42.55790899999998],
                  [-82.604686, 42.54859199999999],
                  [-82.52333699999997, 42.607485999999994],
                  [-82.46748299999999, 42.76191000000001],
                  [-82.48204499999999, 42.80862899999998],
                  [-82.45502699999999, 42.92686599999998],
                  [-82.41296499999999, 42.977041],
                  [-82.48604199999997, 43.102485999999985],
                  [-82.52308599999998, 43.22536099999998],
                  [-82.53951699999998, 43.437539],
                  [-82.60049999999998, 43.60293499999998],
                  [-82.612224, 43.73977099999999],
                  [-82.63364099999997, 43.831224],
                  [-82.738992, 43.989505999999984],
                  [-82.91597599999997, 44.070502999999995],
                  [-83.02460399999998, 44.04517399999999],
                  [-83.04657699999998, 44.01570999999999],
                  [-83.26152999999998, 43.97352499999998],
                  [-83.28230999999998, 43.93803099999999],
                  [-83.34736524657566, 43.91215950264758],
                  [-83.33226999999998, 43.88052199999999],
                  [-83.40764659285237, 43.83199813110939],
                  [-83.48006999999997, 43.714636],
                  [-83.52483699999996, 43.71694799999999],
                  [-83.66979499999997, 43.59078999999999],
                  [-83.76988599999999, 43.63492399999999],
                  [-83.85207599999998, 43.644921999999994],
                  [-83.90947899999998, 43.67262199999998],
                  [-83.95434699999997, 43.750646999999994],
                  [-83.92937499999996, 43.777091],
                  [-83.91681499999997, 43.89904999999998],
                  [-83.87769399999996, 43.959235],
                  [-83.82907699999998, 43.989095],
                  [-83.68010799999998, 43.994195999999974],
                  [-83.65011599999998, 44.05240399999999],
                  [-83.58408999999997, 44.056747999999985],
                  [-83.54909599999998, 44.22728199999998],
                  [-83.50883899999998, 44.273710999999984],
                  [-83.42576199999998, 44.272487],
                  [-83.33253299999998, 44.34046399999999],
                  [-83.30847099999997, 44.539901999999984],
                  [-83.31451699999997, 44.60872499999999],
                  [-83.27339299999998, 44.713900999999986],
                  [-83.29729999999999, 44.746133999999984],
                  [-83.30729329492429, 44.804112068175115],
                  [-83.32050299999997, 44.88057099999998]
                ]
              ],
              [
                [
                  [-90, 46.693609105510795],
                  [-90.02839199999998, 46.67438999999999],
                  [-90.32762599999997, 46.607744000000004],
                  [-90.41813599999998, 46.56609399999999],
                  [-90.33692099999998, 46.55407599999999],
                  [-90.26526864008807, 46.503829297965076],
                  [-90.21659399999999, 46.501758999999986],
                  [-90.11882699999998, 46.35924099999999],
                  [-90.12048899999996, 46.336851999999986],
                  [-90, 46.31390905681691],
                  [-89.49572299999998, 46.216300999999994],
                  [-89.27688299999997, 46.17411599999999],
                  [-89.09162999999998, 46.13850499999999],
                  [-88.85026999999997, 46.04027399999998],
                  [-88.74642199999998, 46.02579799999998],
                  [-88.73999399999998, 46.027307999999984],
                  [-88.61640499999999, 45.98769999999999],
                  [-88.50594599999997, 46.01338499999999],
                  [-88.41691399999998, 45.97532299999998],
                  [-88.10290799999999, 45.921868999999994],
                  [-88.08882499999999, 45.85585999999999],
                  [-88.13610999999997, 45.81902899999999],
                  [-88.09404699999996, 45.785658000000005],
                  [-87.99587599999998, 45.79543499999998],
                  [-87.96345199999996, 45.75821999999999],
                  [-87.90465699999999, 45.759162999999994],
                  [-87.81233799999998, 45.71130299999999],
                  [-87.82410199999997, 45.647137999999984],
                  [-87.77767099999998, 45.609204],
                  [-87.81297599999998, 45.46415899999999],
                  [-87.86169699999999, 45.43447299999999],
                  [-87.87148499999999, 45.37154599999999],
                  [-87.75410399999998, 45.34944199999999],
                  [-87.69395599999997, 45.389893],
                  [-87.64812599999996, 45.339395999999994],
                  [-87.69824799999998, 45.28151199999999],
                  [-87.73520999999997, 45.177641999999985],
                  [-87.66121099999998, 45.10827899999998],
                  [-87.59020799999998, 45.09526399999999],
                  [-87.61201899999996, 45.12337699999999],
                  [-87.46520099999998, 45.273351000000005],
                  [-87.26348799999997, 45.55203199999999],
                  [-87.17224099999999, 45.66178799999999],
                  [-87.07044199999997, 45.71877899999999],
                  [-87.05743899999999, 45.81248300000001],
                  [-86.98843799999999, 45.81062099999999],
                  [-86.984588, 45.70581199999998],
                  [-86.92105999999997, 45.697867999999985],
                  [-86.83874599999997, 45.72230699999999],
                  [-86.77327899999997, 45.81138499999999],
                  [-86.78207999999997, 45.86019499999999],
                  [-86.64599799999998, 45.83388799999999],
                  [-86.58330399999997, 45.898784],
                  [-86.52920799999998, 45.85304299999999],
                  [-86.55554699999998, 45.813498999999986],
                  [-86.71578099999998, 45.683948999999984],
                  [-86.648439, 45.61599199999999],
                  [-86.58584699999997, 45.70492199999999],
                  [-86.51456999999996, 45.75233699999998],
                  [-86.36380799999996, 45.790056999999976],
                  [-86.32423199999997, 45.90607999999998],
                  [-86.27800699999999, 45.942056999999984],
                  [-86.19661799999999, 45.96318499999998],
                  [-86.050956, 45.96220499999999],
                  [-85.92601699999997, 45.93210399999999],
                  [-85.89319599999999, 45.967252999999985],
                  [-85.81044199999998, 45.98008699999998],
                  [-85.66396599999997, 45.96701299999999],
                  [-85.52156999999998, 46.091256999999985],
                  [-85.42691599999999, 46.10196399999998],
                  [-85.33591099999998, 46.09259499999998],
                  [-85.19752299999998, 46.044878],
                  [-85.15202699999999, 46.05072499999999],
                  [-85.00359699999998, 46.006129999999985],
                  [-84.83139599999998, 45.87203799999998],
                  [-84.76785112357815, 45.84461532445385],
                  [-84.74698499999997, 45.835596999999986],
                  [-84.70118299999999, 45.85309199999999],
                  [-84.73400199999998, 45.90702599999999],
                  [-84.69273499999998, 46.02701899999999],
                  [-84.656567, 46.05265399999998],
                  [-84.376429, 45.93196199999999],
                  [-84.33002099999999, 45.95624699999999],
                  [-84.11117399999998, 45.978674999999996],
                  [-84.01756499999998, 45.959046],
                  [-83.88105499999996, 45.968184999999984],
                  [-83.78610999999997, 45.93337499999997],
                  [-83.65765999999998, 45.94546299999998],
                  [-83.56183799999998, 45.912561999999994],
                  [-83.51062299999997, 45.929324],
                  [-83.48063899999997, 45.99616399999999],
                  [-83.532913, 46.01132799999998],
                  [-83.58131499999996, 46.089612999999986],
                  [-83.70386099999997, 46.103365999999994],
                  [-83.77378499999998, 46.05147099999999],
                  [-83.90053499999996, 45.99891799999998],
                  [-83.98952599999998, 46.03282299999999],
                  [-84.07174099999997, 46.092441],
                  [-84.02653599999998, 46.13164799999999],
                  [-84.12502199999999, 46.180208999999984],
                  [-84.22100099999999, 46.16306199999999],
                  [-84.21949399999998, 46.23199199999999],
                  [-84.11817509636457, 46.23396779086],
                  [-84.11962899999997, 46.315012999999986],
                  [-84.14617199999998, 46.41851999999999],
                  [-84.11122499999998, 46.50411899999999],
                  [-84.12892499999997, 46.53011899999999],
                  [-84.22613099999998, 46.533919999999995],
                  [-84.25443399999997, 46.50082099999999],
                  [-84.42027399999998, 46.50107699999999],
                  [-84.55149599999999, 46.41852199999998],
                  [-84.63101999999996, 46.48486799999999],
                  [-84.64895733455953, 46.48593969836707],
                  [-84.67842299999998, 46.48769399999999],
                  [-84.80010099999997, 46.446218999999985],
                  [-84.861448, 46.46992999999999],
                  [-85.01521099999998, 46.47971199999999],
                  [-85.05613299999999, 46.526519999999984],
                  [-85.03547599999997, 46.581546999999986],
                  [-85.02751299999998, 46.697450999999994],
                  [-84.95157999999998, 46.76948799999998],
                  [-85.06355599999998, 46.75785599999999],
                  [-85.25685999999999, 46.753379999999986],
                  [-85.48209599999998, 46.68043199999998],
                  [-85.58734499999998, 46.674626999999994],
                  [-85.87790799999996, 46.690913999999985],
                  [-86.11986199999998, 46.65725599999999],
                  [-86.13829499999997, 46.67293499999998],
                  [-86.34989, 46.57803499999998],
                  [-86.49505399999998, 46.52487399999999],
                  [-86.58616799999999, 46.463323999999986],
                  [-86.68381899999999, 46.49807899999998],
                  [-86.78790499999997, 46.47772899999999],
                  [-86.81602599999997, 46.437891999999984],
                  [-86.87515099999997, 46.43727999999999],
                  [-86.94707699999996, 46.47206399999999],
                  [-87.01713599999997, 46.53355],
                  [-87.10755899999997, 46.49612399999998],
                  [-87.25873199999997, 46.488254999999995],
                  [-87.38928999999997, 46.52447199999998],
                  [-87.38396099999997, 46.59306999999998],
                  [-87.44261199999998, 46.602775999999984],
                  [-87.57320299999996, 46.720470999999996],
                  [-87.63329999999998, 46.81210699999999],
                  [-87.72735799999998, 46.827656],
                  [-87.74101399999996, 46.86524699999998],
                  [-87.90033899999999, 46.90968599999999],
                  [-88.08186999999997, 46.920457999999996],
                  [-88.17519699999998, 46.90457999999997],
                  [-88.24443699999998, 46.92961199999998],
                  [-88.38140999999997, 46.83846599999998],
                  [-88.43842699999999, 46.786713999999996],
                  [-88.48374799999996, 46.831726999999994],
                  [-88.44390099999998, 46.97225099999998],
                  [-88.36762399999998, 47.019212999999986],
                  [-88.35319099999998, 47.06906299999999],
                  [-88.29762499999998, 47.098504999999975],
                  [-88.21236099999999, 47.209422999999994],
                  [-88.16305899999999, 47.21627799999999],
                  [-88.05484899999998, 47.29824],
                  [-87.93824999999998, 47.34229899999999],
                  [-87.95705799999998, 47.38725999999998],
                  [-87.81537099999998, 47.38478999999998],
                  [-87.74241699999997, 47.40582299999999],
                  [-87.71594199999998, 47.43981599999999],
                  [-87.80118399999998, 47.473300999999985],
                  [-87.97893399999997, 47.47941999999998],
                  [-88.18181999999999, 47.45765699999998],
                  [-88.41867299999998, 47.371187999999975],
                  [-88.50077999999998, 47.29350299999999],
                  [-88.57399699999996, 47.24598899999998],
                  [-88.65635899999998, 47.22562399999998],
                  [-88.76435099999996, 47.15576199999999],
                  [-88.88913999999998, 47.100574999999985],
                  [-88.94404499999999, 47.02012899999998],
                  [-88.99841699999996, 46.99531399999999],
                  [-89.14259499999997, 46.984858999999986],
                  [-89.24914299999998, 46.903325999999986],
                  [-89.43704699999998, 46.839511999999985],
                  [-89.51393799999998, 46.841834999999996],
                  [-89.61932899999996, 46.81888999999998],
                  [-89.67337499999996, 46.83322899999998],
                  [-89.790663, 46.818469],
                  [-89.84865199999997, 46.79571099999998],
                  [-90, 46.693609105510795]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US26",
            STATE: "26",
            NAME: "Michigan",
            CENSUSAREA: 56538.901,
            gx_id: "23",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-90, 47.8245265097172],
                [-89.97429599999997, 47.83051399999999],
                [-89.92364899999997, 47.86206199999999],
                [-89.79353899999998, 47.89135799999999],
                [-89.69761899999997, 47.941287999999986],
                [-89.58823014975266, 47.96619967501389],
                [-89.62508699999998, 48.011516999999984],
                [-89.74931399999998, 48.02332499999999],
                [-89.87124499999999, 47.98594499999999],
                [-89.96825499999997, 48.014481999999994],
                [-90, 48.054792809874094],
                [-90.02359499999999, 48.08470799999999],
                [-90.13264499999997, 48.111767999999984],
                [-90.30563399999997, 48.10511699999999],
                [-90.37454199999999, 48.09094199999999],
                [-90.64159599999998, 48.10351499999999],
                [-90.76162499999997, 48.09828299999998],
                [-90.83258899999997, 48.17376499999998],
                [-90.83917599999998, 48.23951099999999],
                [-90.97695499999998, 48.21945199999999],
                [-91.13773299999997, 48.149149999999985],
                [-91.25011199999999, 48.08408699999998],
                [-91.42964199999999, 48.04860799999998],
                [-91.56974599999997, 48.09334799999999],
                [-91.71198599999998, 48.11471299999998],
                [-91.71493099999996, 48.19912999999999],
                [-91.86438199999998, 48.207030999999986],
                [-91.89346999999997, 48.23769899999998],
                [-92.00657699999996, 48.26542099999999],
                [-92.00013299999998, 48.32135499999999],
                [-92.16216099999998, 48.36327899999999],
                [-92.28899399999997, 48.342990999999984],
                [-92.28072699999997, 48.24426899999999],
                [-92.36917399999999, 48.220268],
                [-92.46994799999999, 48.351835999999984],
                [-92.45638899999999, 48.401133999999985],
                [-92.50728499999998, 48.44787499999998],
                [-92.65602699999998, 48.43670899999999],
                [-92.71256199999996, 48.46301299999999],
                [-92.63669599999999, 48.49942799999998],
                [-92.63493099999997, 48.542872999999986],
                [-92.72804599999996, 48.53928999999999],
                [-92.98496299999998, 48.623730999999985],
                [-93.17809499999998, 48.62333899999998],
                [-93.20739799999997, 48.642473999999986],
                [-93.34752799999998, 48.62661999999998],
                [-93.46430799999997, 48.59179199999999],
                [-93.46750399999996, 48.54566399999998],
                [-93.64539699999999, 48.51728099999998],
                [-93.79445399999999, 48.51602099999998],
                [-93.84400799999997, 48.62939499999998],
                [-94.24439399999997, 48.65344199999999],
                [-94.26447299999997, 48.69891899999999],
                [-94.41619099999997, 48.71094799999999],
                [-94.43870099999997, 48.69488899999999],
                [-94.58714999999998, 48.717598999999986],
                [-94.690889, 48.77806599999999],
                [-94.68306899999996, 48.88392899999998],
                [-94.71893199999998, 48.99999099999998],
                [-94.75021799999998, 48.999991999999985],
                [-94.75022099999997, 49.09976299999998],
                [-94.77322299999999, 49.12073299999999],
                [-94.82515999999998, 49.29428299999999],
                [-94.95746499999997, 49.37018599999999],
                [-95.05840399999998, 49.35316999999998],
                [-95.15331399999998, 49.384357999999985],
                [-95.15371099999997, 48.998902999999984],
                [-95.84607204250878, 49.00020074097161],
                [-95.97538999999996, 48.99998399999999],
                [-96.40540799999997, 48.99998399999999],
                [-97.22903899999997, 49.000686999999985],
                [-97.23920899999999, 48.96868399999998],
                [-97.175618433936, 48.85310509541459],
                [-97.13608275557547, 48.727762735004895],
                [-97.09869670006738, 48.68753407768949],
                [-97.16310499999997, 48.543855],
                [-97.13274585253737, 48.459942471036],
                [-97.1477477043823, 48.35990546506171],
                [-97.11657, 48.27966099999999],
                [-97.14667200265437, 48.1714844606985],
                [-97.07564099999998, 48.05272499999999],
                [-97.05455399999997, 47.94627899999998],
                [-97.01775399999997, 47.919777999999994],
                [-96.98057870942317, 47.80561364082849],
                [-96.93917899999997, 47.76839699999999],
                [-96.87949599999997, 47.62057599999999],
                [-96.85129277154458, 47.58926399066699],
                [-96.86426128812339, 47.420971520310886],
                [-96.84109863229918, 47.38415008080809],
                [-96.83823309960518, 47.1963655152712],
                [-96.818843327354, 47.107153516121386],
                [-96.81955799999997, 46.967452999999985],
                [-96.776558, 46.895662999999985],
                [-96.80015999999996, 46.81966399999998],
                [-96.77925185705688, 46.72742943001679],
                [-96.79835699999998, 46.66531399999998],
                [-96.75207750136528, 46.582197262708384],
                [-96.73512338063199, 46.47889664775469],
                [-96.66718899999998, 46.37545799999998],
                [-96.59976099999999, 46.33038599999999],
                [-96.59566999999997, 46.21984999999999],
                [-96.55450699999999, 46.08397799999998],
                [-96.57793999999997, 46.026873999999985],
                [-96.56327999999996, 45.935237999999984],
                [-96.57973999999997, 45.82581999999999],
                [-96.65222599999998, 45.746808999999985],
                [-96.84074599999997, 45.64529399999999],
                [-96.85775099999996, 45.60596199999999],
                [-96.76527999999996, 45.521413999999986],
                [-96.73139599999996, 45.45701999999999],
                [-96.68045399999998, 45.41049899999998],
                [-96.61772599999998, 45.40809199999998],
                [-96.48906499999997, 45.35707099999999],
                [-96.45306699999998, 45.29811499999998],
                [-96.45200899999998, 44.89007999999999],
                [-96.45162556462358, 44.81799946825832],
                [-96.45155953971727, 44.805569481245286],
                [-96.45181599999998, 44.46040199999998],
                [-96.45338899999999, 43.97805999999999],
                [-96.45304899999998, 43.500414999999975],
                [-96.35105899999996, 43.50033299999998],
                [-95.74081299999999, 43.49989399999999],
                [-95.11487399999997, 43.500666999999986],
                [-95.054289, 43.50085999999998],
                [-94.47041999999998, 43.50033999999999],
                [-93.79579299999996, 43.499519999999976],
                [-93.2718, 43.499355999999985],
                [-92.79031699999997, 43.499566999999985],
                [-91.94987899999998, 43.500485],
                [-91.21770599999998, 43.50054999999999],
                [-91.23186499999997, 43.58182199999998],
                [-91.268748, 43.61534799999999],
                [-91.26845499999999, 43.70982399999999],
                [-91.24413499999997, 43.77466699999999],
                [-91.28413799999997, 43.847064999999986],
                [-91.44053599999997, 44.00150099999999],
                [-91.58260399999998, 44.02738099999998],
                [-91.71059699999996, 44.120479999999986],
                [-91.87515799999997, 44.20057499999999],
                [-91.92558999999997, 44.333547999999986],
                [-92.05354899999996, 44.401374999999994],
                [-92.21516299999998, 44.43850299999999],
                [-92.27678399999996, 44.47364899999999],
                [-92.347567, 44.55714899999998],
                [-92.54055099999998, 44.567257999999995],
                [-92.56943399999999, 44.603538999999984],
                [-92.73725899999997, 44.71715499999999],
                [-92.80798799999998, 44.75146999999998],
                [-92.76527799999998, 44.84106999999999],
                [-92.75064499999996, 44.93729899999999],
                [-92.7551523192393, 44.9668658412391],
                [-92.76460399999996, 45.02876699999998],
                [-92.79152799999999, 45.079647],
                [-92.74493799999996, 45.108308999999984],
                [-92.76680799999998, 45.185466],
                [-92.75870999999997, 45.29096499999998],
                [-92.65042199999996, 45.39850699999998],
                [-92.64660199999997, 45.441634999999984],
                [-92.77022299999999, 45.566938999999984],
                [-92.883749, 45.57548299999999],
                [-92.869193, 45.71756799999999],
                [-92.784621, 45.764195999999984],
                [-92.70770199999997, 45.89490099999998],
                [-92.54845899999997, 45.96905599999999],
                [-92.54568199999999, 45.970117999999985],
                [-92.46448099999998, 45.976266999999986],
                [-92.42069599999996, 46.026769],
                [-92.36214099999998, 46.01310299999999],
                [-92.29403300054659, 46.074377066316394],
                [-92.29385699999999, 46.180072999999986],
                [-92.29355799999998, 46.224577999999994],
                [-92.29219199999997, 46.66604199999998],
                [-92.21239199999997, 46.64994099999999],
                [-92.13788999999997, 46.73953999999999],
                [-92.08948999999998, 46.74924],
                [-92.01528999999996, 46.706468999999984],
                [-92.09408899999997, 46.787839],
                [-91.70464899999997, 47.00524599999999],
                [-91.66647699999997, 47.01429699999999],
                [-91.57381699999998, 47.089916999999986],
                [-91.47735099999998, 47.125666999999986],
                [-91.35780299999998, 47.206742999999996],
                [-91.188772, 47.34008199999998],
                [-91.17003699999998, 47.366265999999996],
                [-91.02312399999998, 47.46496399999999],
                [-90.73592699999998, 47.62434299999999],
                [-90.53710499999997, 47.703054999999985],
                [-90.33268599999998, 47.746387],
                [-90, 47.8245265097172]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US27",
            STATE: "27",
            NAME: "Minnesota",
            CENSUSAREA: 79626.743,
            gx_id: "24",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-115.25514599999997, 47.16287599999998],
                [-115.18945099999998, 47.13103199999998],
                [-115.08780599999997, 47.045518999999985],
                [-115.04785699999996, 46.969532999999984],
                [-115.00127399999997, 46.97190099999998],
                [-114.93680499999996, 46.89737799999999],
                [-114.92783699999997, 46.83598999999998],
                [-114.76510599999997, 46.75815299999997],
                [-114.76688999999998, 46.69690099999999],
                [-114.64938799999999, 46.73288999999998],
                [-114.61503599999999, 46.639732999999985],
                [-114.46690199999998, 46.631695],
                [-114.42442399999999, 46.66064799999999],
                [-114.33288699999997, 46.660755999999985],
                [-114.32251899999997, 46.61106599999999],
                [-114.35165499999997, 46.50811899999999],
                [-114.40301899999997, 46.498674999999984],
                [-114.37641299999997, 46.44298299999999],
                [-114.42245799999998, 46.38709699999999],
                [-114.41375799999997, 46.33594499999998],
                [-114.45191199999996, 46.241252999999986],
                [-114.44592799999997, 46.17393299999999],
                [-114.51470599999998, 46.16772599999998],
                [-114.52129999999998, 46.12528699999999],
                [-114.46004899999997, 46.09710399999999],
                [-114.49215345696197, 46.047290070963584],
                [-114.38824299999997, 45.882339999999985],
                [-114.40947699999997, 45.85163999999998],
                [-114.49880899999997, 45.850675999999986],
                [-114.56617199999997, 45.77386399999998],
                [-114.50486899999997, 45.72217599999998],
                [-114.49963699999998, 45.669034999999994],
                [-114.56104599999999, 45.63990599999998],
                [-114.55825299999997, 45.58510399999999],
                [-114.46054199999998, 45.56128299999999],
                [-114.41580399999997, 45.50975299999998],
                [-114.33321799999997, 45.459315999999994],
                [-114.24782399999998, 45.52428299999998],
                [-114.13524899999997, 45.557464999999986],
                [-113.98665599999998, 45.70456399999999],
                [-113.89888252684398, 45.644166581896386],
                [-113.80672899999999, 45.602146],
                [-113.83455499999998, 45.52072899999999],
                [-113.76602199999996, 45.52062099999998],
                [-113.78415999999999, 45.454945999999985],
                [-113.73440199999997, 45.39235299999999],
                [-113.73560099999997, 45.32526499999999],
                [-113.68494599999997, 45.253705999999994],
                [-113.59950599999999, 45.19111399999999],
                [-113.57466999999998, 45.12841099999998],
                [-113.45196999999999, 45.059247],
                [-113.44378199999997, 44.959889999999994],
                [-113.49444599999997, 44.948597],
                [-113.45507099999998, 44.86542399999999],
                [-113.35606199999997, 44.81979799999999],
                [-113.34170399999996, 44.784852999999984],
                [-113.24716599999996, 44.822950000000006],
                [-113.13145299999996, 44.77283699999999],
                [-113.05676999999999, 44.618656999999985],
                [-113.08381939969098, 44.60222049085],
                [-113.01977651854199, 44.52850514932459],
                [-113.00354399999999, 44.450814],
                [-112.88604099999998, 44.395874],
                [-112.78129399999999, 44.484887999999984],
                [-112.71910999999997, 44.50434399999998],
                [-112.66069599999999, 44.48575599999998],
                [-112.47320699999997, 44.48002699999999],
                [-112.38738899999997, 44.44805799999998],
                [-112.35891699999999, 44.528846999999985],
                [-112.28618699999997, 44.56847199999999],
                [-112.10675499999996, 44.52082899999999],
                [-112.03270699999999, 44.54664199999999],
                [-111.87050399999997, 44.56403299999998],
                [-111.82148799999999, 44.50928599999999],
                [-111.71547399999997, 44.543542999999985],
                [-111.58576299999999, 44.562842999999994],
                [-111.50079199999998, 44.54006199999999],
                [-111.52576399999998, 44.60488299999999],
                [-111.47317799999999, 44.665479],
                [-111.48601899999997, 44.707653999999984],
                [-111.32366899999998, 44.72447399999999],
                [-111.22416118283198, 44.62340171445719],
                [-111.22520798621298, 44.5810062612193],
                [-111.14355747973597, 44.53573210755958],
                [-111.12265399999997, 44.493658999999994],
                [-111.04897399999997, 44.47407199999999],
                [-111.05520799999996, 44.62492700000001],
                [-111.05519899999997, 45.001321],
                [-110.78500799999998, 45.002951999999986],
                [-110.70527199999997, 44.99232399999998],
                [-110.19950299999996, 44.99618799999998],
                [-110.11010299999997, 45.00390499999998],
                [-109.75072999999998, 45.001604999999984],
                [-109.10344499999997, 45.00590399999998],
                [-109.08300999999997, 44.99960999999998],
                [-108.271201, 45.00025099999998],
                [-107.351441, 45.001407],
                [-107.13417999999997, 45.00010899999999],
                [-107.08493899999998, 44.99659899999999],
                [-106.26358599999998, 44.993788],
                [-105.92818399999999, 44.993646999999996],
                [-105.84806499999998, 45.00039599999998],
                [-105.07660744789197, 45.00034740634939],
                [-104.47042199999999, 44.998452999999984],
                [-104.05769799999999, 44.99743099999999],
                [-104.040128, 44.999987],
                [-104.04011399999999, 45.37421399999999],
                [-104.045443, 45.94531],
                [-104.04509845443599, 46.54092899334059],
                [-104.04527098971299, 46.6414430068147],
                [-104.04478799999997, 47.12742999999998],
                [-104.04324199999999, 47.74710599999998],
                [-104.04821199999998, 48.59905499999999],
                [-104.04873599999998, 48.999876999999984],
                [-104.87552699999999, 48.99899099999998],
                [-105.35588799999998, 48.99935699999998],
                [-106.05054299999998, 48.999206999999984],
                [-106.47960899999997, 48.999371999999994],
                [-107.44101699999999, 48.99936299999999],
                [-108.23649625326797, 48.99952985215909],
                [-108.99472199999997, 48.999237],
                [-110.17159499999998, 48.99926199999998],
                [-111.00391599999998, 48.99753699999999],
                [-111.500812, 48.99696299999998],
                [-112.19358802197097, 48.99889985922768],
                [-113.00989499999997, 48.998618999999984],
                [-113.69298199999997, 48.99763199999999],
                [-114.37597699999998, 49.00138999999999],
                [-115.20791199999996, 48.999227999999974],
                [-116.04919299999997, 49.00091199999998],
                [-116.049156521784, 48.502058001131786],
                [-116.04884999999999, 47.97718599999999],
                [-115.90093399999999, 47.843063999999984],
                [-115.85229099999997, 47.82799099999998],
                [-115.82459699999998, 47.75215399999999],
                [-115.72376999999997, 47.696670999999974],
                [-115.73626999999999, 47.65476199999999],
                [-115.68940399999997, 47.595402],
                [-115.746944842124, 47.5552929742068],
                [-115.67118778409096, 47.45438967167519],
                [-115.71893382481898, 47.42096744871679],
                [-115.55107899999997, 47.34985599999999],
                [-115.52675117074298, 47.30321854186749],
                [-115.41068499999999, 47.26422799999999],
                [-115.32690341768499, 47.255911821100284],
                [-115.25578599999999, 47.17472499999999],
                [-115.25514599999997, 47.16287599999998]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US30",
            STATE: "30",
            NAME: "Montana",
            CENSUSAREA: 145545.801,
            gx_id: "27",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-119.72572999999997, 41.99629599999999],
                [-119.99916799999998, 41.99453999999999],
                [-119.99828699999999, 41.74989199999999],
                [-119.99986599999997, 41.183973999999985],
                [-119.99939129912379, 40.8935685616097],
                [-119.99935799999997, 40.87310099999999],
                [-119.99592599999997, 40.49990099999999],
                [-120.00050199999997, 39.77995599999999],
                [-120.00131900843897, 39.722416320206285],
                [-120.00574599999999, 39.22521],
                [-120.00101399999998, 38.99957399999999],
                [-119.58767899999998, 38.71473399999999],
                [-119.09716099999997, 38.37285299999999],
                [-118.74659799999998, 38.12492599999999],
                [-118.62158999999998, 38.03438899999998],
                [-117.87592699999998, 37.497266999999994],
                [-117.58141799999997, 37.278935999999995],
                [-117.50090899999998, 37.22028199999998],
                [-117.00089499999997, 36.84769399999998],
                [-116.54198299999999, 36.49995199999999],
                [-116.375875, 36.37256199999999],
                [-116.09721599999999, 36.158345999999995],
                [-115.50083199999997, 35.69338199999999],
                [-114.80502999999997, 35.140283999999994],
                [-114.63301299999998, 35.00208499999999],
                [-114.60473599999997, 35.07482999999999],
                [-114.64283099999997, 35.09650299999999],
                [-114.57274699999996, 35.138725],
                [-114.56923799999997, 35.18347999999999],
                [-114.595931, 35.325233999999995],
                [-114.61143499999997, 35.36905599999999],
                [-114.66212499999997, 35.444241],
                [-114.67720499999999, 35.513490999999995],
                [-114.65340599999998, 35.61078899999998],
                [-114.68220699999999, 35.678187999999984],
                [-114.68320799999998, 35.68938699999999],
                [-114.71210999999997, 35.80618499999999],
                [-114.67742038175197, 35.87472796293489],
                [-114.67903885108598, 35.88004579842708],
                [-114.73115899999999, 35.943916],
                [-114.74037470307799, 36.04925769149439],
                [-114.73625324291599, 36.058470354436594],
                [-114.73616499999999, 36.10436699999999],
                [-114.57203099999998, 36.15160999999999],
                [-114.51172099999997, 36.15095599999999],
                [-114.45836899999998, 36.13858599999998],
                [-114.44865399999998, 36.12640999999999],
                [-114.41694999999999, 36.14576099999999],
                [-114.40547499999998, 36.14737099999999],
                [-114.32877699999997, 36.10550099999999],
                [-114.31610899999997, 36.06310899999999],
                [-114.31402799999996, 36.05816499999998],
                [-114.23879899999997, 36.01456099999999],
                [-114.15412999999997, 36.023861999999994],
                [-114.06802699999997, 36.18066299999999],
                [-114.04683799999997, 36.19406899999999],
                [-114.05056199999997, 36.65625899999999],
                [-114.05059999999999, 37.00039599999999],
                [-114.05244799999998, 37.431439999999995],
                [-114.05270099999997, 37.49201399999998],
                [-114.04941699999998, 38.2647],
                [-114.04910399999997, 39.00550899999999],
                [-114.04707899999997, 39.49994299999999],
                [-114.04655499999997, 39.996899],
                [-114.04617799999997, 40.39831299999999],
                [-114.04317599999997, 40.77167499999998],
                [-114.04023099999998, 41.49168999999999],
                [-114.04172299999999, 41.99371999999998],
                [-114.59826699999996, 41.99451099999999],
                [-114.80638399999997, 42.00182199999999],
                [-115.03178299999998, 41.99600799999999],
                [-115.8015325330767, 41.99693323853626],
                [-115.87018099999997, 41.996765999999994],
                [-116.36847799999997, 41.99628099999999],
                [-117.02622199999998, 42.00025199999999],
                [-117.44306199999997, 41.99965899999999],
                [-117.62373099999998, 41.998466999999984],
                [-118.19718899999998, 41.99699499999998],
                [-118.69640899999997, 41.991793999999985],
                [-119.44459799999998, 41.99547799999999],
                [-119.72572999999997, 41.99629599999999]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US32",
            STATE: "32",
            NAME: "Nevada",
            CENSUSAREA: 109781.18,
            gx_id: "29",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-113.12596099999998, 31.972779999999997],
                [-112.61986494804043, 31.81977843599728],
                [-111.97941699999997, 31.620683000000003],
                [-111.56019399999997, 31.488137999999992],
                [-111.07482499999998, 31.33223899999999],
                [-110.46017199999999, 31.33282699999999],
                [-109.82968899999997, 31.33406699999999],
                [-109.050044, 31.33250199999999],
                [-109.04828599999998, 32.08911399999999],
                [-109.04711699999997, 32.77757],
                [-109.04711633322835, 33.01821773864426],
                [-109.04711599999997, 33.13799499999999],
                [-109.04746999999998, 33.25006299999999],
                [-109.04700599999998, 34.000049999999995],
                [-109.04618199999997, 34.522393],
                [-109.04602418552197, 35.17549898440889],
                [-109.04601099999998, 35.925895999999995],
                [-109.04572899999997, 36.11702799999999],
                [-109.04543099999997, 36.50000099999999],
                [-109.04522299999996, 36.99908399999999],
                [-109.27009699999999, 36.99926599999999],
                [-109.38122599999998, 36.99914799999999],
                [-110.02177799999997, 36.99860199999999],
                [-110.47018999999997, 36.997997],
                [-110.50068999999996, 37.004259999999995],
                [-111.06649599999997, 37.002388999999994],
                [-111.25485299999998, 37.00107699999999],
                [-111.27828599999997, 37.00046499999999],
                [-111.40586899999997, 37.001480999999984],
                [-112.54509399999998, 37.000733999999994],
                [-112.60978699999997, 37.00075299999999],
                [-112.61986494804043, 37.00074972667879],
                [-112.89936590338299, 37.00031946461738],
                [-114.05059999999999, 37.00039599999999],
                [-114.05056199999997, 36.65625899999999],
                [-114.04683799999997, 36.19406899999999],
                [-114.06802699999997, 36.18066299999999],
                [-114.15412999999997, 36.023861999999994],
                [-114.23879899999997, 36.01456099999999],
                [-114.31402799999996, 36.05816499999998],
                [-114.31610899999997, 36.06310899999999],
                [-114.32877699999997, 36.10550099999999],
                [-114.40547499999998, 36.14737099999999],
                [-114.41694999999999, 36.14576099999999],
                [-114.44865399999998, 36.12640999999999],
                [-114.45836899999998, 36.13858599999998],
                [-114.51172099999997, 36.15095599999999],
                [-114.57203099999998, 36.15160999999999],
                [-114.73616499999999, 36.10436699999999],
                [-114.73625324291599, 36.058470354436594],
                [-114.74037470307799, 36.04925769149439],
                [-114.73115899999999, 35.943916],
                [-114.67903885108598, 35.88004579842708],
                [-114.67742038175197, 35.87472796293489],
                [-114.71210999999997, 35.80618499999999],
                [-114.68320799999998, 35.68938699999999],
                [-114.68220699999999, 35.678187999999984],
                [-114.65340599999998, 35.61078899999998],
                [-114.67720499999999, 35.513490999999995],
                [-114.66212499999997, 35.444241],
                [-114.61143499999997, 35.36905599999999],
                [-114.595931, 35.325233999999995],
                [-114.56923799999997, 35.18347999999999],
                [-114.57274699999996, 35.138725],
                [-114.64283099999997, 35.09650299999999],
                [-114.60473599999997, 35.07482999999999],
                [-114.63301299999998, 35.00208499999999],
                [-114.630682, 34.86635199999999],
                [-114.58684199999998, 34.83567199999999],
                [-114.55268199999998, 34.766870999999995],
                [-114.47161999999997, 34.712965999999994],
                [-114.38083799999997, 34.529723999999995],
                [-114.38669899999998, 34.45791099999999],
                [-114.34261499999997, 34.451442000000014],
                [-114.22610699999997, 34.36591599999999],
                [-114.17690899999997, 34.34930599999999],
                [-114.13828199999998, 34.30323],
                [-114.16653599999997, 34.24964699999999],
                [-114.25414099999998, 34.17383099999999],
                [-114.41590799999997, 34.10763599999999],
                [-114.46026439542898, 33.996648850930995],
                [-114.53367942794698, 33.92607205327779],
                [-114.50301699999997, 33.86799799999999],
                [-114.52959699999997, 33.84806299999999],
                [-114.49648899999997, 33.69690099999999],
                [-114.53152299999996, 33.675107999999994],
                [-114.55889799999997, 33.53181899999998],
                [-114.62963999999997, 33.42813799999999],
                [-114.72287199999997, 33.39877899999999],
                [-114.70093799999997, 33.33701399999999],
                [-114.73122299999996, 33.30243399999999],
                [-114.67703199999998, 33.270169999999986],
                [-114.67872899999998, 33.16294799999999],
                [-114.70789599999999, 33.097432],
                [-114.67080299999999, 33.037983999999994],
                [-114.57165299999997, 33.03662399999999],
                [-114.50612999999997, 33.01700999999999],
                [-114.46444799999998, 32.913129],
                [-114.46897099999997, 32.84515499999999],
                [-114.53166899999997, 32.79118499999999],
                [-114.52685599999997, 32.75709399999999],
                [-114.61837299999998, 32.728244999999994],
                [-114.68877899999997, 32.73767499999999],
                [-114.71963299999999, 32.71876299999999],
                [-114.76438199999998, 32.64266599999999],
                [-114.80939299999997, 32.61711899999999],
                [-114.81361299999998, 32.49427699999999],
                [-114.25077499999998, 32.32390999999999],
                [-113.78167999999997, 32.179033999999994],
                [-113.77369113008277, 32.1765470310798],
                [-113.12596099999998, 31.972779999999997]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US04",
            STATE: "4",
            NAME: "Arizona",
            CENSUSAREA: 113594.084,
            gx_id: "3",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-70.96722899999999, 43.34377699999999],
                [-70.98079699230868, 43.39263138792809],
                [-70.98681199999999, 43.414263999999996],
                [-70.95083799999998, 43.551025999999986],
                [-70.97271599999998, 43.57025499999999],
                [-70.98906699999996, 43.79243999999999],
                [-71.01126999999998, 44.30184599999998],
                [-71.03103899999998, 44.655454999999975],
                [-71.08433399999998, 45.30529299999999],
                [-71.133994, 45.24416699999999],
                [-71.22804799999999, 45.24968999999999],
                [-71.28439599999997, 45.30243399999999],
                [-71.40326699999999, 45.21534799999999],
                [-71.42675499999999, 45.129671999999985],
                [-71.49546299999999, 45.069150999999984],
                [-71.50248699999999, 45.01336699999999],
                [-71.53697999999997, 44.99417699999999],
                [-71.49391999999999, 44.91092299999999],
                [-71.55680499999998, 44.848807999999984],
                [-71.57170599999998, 44.79482999999999],
                [-71.62517999999999, 44.74397799999999],
                [-71.56177199999998, 44.650223999999994],
                [-71.55856499999999, 44.56557199999999],
                [-71.59947999999999, 44.48645499999999],
                [-71.64588999999998, 44.47514099999999],
                [-71.70804099999998, 44.41197699999999],
                [-71.79068799999999, 44.40025999999999],
                [-71.81247299999998, 44.358477],
                [-72.03313599999998, 44.32036499999999],
                [-72.06777399999999, 44.27097599999999],
                [-72.06616599999998, 44.18977299999998],
                [-72.04008199999998, 44.15574899999999],
                [-72.03373899999998, 44.07882999999999],
                [-72.11698499999999, 43.99447999999999],
                [-72.12100199999998, 43.918955999999994],
                [-72.18791599999999, 43.85612599999998],
                [-72.18484699999998, 43.80469799999998],
                [-72.23271299999998, 43.748285999999986],
                [-72.30286699999998, 43.70271799999999],
                [-72.32773438916803, 43.615662856925255],
                [-72.33238199999998, 43.599363999999994],
                [-72.37312599999998, 43.579419],
                [-72.38089399999998, 43.49339399999999],
                [-72.41337699999998, 43.36274099999998],
                [-72.39546199999998, 43.31299399999999],
                [-72.43522099999997, 43.258482999999984],
                [-72.45688999999999, 43.146557999999985],
                [-72.43297199999998, 43.11965499999999],
                [-72.46025199999998, 43.04067099999998],
                [-72.46090499999998, 43.035961],
                [-72.47382699999999, 42.97204499999999],
                [-72.53455399999999, 42.949893999999986],
                [-72.55283399999998, 42.884967999999986],
                [-72.54278399999998, 42.80848199999999],
                [-72.45851899999998, 42.726852999999984],
                [-71.98140199999999, 42.71329399999999],
                [-71.92881099999998, 42.71223399999998],
                [-71.29420499999998, 42.69698999999999],
                [-71.24550399999998, 42.742588999999974],
                [-71.18180299999999, 42.73759],
                [-71.18610399999999, 42.790688999999986],
                [-71.13250299999999, 42.82138899999999],
                [-71.064201, 42.806288999999985],
                [-71.03120099999998, 42.85908899999999],
                [-70.93079899999998, 42.88458899999999],
                [-70.81729599999998, 42.87228999999999],
                [-70.81068099999999, 42.90688699999998],
                [-70.70469599999998, 43.07098899999999],
                [-70.80870799999998, 43.11706499999999],
                [-70.81999915569469, 43.12258558719359],
                [-70.81311899999999, 43.21725199999999],
                [-70.80967, 43.224560999999994],
                [-70.81185199999999, 43.22830599999998],
                [-70.81401899999999, 43.22905300000001],
                [-70.96722899999999, 43.34377699999999]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US33",
            STATE: "33",
            NAME: "New Hampshire",
            CENSUSAREA: 8952.651,
            gx_id: "30",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-106.12553399999997, 32.002532999999985],
                [-105.42928099999997, 32.00057699999999],
                [-104.53175599999999, 32.000117],
                [-103.72285300262797, 32.0002083832182],
                [-103.06442299999999, 32.00051799999999],
                [-103.06469599999997, 32.522192999999994],
                [-103.06462499999998, 32.99989899999999],
                [-103.05665499999998, 33.388438],
                [-103.04361699999998, 34.00363300000001],
                [-103.04359399999997, 34.46266],
                [-103.04278099999998, 34.85024299999999],
                [-103.04155399999998, 35.622486999999985],
                [-103.04082399999997, 36.05523099999999],
                [-103.04192399999998, 36.50043899999999],
                [-103.00243399999998, 36.50039699999999],
                [-103.002199, 37.00010399999999],
                [-103.73324699999999, 36.99801599999999],
                [-104.51925699999998, 36.993766],
                [-104.64502899999997, 36.99337799999999],
                [-105.02922799999997, 36.99272899999998],
                [-105.15504227164197, 36.99533914636009],
                [-105.62746999999997, 36.995678999999996],
                [-106.50058899999998, 36.99376799999999],
                [-106.61715899999997, 36.99296699999999],
                [-106.66134399999997, 36.99324299999999],
                [-106.75059099999997, 36.992461],
                [-106.87729199999997, 37.000139],
                [-107.42091299999997, 37.000004999999994],
                [-108.00062299999998, 37.00000099999999],
                [-108.25063499999997, 36.99956099999999],
                [-108.37920295280998, 36.99945894507209],
                [-108.62030899999998, 36.99928699999998],
                [-109.04522299999996, 36.99908399999999],
                [-109.04543099999997, 36.50000099999999],
                [-109.04572899999997, 36.11702799999999],
                [-109.04601099999998, 35.925895999999995],
                [-109.04602418552197, 35.17549898440889],
                [-109.04618199999997, 34.522393],
                [-109.04700599999998, 34.000049999999995],
                [-109.04746999999998, 33.25006299999999],
                [-109.04711599999997, 33.13799499999999],
                [-109.04711699999997, 32.77757],
                [-109.04828599999998, 32.08911399999999],
                [-109.050044, 31.33250199999999],
                [-108.20857299999999, 31.333394999999992],
                [-108.20839399999997, 31.783598999999995],
                [-107.42249499999998, 31.783598999999995],
                [-107.00056, 31.783512999999992],
                [-106.52854299999998, 31.783906999999992],
                [-106.53474299999998, 31.796106999999996],
                [-106.53515399999999, 31.797088999999993],
                [-106.57724399999996, 31.81040599999999],
                [-106.63592599999998, 31.866235000000007],
                [-106.61848599999998, 32.000495],
                [-106.56514199999998, 32.000736],
                [-106.41107499999997, 32.00133399999999],
                [-106.12553399999997, 32.002532999999985]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US35",
            STATE: "35",
            NAME: "New Mexico",
            CENSUSAREA: 121298.148,
            gx_id: "32",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-74.05312499999997, 40.60367799999999],
                  [-74.08648499999997, 40.64860099999999],
                  [-74.20057999999999, 40.631448000000006],
                  [-74.21088699999999, 40.560901999999984],
                  [-74.14442799999999, 40.53516],
                  [-74.05312499999997, 40.60367799999999]
                ]
              ],
              [
                [
                  [-79.76137399999998, 41.99906699999998],
                  [-79.38034472384487, 41.99925489640034],
                  [-78.87475899999997, 41.99755899999999],
                  [-77.83202999999999, 41.99852399999999],
                  [-77.12469299999998, 41.99939499999999],
                  [-76.74967499999998, 42.00168899999999],
                  [-76.34372199999999, 41.998346],
                  [-75.74221699999998, 41.99786399999999],
                  [-75.35957899999998, 41.999444999999994],
                  [-75.27909399999999, 41.93891699999999],
                  [-75.26381499999998, 41.87075699999999],
                  [-75.11439899999996, 41.84358299999998],
                  [-75.10463999999997, 41.77420299999999],
                  [-75.05343099999999, 41.752537999999994],
                  [-75.04422399999999, 41.617977999999994],
                  [-75.07461299999997, 41.605711],
                  [-74.98437199999996, 41.50661099999999],
                  [-74.90918099999998, 41.47243599999999],
                  [-74.888691, 41.43825899999999],
                  [-74.75858699999998, 41.42328699999999],
                  [-74.69491399999998, 41.35742299999999],
                  [-74.30199399999998, 41.17259399999999],
                  [-73.90267999999999, 40.99729699999999],
                  [-73.92900599999999, 40.889577999999986],
                  [-74.01378399999999, 40.75660099999999],
                  [-74.02454299999998, 40.70943599999998],
                  [-74.04241196299849, 40.62484744614049],
                  [-73.95005006362787, 40.57336304589549],
                  [-73.93451199999998, 40.54517499999999],
                  [-73.77492799999997, 40.59075899999999],
                  [-73.56237199999998, 40.58370300000001],
                  [-73.31925699999998, 40.635794999999995],
                  [-73.20843999999998, 40.63088399999999],
                  [-73.05496299999999, 40.666370999999984],
                  [-72.76815199999999, 40.76158699999999],
                  [-72.39584999999998, 40.86665999999998],
                  [-72.11444799999998, 40.972085],
                  [-71.87390999999998, 41.052277999999994],
                  [-71.91938499999998, 41.08051699999999],
                  [-72.09545599999998, 40.991348999999985],
                  [-72.16289799999998, 41.053186999999994],
                  [-72.26051499999998, 41.042064999999994],
                  [-72.35608699999999, 41.133634999999984],
                  [-72.39699999999999, 41.09630699999999],
                  [-72.58532699999998, 40.99758699999999],
                  [-72.68934145522688, 40.989776224950994],
                  [-72.77410399999998, 40.965313999999985],
                  [-73.14078499999998, 40.96617799999997],
                  [-73.14899399999999, 40.92889799999999],
                  [-73.22928499999998, 40.905121],
                  [-73.35276099999999, 40.92669699999999],
                  [-73.40086199999998, 40.95399699999999],
                  [-73.49994099999998, 40.91816599999998],
                  [-73.63377099999998, 40.89819799999999],
                  [-73.71367399999997, 40.870098999999996],
                  [-73.78136925704668, 40.79490693007259],
                  [-73.81557382075609, 40.83512868967738],
                  [-73.75677599999999, 40.912599],
                  [-73.68647299999998, 40.94519799999999],
                  [-73.65733599999999, 40.985170999999994],
                  [-73.65877199999998, 40.993496999999984],
                  [-73.65557099999997, 41.00769699999999],
                  [-73.67997299999998, 41.04179699999999],
                  [-73.71687499999999, 41.087595999999984],
                  [-73.727775, 41.10069599999998],
                  [-73.48270899999997, 41.21275999999999],
                  [-73.55096099999999, 41.29542199999999],
                  [-73.54897299999999, 41.32629699999998],
                  [-73.54472799999998, 41.36637499999999],
                  [-73.53426899999997, 41.47639399999999],
                  [-73.53414999999998, 41.478059999999985],
                  [-73.53006699999999, 41.527194],
                  [-73.52001699999998, 41.641197],
                  [-73.48731399999998, 42.049637999999995],
                  [-73.50814199999996, 42.08625699999999],
                  [-73.35252699999998, 42.51000199999999],
                  [-73.26495699999998, 42.74593999999998],
                  [-73.278673, 42.83340999999999],
                  [-73.25649299999998, 43.25924899999998],
                  [-73.24682099999998, 43.52577999999998],
                  [-73.30207599999999, 43.62436399999999],
                  [-73.42790999999997, 43.634427999999986],
                  [-73.35059299999999, 43.77193899999998],
                  [-73.35202527972044, 43.77364807793444],
                  [-73.39275099999998, 43.822195999999984],
                  [-73.39587799999998, 43.90304399999999],
                  [-73.3969340494648, 43.9050549610854],
                  [-73.39725599999998, 43.90566799999999],
                  [-73.41077599999998, 44.026943999999986],
                  [-73.43773999999998, 44.04500599999998],
                  [-73.39080499999999, 44.18907199999998],
                  [-73.31102499999999, 44.274239999999985],
                  [-73.33357499999998, 44.37228799999998],
                  [-73.29603099999999, 44.42833899999998],
                  [-73.29988499999997, 44.47665199999999],
                  [-73.38981999999999, 44.61721],
                  [-73.36556099999997, 44.74178599999998],
                  [-73.33544299999998, 44.80460199999999],
                  [-73.38135899999999, 44.84502099999999],
                  [-73.33848199999997, 44.924111999999994],
                  [-73.352886, 44.980643999999984],
                  [-73.35411199999999, 44.98406199999998],
                  [-73.34312399999999, 45.01083999999998],
                  [-73.87459699999998, 45.00122299999998],
                  [-74.14681399999998, 44.991499999999995],
                  [-74.68397299999998, 44.999689999999994],
                  [-74.73130099999999, 44.990421999999995],
                  [-74.82657799999997, 45.01585000000001],
                  [-74.90795599999998, 44.983358999999986],
                  [-74.97246299999996, 44.98340199999999],
                  [-75.06624472462639, 44.9301740610892],
                  [-75.24130299999999, 44.86695799999997],
                  [-75.50590299999999, 44.705081],
                  [-75.76622999999998, 44.51585099999999],
                  [-75.82082999999999, 44.43224399999998],
                  [-75.91298499999998, 44.36808399999997],
                  [-76.00099799999998, 44.347533999999996],
                  [-76.16183299999999, 44.280776999999986],
                  [-76.16426499999999, 44.23960299999999],
                  [-76.24548699999997, 44.203668999999984],
                  [-76.31264699999997, 44.199043999999994],
                  [-76.32518889377552, 44.176303831065376],
                  [-76.36697159103338, 44.100409450830995],
                  [-76.30420696240418, 44.05944463715129],
                  [-76.26673299999999, 43.99557799999998],
                  [-76.13429594655807, 43.95472598397088],
                  [-76.12728499999999, 43.897888999999985],
                  [-76.28330700222367, 43.8439231984789],
                  [-76.22926799999998, 43.80413499999999],
                  [-76.19659599999999, 43.649760999999984],
                  [-76.20347299999997, 43.57497799999999],
                  [-76.23583399999997, 43.52925599999999],
                  [-76.29710299999998, 43.51286999999999],
                  [-76.41063599999998, 43.523158999999985],
                  [-76.63077399999997, 43.41335599999999],
                  [-76.69835999999997, 43.34443599999999],
                  [-76.952174, 43.27069199999998],
                  [-77.11186599999998, 43.28794499999999],
                  [-77.39101499999998, 43.27636299999998],
                  [-77.57722299999999, 43.24326299999999],
                  [-77.75693099999998, 43.337360999999994],
                  [-77.97643799999999, 43.369158999999975],
                  [-78.10450899999998, 43.375628000000006],
                  [-78.23360899999999, 43.36906999999999],
                  [-78.48885699999998, 43.374762999999994],
                  [-78.63434599999997, 43.357623999999994],
                  [-79.07046899999999, 43.262453999999984],
                  [-79.04236599999997, 43.14365499999998],
                  [-79.07446699999997, 43.077855],
                  [-79.01052992613617, 43.06438862003339],
                  [-79.01156299999997, 42.985255999999985],
                  [-78.93235999999999, 42.95585699999999],
                  [-78.85945599999997, 42.84135799999999],
                  [-78.85345499999998, 42.78395799999999],
                  [-78.91815699999997, 42.73725799999999],
                  [-79.04885999999998, 42.68915799999999],
                  [-79.14872299999998, 42.55367199999999],
                  [-79.24288899999998, 42.531757],
                  [-79.35198914531138, 42.488920276686585],
                  [-79.38034472384487, 42.46668321188368],
                  [-79.42911899999997, 42.42837999999999],
                  [-79.64535799999997, 42.31563099999999],
                  [-79.76195099999997, 42.269859999999994],
                  [-79.761709, 42.11898999999998],
                  [-79.76179799999998, 42.019041999999985],
                  [-79.76137399999998, 41.99906699999998]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US36",
            STATE: "36",
            NAME: "New York",
            CENSUSAREA: 47126.399,
            gx_id: "33",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-97.95020501151556, 49.00051511893839],
                [-98.86903699999996, 49.00020499999999],
                [-99.37606799999996, 48.99935699999998],
                [-99.91377999999996, 48.999048999999985],
                [-100.43398099999997, 48.99941],
                [-101.12543399999998, 48.99907799999998],
                [-102.216993, 48.998552999999994],
                [-103.37546699999997, 48.99895099999998],
                [-104.04873599999998, 48.999876999999984],
                [-104.04821199999998, 48.59905499999999],
                [-104.04324199999999, 47.74710599999998],
                [-104.04478799999997, 47.12742999999998],
                [-104.04527098971299, 46.6414430068147],
                [-104.04509845443599, 46.54092899334059],
                [-104.045443, 45.94531],
                [-103.28410899999997, 45.94515199999999],
                [-102.88025199999998, 45.94506899999999],
                [-102.70487099999997, 45.94507199999998],
                [-101.97374899999997, 45.94445599999999],
                [-101.17569299999997, 45.94398299999999],
                [-101.17107399999998, 45.943958999999985],
                [-100.62768099999998, 45.94364199999998],
                [-99.75039599999997, 45.94093499999999],
                [-99.25774499999997, 45.94005999999998],
                [-98.41451799999997, 45.936503999999985],
                [-98.18463699999998, 45.93618299999999],
                [-98.07051499999999, 45.93617999999999],
                [-97.48196699999997, 45.93513799999999],
                [-96.56327999999996, 45.935237999999984],
                [-96.57793999999997, 46.026873999999985],
                [-96.55450699999999, 46.08397799999998],
                [-96.59566999999997, 46.21984999999999],
                [-96.59976099999999, 46.33038599999999],
                [-96.66718899999998, 46.37545799999998],
                [-96.73512338063199, 46.47889664775469],
                [-96.75207750136528, 46.582197262708384],
                [-96.79835699999998, 46.66531399999998],
                [-96.77925185705688, 46.72742943001679],
                [-96.80015999999996, 46.81966399999998],
                [-96.776558, 46.895662999999985],
                [-96.81955799999997, 46.967452999999985],
                [-96.818843327354, 47.107153516121386],
                [-96.83823309960518, 47.1963655152712],
                [-96.84109863229918, 47.38415008080809],
                [-96.86426128812339, 47.420971520310886],
                [-96.85129277154458, 47.58926399066699],
                [-96.87949599999997, 47.62057599999999],
                [-96.93917899999997, 47.76839699999999],
                [-96.98057870942317, 47.80561364082849],
                [-97.01775399999997, 47.919777999999994],
                [-97.05455399999997, 47.94627899999998],
                [-97.07564099999998, 48.05272499999999],
                [-97.14667200265437, 48.1714844606985],
                [-97.11657, 48.27966099999999],
                [-97.1477477043823, 48.35990546506171],
                [-97.13274585253737, 48.459942471036],
                [-97.16310499999997, 48.543855],
                [-97.09869670006738, 48.68753407768949],
                [-97.13608275557547, 48.727762735004895],
                [-97.175618433936, 48.85310509541459],
                [-97.23920899999999, 48.96868399999998],
                [-97.22903899999997, 49.000686999999985],
                [-97.95020501151556, 49.00051511893839]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US38",
            STATE: "38",
            NAME: "North Dakota",
            CENSUSAREA: 69000.798,
            gx_id: "35",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-82.21485985670382, 41.45399808880069],
                [-82.25467799999997, 41.434441],
                [-82.36178399999997, 41.426643999999996],
                [-82.481214, 41.38134199999998],
                [-82.61695199999997, 41.42842499999999],
                [-82.72191399999998, 41.516676999999994],
                [-82.85676999999998, 41.548262],
                [-82.93436899999998, 41.514352999999986],
                [-82.99991599999998, 41.53853399999998],
                [-83.06659299999998, 41.59533999999999],
                [-83.23165999999996, 41.644217999999995],
                [-83.32682499999997, 41.701561999999974],
                [-83.35707299999997, 41.68776299999999],
                [-83.44603199999999, 41.70684699999998],
                [-83.45383199999996, 41.73264699999999],
                [-84.36041629527847, 41.70662461933579],
                [-84.80608199999999, 41.69608899999999],
                [-84.80391899999996, 41.43553099999999],
                [-84.80216999999996, 40.80060099999999],
                [-84.80391699999997, 40.31011499999999],
                [-84.81312404251976, 39.865525450228866],
                [-84.814179, 39.814212],
                [-84.82015699999998, 39.10547999999999],
                [-84.75444899999997, 39.14665799999999],
                [-84.63244599999999, 39.07675999999999],
                [-84.50974299999997, 39.093659999999986],
                [-84.47054199999997, 39.12145999999999],
                [-84.42984099999998, 39.05826199999999],
                [-84.30469799999997, 39.00645499999998],
                [-84.28816399999997, 38.95578899999999],
                [-84.23445299999999, 38.893226],
                [-84.21290399999998, 38.80570699999999],
                [-84.07149099999997, 38.770475],
                [-83.97881399999997, 38.787103999999985],
                [-83.85902799999998, 38.756792999999995],
                [-83.78361999999998, 38.69564099999999],
                [-83.77215999999997, 38.65815],
                [-83.66811099999998, 38.628068000000006],
                [-83.61573599999998, 38.684144999999994],
                [-83.52095299999998, 38.70304499999999],
                [-83.46805899999997, 38.67546999999999],
                [-83.36666099999998, 38.65853699999999],
                [-83.29419299999998, 38.59658799999998],
                [-83.23951499999998, 38.628588],
                [-83.14283599999997, 38.62507599999999],
                [-83.102746, 38.67731599999998],
                [-83.03301399999998, 38.723804999999984],
                [-82.89419299999997, 38.75657599999999],
                [-82.86989199999996, 38.72817699999999],
                [-82.84718599999997, 38.595165999999985],
                [-82.80011199999998, 38.56318299999999],
                [-82.72484599999997, 38.557599999999994],
                [-82.61380199999998, 38.47452899999999],
                [-82.59367299999998, 38.42180899999999],
                [-82.52957899999997, 38.40518199999999],
                [-82.40488199999999, 38.43934699999999],
                [-82.32399899999999, 38.44926799999999],
                [-82.29127099999998, 38.578983],
                [-82.21896699999998, 38.59168299999999],
                [-82.21485985670384, 38.59169388670311],
                [-82.20517099999996, 38.59171899999999],
                [-82.17206599999999, 38.62598399999998],
                [-82.18246699999997, 38.708782],
                [-82.21485985670382, 38.7896716952213],
                [-82.21726899999999, 38.79567999999998],
                [-82.21485985670382, 38.79717232504754],
                [-82.14486699999996, 38.840479999999985],
                [-82.14316699999998, 38.89807899999999],
                [-82.03596299999998, 39.02547799999999],
                [-81.93318599999998, 38.987659],
                [-81.88923299999998, 38.874279],
                [-81.81423499999998, 38.946167999999986],
                [-81.76425299999998, 39.01527899999999],
                [-81.81165499999999, 39.059578],
                [-81.75235299999997, 39.08987799999999],
                [-81.75625399999998, 39.177275999999985],
                [-81.69133899999997, 39.22794699999999],
                [-81.67833099999999, 39.273754999999994],
                [-81.57024699999998, 39.26767499999999],
                [-81.55754699999997, 39.338773999999994],
                [-81.45614299999998, 39.40927399999999],
                [-81.34756699999998, 39.34576999999999],
                [-81.27071599999996, 39.38591399999999],
                [-81.22358099999998, 39.38606199999998],
                [-81.18594599999999, 39.43073099999999],
                [-81.134434, 39.445074999999996],
                [-81.02389999999998, 39.552313],
                [-80.93329199999997, 39.614811999999986],
                [-80.88035999999997, 39.62070599999998],
                [-80.87900972253594, 39.622682294942955],
                [-80.87600199999999, 39.627083999999996],
                [-80.86533899999996, 39.75325099999999],
                [-80.79313099999999, 39.863750999999986],
                [-80.80339399999998, 39.91876199999999],
                [-80.74012599999998, 39.97079299999999],
                [-80.70460199999998, 40.15482299999999],
                [-80.59989499999998, 40.31766899999999],
                [-80.61119499999997, 40.437766999999994],
                [-80.59919399999997, 40.48256599999999],
                [-80.66691699999998, 40.57366399999999],
                [-80.62717099999998, 40.61993599999998],
                [-80.51899099999997, 40.638801],
                [-80.51900199999999, 40.87754299999997],
                [-80.51976399999998, 40.89985799999998],
                [-80.51869299999998, 41.24885499999999],
                [-80.51942499999997, 41.97752299999999],
                [-80.90034199999998, 41.86891199999999],
                [-81.01048999999998, 41.85396199999999],
                [-81.24867199999998, 41.76129099999999],
                [-81.28692499999998, 41.760242999999996],
                [-81.44264499999998, 41.67325499999998],
                [-81.59974699999997, 41.56064899999999],
                [-81.74475499999998, 41.487149999999986],
                [-81.93786199999998, 41.49144299999999],
                [-82.01196599999999, 41.51563899999999],
                [-82.19337499999997, 41.464539999999985],
                [-82.21485985670382, 41.45399808880069]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US39",
            STATE: "39",
            NAME: "Ohio",
            CENSUSAREA: 40860.694,
            gx_id: "36",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-95.04902499999999, 33.86408999999998],
                [-94.96440099999997, 33.83702099999999],
                [-94.91961350347559, 33.78630510336219],
                [-94.83080431826019, 33.74006802234809],
                [-94.77506443437147, 33.75503815486819],
                [-94.70785806967648, 33.686876245991094],
                [-94.65226503578657, 33.6909791044549],
                [-94.48587499999998, 33.63786699999999],
                [-94.48557699999996, 33.65330999999999],
                [-94.48451999999996, 33.68790899999999],
                [-94.48184199999999, 33.78900799999999],
                [-94.48136099999996, 33.80264899999999],
                [-94.47029232714209, 34.18986399999999],
                [-94.46542499999998, 34.35954799999999],
                [-94.46367099999996, 34.41958499999999],
                [-94.46344916312619, 34.427321705562264],
                [-94.46114899999996, 34.50745699999999],
                [-94.43846999999997, 35.208586999999994],
                [-94.43757799999999, 35.23093599999999],
                [-94.43757799999999, 35.24220199999999],
                [-94.43581199999997, 35.27129999999999],
                [-94.43121499999998, 35.39428999999999],
                [-94.52290999999998, 35.93612699999999],
                [-94.52463999999996, 35.94572699999999],
                [-94.57439499999997, 36.22999599999999],
                [-94.57507099999997, 36.233681999999995],
                [-94.61531099999996, 36.48499199999999],
                [-94.61791899999999, 36.49941399999998],
                [-94.61807999999998, 36.99813499999999],
                [-95.40768299999996, 36.999240999999984],
                [-96.00080999999999, 36.998859999999986],
                [-96.50028799999997, 36.998642999999994],
                [-97.46227999999996, 36.998684999999995],
                [-98.35407299999997, 36.99796099999999],
                [-99.02933699999997, 36.99959500000001],
                [-99.64865199999997, 36.99960399999999],
                [-100.201676, 37.00208099999999],
                [-100.61965527615514, 36.99991182904871],
                [-100.73451699999998, 36.99905899999999],
                [-101.35779699999999, 36.99627099999999],
                [-102.04223999999998, 36.99308299999999],
                [-102.18427099999997, 36.99359299999999],
                [-102.69814199999998, 36.995148999999984],
                [-103.002199, 37.00010399999999],
                [-103.00243399999998, 36.50039699999999],
                [-102.25045299999998, 36.50036899999999],
                [-101.62391499999997, 36.49952799999999],
                [-101.08515599999998, 36.49924399999999],
                [-100.64834399999997, 36.499463],
                [-100.61965527615513, 36.49946932573566],
                [-100.59261399999997, 36.49946899999999],
                [-100.00040599999998, 36.49970199999999],
                [-100.00039899999997, 36.05567699999999],
                [-100.000392, 35.619115],
                [-100.00038360336798, 35.030384996158894],
                [-100.00038099999998, 34.56050899999999],
                [-99.94571999999998, 34.579273],
                [-99.88714699999997, 34.549046999999995],
                [-99.75424799999998, 34.421288999999994],
                [-99.69646199999997, 34.38103600000001],
                [-99.60002599999997, 34.37468799999999],
                [-99.58005999999996, 34.41665299999999],
                [-99.49987499999997, 34.40960799999999],
                [-99.44075999999997, 34.37412299999998],
                [-99.39725299999996, 34.377871],
                [-99.39495599999997, 34.442098999999985],
                [-99.26132099999998, 34.40349899999999],
                [-99.21313499999997, 34.34036899999999],
                [-99.18951099999998, 34.21431199999999],
                [-99.04347099999997, 34.198208],
                [-99.00076099999997, 34.21764299999999],
                [-98.92312899999996, 34.18597799999999],
                [-98.92095533450659, 34.183698573729686],
                [-98.92070399999997, 34.18343499999998],
                [-98.76556999999998, 34.13637599999999],
                [-98.69007199999997, 34.13315499999999],
                [-98.64807299999997, 34.16444099999999],
                [-98.57713599999997, 34.14896199999999],
                [-98.48632799999997, 34.06259799999997],
                [-98.417813, 34.083028999999996],
                [-98.36402299999997, 34.15710899999999],
                [-98.30020899999997, 34.13457899999999],
                [-98.16911999999996, 34.11417099999999],
                [-98.11941699999997, 34.08447399999999],
                [-98.08283899999998, 34.002411999999985],
                [-97.94594999999997, 33.988395999999995],
                [-97.96777699999998, 33.88242999999999],
                [-97.86576499999998, 33.84939299999999],
                [-97.83433299999999, 33.85767099999999],
                [-97.67177199999996, 33.99136999999999],
                [-97.58882799999996, 33.95188199999999],
                [-97.55154099999997, 33.89794699999999],
                [-97.50095999999998, 33.919643],
                [-97.46037599999998, 33.90394799999999],
                [-97.462857, 33.84177199999999],
                [-97.37294099999997, 33.81945399999999],
                [-97.33652400825417, 33.8728272432604],
                [-97.27153199999997, 33.862559999999995],
                [-97.21092099999997, 33.91606399999999],
                [-97.16662899999997, 33.84731099999999],
                [-97.20543099999999, 33.801488],
                [-97.17219199999998, 33.73754499999999],
                [-97.09715399999997, 33.72780899999999],
                [-97.09477099999998, 33.798531999999994],
                [-96.98556699999996, 33.88652199999999],
                [-96.99502299999996, 33.93203499999999],
                [-96.92211399999997, 33.95957899999998],
                [-96.86643799999997, 33.85314900000001],
                [-96.79427599999997, 33.86888599999999],
                [-96.76158799999997, 33.82440599999998],
                [-96.69070799999999, 33.84995899999999],
                [-96.67344899999996, 33.91227799999999],
                [-96.59734799999997, 33.875100999999994],
                [-96.62315499999998, 33.841483],
                [-96.52665499999996, 33.82089099999999],
                [-96.50026799999996, 33.77258299999999],
                [-96.422643, 33.77604099999999],
                [-96.342665, 33.68697499999998],
                [-96.27726899999998, 33.76973499999999],
                [-96.22902299999997, 33.74802099999999],
                [-96.16945199999996, 33.77013099999999],
                [-96.14806999999996, 33.837799],
                [-96.04883399999997, 33.83646799999998],
                [-95.94126699999997, 33.861619],
                [-95.82824499999998, 33.83605399999999],
                [-95.71353999999997, 33.88512399999999],
                [-95.56342399999997, 33.93219299999999],
                [-95.533283, 33.88116199999998],
                [-95.40779499999996, 33.866308],
                [-95.29478935452318, 33.87538833706709],
                [-95.25309462698438, 33.905443896905794],
                [-95.23049099999997, 33.960764],
                [-95.13105599999997, 33.93692499999999],
                [-95.05986884626412, 33.87372846571991],
                [-95.04902499999999, 33.86408999999998]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US40",
            STATE: "40",
            NAME: "Oklahoma",
            CENSUSAREA: 68594.921,
            gx_id: "37",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-123.94720818599487, 45.59889397080597],
                [-123.97971499999997, 45.347723999999985],
                [-123.96416899999997, 45.317026],
                [-123.97542499999997, 45.14547599999999],
                [-124.03229599999999, 44.90080899999999],
                [-124.06674599999998, 44.831191],
                [-124.05828099999997, 44.65886599999999],
                [-124.05914663078131, 44.65348735220194],
                [-124.08360099999999, 44.501122999999986],
                [-124.12240599999998, 44.10444199999999],
                [-124.16839199999997, 43.808902999999994],
                [-124.23353399999996, 43.55712999999999],
                [-124.28689599999997, 43.43629599999999],
                [-124.34158699999999, 43.351336999999994],
                [-124.40281399999998, 43.305871999999994],
                [-124.38245999999998, 43.270166999999994],
                [-124.43445099999997, 43.11598599999999],
                [-124.45691799999997, 43.00031499999999],
                [-124.55244099999997, 42.84056799999999],
                [-124.51466899999998, 42.73680600000001],
                [-124.47386399999998, 42.73267099999999],
                [-124.41677399999999, 42.661594],
                [-124.38997699999999, 42.57475799999999],
                [-124.43510499999998, 42.440162999999984],
                [-124.41098199999999, 42.25054699999998],
                [-124.36100899999997, 42.18075199999999],
                [-124.35622899999997, 42.11495199999999],
                [-124.29964899999999, 42.051736],
                [-124.21160499999996, 41.99845999999999],
                [-123.72815599999997, 41.997006999999996],
                [-123.62455399999999, 41.99983699999999],
                [-123.23076199999998, 42.00384499999999],
                [-123.15490799999999, 42.00803599999998],
                [-123.04525399999997, 42.00304899999999],
                [-122.15540799999997, 42.00742899999997],
                [-122.00031899999996, 42.00396699999998],
                [-121.52024999999998, 41.99798299999999],
                [-121.43960999999999, 41.997079999999976],
                [-121.37610099999998, 41.99702599999999],
                [-121.34051699999999, 41.99622],
                [-121.30998099999996, 41.997612],
                [-121.24761599999998, 41.997054],
                [-120.69221899999997, 41.993677],
                [-120.50106899999999, 41.99378499999998],
                [-119.99916799999998, 41.99453999999999],
                [-119.72572999999997, 41.99629599999999],
                [-119.49408211078116, 41.99567172560256],
                [-119.44459799999998, 41.99547799999999],
                [-118.69640899999997, 41.991793999999985],
                [-118.19718899999998, 41.99699499999998],
                [-117.62373099999998, 41.998466999999984],
                [-117.44306199999997, 41.99965899999999],
                [-117.02622199999998, 42.00025199999999],
                [-117.02666499999997, 42.62487799999999],
                [-117.02665199999997, 43.025128],
                [-117.02687071938098, 43.832478675777985],
                [-116.98234699999999, 43.86883999999999],
                [-116.969842417282, 43.96758777352018],
                [-116.93448499999998, 44.02124899999999],
                [-116.97735099999998, 44.08536399999999],
                [-116.93370399999999, 44.10003899999998],
                [-116.89593099999998, 44.15429499999999],
                [-116.97167499999998, 44.19725599999998],
                [-116.97590499999997, 44.24284399999999],
                [-117.05650999999999, 44.23087399999999],
                [-117.10420799999997, 44.27993999999999],
                [-117.17034199999999, 44.258889999999994],
                [-117.21697399999998, 44.28835699999998],
                [-117.18976899999997, 44.336584999999985],
                [-117.24267499999998, 44.39654799999998],
                [-117.22593199999999, 44.47938899999999],
                [-117.14416099999998, 44.54564699999999],
                [-117.12052199999997, 44.61465799999999],
                [-117.04421699999997, 44.745140000000006],
                [-116.93469999999999, 44.783880999999994],
                [-116.83198999999996, 44.93300699999999],
                [-116.84794399999997, 45.02260199999999],
                [-116.73121599999999, 45.13993399999999],
                [-116.67379299999997, 45.32151099999999],
                [-116.54867599999999, 45.51038499999999],
                [-116.46363499999998, 45.60278499999998],
                [-116.53539599999996, 45.69173399999999],
                [-116.53569799999997, 45.734231],
                [-116.593004, 45.77854099999998],
                [-116.66534399999998, 45.78199799999999],
                [-116.69807899999998, 45.82085199999999],
                [-116.78267599999998, 45.825375999999984],
                [-116.91598899999997, 45.995412999999985],
                [-117.47514799999998, 45.99789299999998],
                [-118.12619699999996, 46.00028199999998],
                [-118.98712899999997, 45.99985499999999],
                [-119.12611999999997, 45.932858999999986],
                [-119.25714999999997, 45.939925999999986],
                [-119.36439599999999, 45.921604999999985],
                [-119.62339299999996, 45.905638999999994],
                [-119.66987699999999, 45.85686699999999],
                [-119.77292699999998, 45.845578],
                [-119.96574399999999, 45.82436499999999],
                [-120.17045299999997, 45.76195099999998],
                [-120.21075399999998, 45.725950999999974],
                [-120.40395999999997, 45.69924899999999],
                [-120.50586299999999, 45.70004799999998],
                [-120.55946499999997, 45.73834799999999],
                [-120.65967136566474, 45.73084057433112],
                [-120.66886899999999, 45.73014699999998],
                [-120.67393845261509, 45.726611942640865],
                [-120.68936999999998, 45.71584699999998],
                [-120.85567399999998, 45.67154499999999],
                [-120.91587599999997, 45.64134500000001],
                [-120.93163687078533, 45.649815914313166],
                [-120.94397699999999, 45.656444999999984],
                [-121.08493299999999, 45.647892999999996],
                [-121.18384099999996, 45.60644099999999],
                [-121.21577899999997, 45.67123799999998],
                [-121.33776999999996, 45.704949],
                [-121.40173899999996, 45.692886999999985],
                [-121.53310599999999, 45.72654099999999],
                [-121.73510399999999, 45.69403899999999],
                [-121.81130399999996, 45.706760999999986],
                [-121.90826699999997, 45.65439899999999],
                [-122.10167499999997, 45.583515999999996],
                [-122.18369499999999, 45.57769599999998],
                [-122.24899299999997, 45.54774499999998],
                [-122.33150199999999, 45.54824099999998],
                [-122.38030199999997, 45.575940999999986],
                [-122.47465899999999, 45.57830499999999],
                [-122.67500799999996, 45.61803899999999],
                [-122.76380999999998, 45.65713799999999],
                [-122.76010799999996, 45.734412999999996],
                [-122.79560499999997, 45.80999999999999],
                [-122.78502599999997, 45.86769899999998],
                [-122.81399799999997, 45.96098399999998],
                [-122.90411899999997, 46.083734],
                [-123.11590399999999, 46.185267999999986],
                [-123.16641399999999, 46.18897299999999],
                [-123.28016599999997, 46.14484299999999],
                [-123.37143299999998, 46.14637199999998],
                [-123.43084699999997, 46.18182699999999],
                [-123.42762899999997, 46.22934799999999],
                [-123.479644, 46.26913099999998],
                [-123.54765899999998, 46.25910899999999],
                [-123.70666699999997, 46.19966499999998],
                [-123.82183399999998, 46.19029299999998],
                [-123.85480075711898, 46.15734174183267],
                [-124.01034399999999, 46.22351399999999],
                [-123.93336599999998, 46.071671999999985],
                [-123.93747099999997, 45.97730599999997],
                [-123.99370299999998, 45.94643099999998],
                [-123.96762999999997, 45.90780699999999],
                [-123.96856299999999, 45.757019],
                [-123.93900499999997, 45.66192299999998],
                [-123.94720818599487, 45.59889397080597]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US41",
            STATE: "41",
            NAME: "Oregon",
            CENSUSAREA: 95988.013,
            gx_id: "38",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-74.75858699999998, 41.42328699999999],
                [-74.888691, 41.43825899999999],
                [-74.90918099999998, 41.47243599999999],
                [-74.98437199999996, 41.50661099999999],
                [-75.07461299999997, 41.605711],
                [-75.04422399999999, 41.617977999999994],
                [-75.05343099999999, 41.752537999999994],
                [-75.10463999999997, 41.77420299999999],
                [-75.11439899999996, 41.84358299999998],
                [-75.26381499999998, 41.87075699999999],
                [-75.27909399999999, 41.93891699999999],
                [-75.35957899999998, 41.999444999999994],
                [-75.74221699999998, 41.99786399999999],
                [-76.34372199999999, 41.998346],
                [-76.74967499999998, 42.00168899999999],
                [-77.12469299999998, 41.99939499999999],
                [-77.83202999999999, 41.99852399999999],
                [-78.87475899999997, 41.99755899999999],
                [-79.76137399999998, 41.99906699999998],
                [-79.76179799999998, 42.019041999999985],
                [-79.761709, 42.11898999999998],
                [-79.76195099999997, 42.269859999999994],
                [-79.93132399999998, 42.206737],
                [-80.06107999999998, 42.14485699999999],
                [-80.13621299999998, 42.14993700000001],
                [-80.18808499999997, 42.094256999999985],
                [-80.32997599999997, 42.03616799999999],
                [-80.51942499999997, 41.97752299999999],
                [-80.51869299999998, 41.24885499999999],
                [-80.51976399999998, 40.89985799999998],
                [-80.51900199999999, 40.87754299999997],
                [-80.51899099999997, 40.638801],
                [-80.51895999999996, 40.078089],
                [-80.51934199999998, 39.721403],
                [-79.85313099999998, 39.72071299999999],
                [-79.47666199999996, 39.72107799999999],
                [-79.39245838263568, 39.72143054603039],
                [-79.04554799999998, 39.72288299999999],
                [-78.53770199999998, 39.72248999999999],
                [-77.53475799999998, 39.72013399999998],
                [-76.99090299999999, 39.71979999999999],
                [-76.41878399999999, 39.72120399999999],
                [-75.788359, 39.72181099999998],
                [-75.70120799999997, 39.80260599999999],
                [-75.61725099999998, 39.833999],
                [-75.49884299999997, 39.83331199999999],
                [-75.41504099999999, 39.80178599999999],
                [-75.33043299999999, 39.84901199999999],
                [-75.27115899999998, 39.84944],
                [-75.15072099999998, 39.88271299999999],
                [-75.13011999999996, 39.95871199999999],
                [-74.93221099999998, 40.06841099999998],
                [-74.86380899999999, 40.08220999999999],
                [-74.81630699999998, 40.12761],
                [-74.72566299999998, 40.14549499999999],
                [-74.77040599999998, 40.21450799999998],
                [-74.84230799999999, 40.25050799999998],
                [-74.86820899999998, 40.29520699999999],
                [-74.93971099999999, 40.33800599999999],
                [-74.96399699999998, 40.395245999999986],
                [-75.05610199999998, 40.416065999999994],
                [-75.06861499999998, 40.54222299999999],
                [-75.10032499999998, 40.567810999999985],
                [-75.19404599999999, 40.57625599999999],
                [-75.20391999999998, 40.69149799999999],
                [-75.17158699999999, 40.77774499999999],
                [-75.10850499999997, 40.791093999999994],
                [-75.05366399999998, 40.873659999999994],
                [-75.13057499999998, 40.991092999999985],
                [-75.02577699999998, 41.039806],
                [-74.98221199999996, 41.10824499999998],
                [-74.88213899999998, 41.18083599999999],
                [-74.83836599999997, 41.27728599999999],
                [-74.75323899999997, 41.346122],
                [-74.69491399999998, 41.35742299999999],
                [-74.75858699999998, 41.42328699999999]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US42",
            STATE: "42",
            NAME: "Pennsylvania",
            CENSUSAREA: 44742.703,
            gx_id: "39",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-90, 35.54103064046952],
                [-89.95577999999998, 35.533213999999994],
                [-89.95771499999998, 35.52719199999999],
                [-89.91078899999998, 35.54751499999999],
                [-89.91742399999997, 35.55030799999999],
                [-89.95792399999996, 35.58549899999999],
                [-89.95674899999999, 35.59051099999999],
                [-89.90602899999996, 35.61614499999999],
                [-89.89699899999998, 35.614881999999994],
                [-89.858935, 35.669059999999995],
                [-89.86478199999998, 35.67038499999999],
                [-89.93103599999996, 35.660044],
                [-89.95027799999997, 35.73849299999999],
                [-89.86387399999997, 35.74759199999999],
                [-89.84634299999996, 35.755731999999995],
                [-89.82492299999997, 35.75571499999999],
                [-89.78179299999996, 35.805083999999994],
                [-89.72342599999996, 35.80938199999999],
                [-89.706085, 35.81825999999999],
                [-89.70926099999997, 35.83891099999999],
                [-89.74942399999996, 35.852954999999994],
                [-89.76568899999997, 35.89129899999999],
                [-89.64671099999997, 35.90800799999999],
                [-89.65227899999998, 35.92146199999999],
                [-89.67111699999998, 35.93579499999999],
                [-89.69987099999999, 35.95406299999999],
                [-89.73309499999996, 36.00060799999999],
                [-89.95937534200068, 35.999020009829394],
                [-89.95989299999998, 35.999019999999994],
                [-90, 35.99876271685745],
                [-90.37788999999997, 35.995682999999985],
                [-90.29787799999998, 36.104825999999996],
                [-90.29449199999998, 36.11294899999999],
                [-90.23558499999999, 36.139473999999986],
                [-90.18578999999997, 36.20467399999999],
                [-90.17969499999997, 36.20826199999999],
                [-90.17328099999997, 36.210300999999994],
                [-90.16116599999997, 36.215766999999985],
                [-90.06397999999999, 36.303037999999994],
                [-90.07466799999999, 36.34479399999999],
                [-90.07537599999998, 36.35014799999999],
                [-90.07668899999999, 36.39586699999998],
                [-90.08042599999997, 36.400762999999976],
                [-90.12871899999996, 36.41165899999999],
                [-90.13500199999997, 36.41372099999998],
                [-90.13865299999998, 36.41454699999999],
                [-90.13491499999999, 36.41690199999999],
                [-90.13423099999999, 36.42282699999999],
                [-90.13558999999998, 36.42289699999999],
                [-90.13756499999997, 36.43191299999999],
                [-90.13399299999998, 36.43790599999999],
                [-90.15946199999996, 36.48760899999999],
                [-90.15599699999999, 36.49038499999999],
                [-90.15248099999997, 36.49795199999999],
                [-90.87377499999998, 36.49807399999998],
                [-90.87686699999996, 36.49842299999999],
                [-91.50013999999997, 36.49881199999999],
                [-91.53686999999998, 36.499155999999985],
                [-91.64258999999997, 36.49933499999999],
                [-91.68602599999997, 36.49937399999999],
                [-92.44412899999998, 36.49852599999999],
                [-92.516836, 36.49873799999999],
                [-92.77233299999997, 36.49777199999998],
                [-93.39607899999997, 36.498668999999985],
                [-93.50740799999998, 36.498911],
                [-93.58428099999996, 36.498895999999974],
                [-94.09858799999996, 36.49867599999998],
                [-94.11067299999996, 36.498586999999986],
                [-94.55928999999996, 36.499495999999986],
                [-94.61531099999996, 36.48499199999999],
                [-94.57507099999997, 36.233681999999995],
                [-94.57439499999997, 36.22999599999999],
                [-94.52463999999996, 35.94572699999999],
                [-94.52290999999998, 35.93612699999999],
                [-94.43121499999998, 35.39428999999999],
                [-94.43581199999997, 35.27129999999999],
                [-94.43757799999999, 35.24220199999999],
                [-94.43757799999999, 35.23093599999999],
                [-94.43846999999997, 35.208586999999994],
                [-94.46114899999996, 34.50745699999999],
                [-94.46344916312619, 34.427321705562264],
                [-94.46367099999996, 34.41958499999999],
                [-94.46542499999998, 34.35954799999999],
                [-94.47029232714209, 34.18986399999999],
                [-94.48136099999996, 33.80264899999999],
                [-94.48184199999999, 33.78900799999999],
                [-94.48451999999996, 33.68790899999999],
                [-94.48557699999996, 33.65330999999999],
                [-94.48587499999998, 33.63786699999999],
                [-94.46808599999999, 33.59943599999999],
                [-94.45399599999996, 33.59222299999999],
                [-94.45162199999999, 33.59136099999999],
                [-94.44236399999997, 33.59124299999999],
                [-94.43003899999997, 33.59112399999999],
                [-94.42598199999998, 33.58642499999999],
                [-94.39734199999997, 33.57160799999998],
                [-94.38288699999997, 33.583268],
                [-94.37807599999996, 33.57701899999999],
                [-94.39465561877299, 33.564059042448385],
                [-94.39922701237059, 33.5599032319904],
                [-94.35896999999999, 33.543229999999994],
                [-94.34894499999997, 33.54835899999999],
                [-94.333895, 33.55746099999999],
                [-94.33183299999997, 33.55334799999999],
                [-94.28358199999997, 33.58189099999999],
                [-94.28084899999996, 33.57718699999999],
                [-94.23886799999997, 33.57672199999998],
                [-94.25110799999999, 33.56527999999999],
                [-94.25228299999998, 33.56044499999999],
                [-94.18391299999999, 33.59468199999999],
                [-94.15678199999996, 33.575748999999995],
                [-94.14873199999997, 33.58019699999999],
                [-94.13514199999997, 33.571032999999986],
                [-94.13304799999997, 33.55795299999999],
                [-94.10317599999996, 33.57035],
                [-94.09743999999996, 33.57371899999999],
                [-94.06117999999998, 33.559158999999994],
                [-94.06798499999998, 33.56096099999999],
                [-94.04300899999998, 33.49303899999999],
                [-94.04318799999997, 33.47032399999999],
                [-94.04296399999998, 33.01921899999999],
                [-93.490893, 33.01844199999999],
                [-93.48950599999996, 33.01844299999999],
                [-93.30818099999998, 33.01815599999999],
                [-93.15435099999998, 33.017855999999995],
                [-92.50377599999999, 33.01216099999999],
                [-92.4604145385917, 33.01182983287821],
                [-92.06910499999998, 33.00816299999999],
                [-91.95000099999997, 33.00751999999999],
                [-91.50011799999999, 33.00678399999999],
                [-91.46040005144657, 33.00590956593519],
                [-91.32503699999998, 33.00536399999999],
                [-91.31201599999999, 33.005261999999995],
                [-91.16607299999997, 33.00410599999999],
                [-91.14242399999999, 33.02723099999999],
                [-91.12908799999998, 33.03355399999999],
                [-91.12119499999997, 33.05916599999999],
                [-91.149823, 33.081602999999994],
                [-91.17151399999997, 33.08781799999999],
                [-91.17472299999999, 33.09163999999999],
                [-91.18083599999997, 33.09836399999999],
                [-91.20016699999998, 33.10692999999999],
                [-91.183662, 33.141690999999994],
                [-91.11408699999997, 33.12983399999999],
                [-91.09320099999997, 33.136725999999996],
                [-91.08598399999997, 33.22164399999999],
                [-91.07922699999997, 33.22388899999999],
                [-91.04514099999999, 33.279014999999994],
                [-91.05236899999998, 33.28541499999999],
                [-91.05872999999998, 33.28690099999999],
                [-91.07256699999998, 33.28588499999999],
                [-91.08369399999998, 33.278557],
                [-91.09148899999997, 33.25483799999999],
                [-91.10614199999998, 33.24179899999999],
                [-91.11432499999998, 33.25295299999999],
                [-91.14221899999998, 33.34898899999999],
                [-91.09085228336377, 33.39578084908879],
                [-91.06228099999997, 33.421237999999995],
                [-91.09927698344627, 33.40824389994369],
                [-91.11376433812616, 33.393123770792386],
                [-91.16630399999997, 33.37970899999999],
                [-91.20811299999997, 33.40200699999999],
                [-91.20922, 33.40628999999999],
                [-91.13055199999998, 33.43326299999999],
                [-91.1211, 33.44356299999999],
                [-91.11797499999997, 33.45380699999999],
                [-91.12510899999997, 33.47284199999999],
                [-91.15731899999997, 33.492923],
                [-91.16401895476238, 33.497448455982386],
                [-91.17714834524007, 33.486170389054195],
                [-91.17563499999999, 33.471760999999994],
                [-91.21027499999997, 33.433795999999994],
                [-91.21737399999999, 33.434698999999995],
                [-91.21550799999997, 33.46477999999999],
                [-91.20853499999997, 33.468605999999994],
                [-91.18736699999998, 33.51055199999998],
                [-91.21567099999999, 33.529422999999994],
                [-91.22632499999999, 33.541199999999996],
                [-91.23229499999997, 33.552788],
                [-91.22146599999998, 33.56816599999999],
                [-91.20315099999998, 33.57075799999999],
                [-91.16075499999998, 33.581351999999995],
                [-91.15214799999998, 33.58272099999999],
                [-91.13920899999997, 33.625657999999994],
                [-91.21128399999996, 33.658525999999995],
                [-91.21904799999997, 33.66150299999999],
                [-91.22056999999998, 33.69292299999999],
                [-91.21207699999997, 33.69824899999999],
                [-91.20071199999997, 33.70153499999999],
                [-91.16584599999997, 33.70513299999999],
                [-91.08412599999998, 33.65732199999999],
                [-91.03040199999998, 33.68776599999999],
                [-91.03611999999998, 33.689113],
                [-91.06828999999996, 33.71647699999999],
                [-91.14473199999996, 33.726803],
                [-91.10731799999998, 33.77061899999999],
                [-90.99121999999998, 33.77679099999999],
                [-90.98846599999999, 33.78452999999999],
                [-91.06497699999997, 33.837126],
                [-91.07119499999996, 33.84953899999999],
                [-91.01083099999998, 33.92555199999999],
                [-91.08792099999997, 33.975334999999994],
                [-91.01888999999997, 34.00315099999999],
                [-91.00498099999997, 33.97701099999999],
                [-90.98794799999999, 34.019037999999995],
                [-90.88699099999997, 34.035094],
                [-90.88905799999998, 34.04636199999999],
                [-90.87660599999998, 34.092910999999994],
                [-90.88262799999997, 34.09661499999999],
                [-90.95846699999997, 34.12510499999999],
                [-90.9543, 34.13849799999999],
                [-90.894385, 34.160953],
                [-90.87683599999998, 34.148129999999995],
                [-90.89187099999998, 34.184765999999996],
                [-90.91604799999996, 34.196915999999995],
                [-90.93521999999997, 34.219049999999996],
                [-90.93715199999998, 34.234109999999994],
                [-90.84000899999997, 34.22307699999999],
                [-90.84012799999998, 34.23010399999999],
                [-90.83240699999996, 34.26749099999999],
                [-90.82826699999998, 34.27364999999999],
                [-90.74088899999997, 34.30653799999998],
                [-90.75619699999999, 34.36725599999998],
                [-90.65854199999997, 34.37570499999998],
                [-90.56650499999998, 34.42952799999999],
                [-90.58547699999998, 34.46124699999999],
                [-90.58992099999998, 34.48479299999999],
                [-90.58352999999998, 34.50408499999999],
                [-90.58266673832343, 34.50713985891997],
                [-90.58106199999997, 34.51281799999999],
                [-90.54589099999998, 34.563257],
                [-90.58722399999996, 34.615731999999994],
                [-90.58732299999998, 34.665407],
                [-90.58841899999999, 34.67096299999999],
                [-90.54007399999998, 34.68498099999999],
                [-90.53806099999997, 34.67323199999999],
                [-90.54761399999997, 34.631656],
                [-90.53716499999999, 34.627766999999984],
                [-90.49663899999997, 34.64811699999999],
                [-90.47971799999996, 34.65993399999999],
                [-90.46604099999996, 34.67431199999999],
                [-90.48696599999997, 34.70147699999999],
                [-90.50984699999998, 34.69800299999999],
                [-90.52208399999996, 34.69660499999999],
                [-90.53897399999997, 34.69878299999999],
                [-90.56723999999998, 34.733463],
                [-90.56354399999998, 34.73867099999999],
                [-90.54381133919127, 34.749277416798094],
                [-90.54263099999997, 34.76439599999999],
                [-90.54761199999997, 34.78458899999999],
                [-90.54022199999999, 34.79576799999999],
                [-90.50549399999998, 34.76456799999999],
                [-90.52055637096758, 34.75338811110509],
                [-90.52189968313387, 34.74353705687669],
                [-90.51831749421777, 34.732790464096595],
                [-90.51473528794708, 34.72965604011779],
                [-90.48886499999998, 34.723730999999994],
                [-90.46989699999997, 34.72703],
                [-90.45693499999997, 34.82338299999999],
                [-90.46615399999997, 34.89098899999999],
                [-90.45391599999998, 34.89112199999999],
                [-90.41486399999998, 34.83184599999999],
                [-90.35217399999996, 34.85319599999999],
                [-90.34037999999997, 34.86035699999999],
                [-90.302669, 34.85436599999999],
                [-90.30369799999997, 34.859703999999994],
                [-90.25009499999999, 34.90731999999999],
                [-90.28223399999997, 34.967661],
                [-90.29308299999997, 34.97457399999998],
                [-90.30929699999997, 34.99569399999999],
                [-90.29559599999997, 35.04009299999999],
                [-90.26529599999998, 35.04029299999999],
                [-90.25649499999999, 35.03449299999998],
                [-90.22479099999998, 35.02996099999999],
                [-90.19714571845417, 35.0507310934728],
                [-90.19513304620858, 35.06179299516848],
                [-90.18138699999999, 35.09140099999999],
                [-90.17360299999997, 35.11807299999998],
                [-90.09294419796117, 35.15722849737549],
                [-90.0997774077099, 35.16447404617809],
                [-90.109177, 35.17845099999999],
                [-90.11421399999996, 35.181690999999994],
                [-90.07875043598527, 35.22780588603339],
                [-90.11649299999998, 35.255787999999995],
                [-90.13211599999998, 35.25317999999999],
                [-90.16887099999998, 35.28199699999999],
                [-90.163812, 35.29611499999999],
                [-90.16122499999997, 35.29895099999998],
                [-90.15339399999996, 35.30258799999999],
                [-90.13239299999998, 35.300487999999994],
                [-90.12186399999999, 35.304534999999994],
                [-90.10881699999999, 35.342586999999995],
                [-90.10029399999998, 35.35161899999999],
                [-90.07797099999996, 35.38450099999999],
                [-90.09358899999998, 35.39333299999999],
                [-90.13512499999997, 35.41297699999999],
                [-90.14165999999997, 35.408562999999994],
                [-90.14492399999999, 35.37463299999998],
                [-90.172388, 35.37768099999999],
                [-90.17926499999999, 35.38519399999999],
                [-90.17059899999997, 35.418352],
                [-90.10772299999998, 35.47693499999998],
                [-90.06779799999998, 35.46622399999999],
                [-90.05664380940267, 35.403785568649994],
                [-90.04530599999998, 35.41543499999999],
                [-90.031584, 35.427661999999984],
                [-90.02930999999997, 35.435244999999995],
                [-90.01899799999997, 35.46780299999999],
                [-90.03497599999999, 35.48070499999999],
                [-90.03974399999998, 35.548041],
                [-90, 35.54103064046952]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US05",
            STATE: "5",
            NAME: "Arkansas",
            CENSUSAREA: 52035.477,
            gx_id: "4",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-71.13749199999998, 41.60256099999999],
                  [-71.13288799999998, 41.66010199999998],
                  [-71.19117799999998, 41.674215999999994],
                  [-71.19438445922408, 41.67480268783479],
                  [-71.19564017911648, 41.675090493932785],
                  [-71.27186202176779, 41.62398571920229],
                  [-71.33083129107989, 41.51836396031558],
                  [-71.31651901825029, 41.47756024046478],
                  [-71.24061369828728, 41.500556525050186],
                  [-71.19016728377379, 41.484285110172394],
                  [-71.12056999999999, 41.497448],
                  [-71.13161799999999, 41.593917999999995],
                  [-71.13749199999998, 41.60256099999999]
                ]
              ],
              [
                [
                  [-71.78699399999998, 41.655991999999976],
                  [-71.79768299999999, 41.41670899999998],
                  [-71.83964899999998, 41.41211899999998],
                  [-71.8295953412471, 41.34454408411419],
                  [-71.86051349672418, 41.32024831782729],
                  [-71.72073999999998, 41.331566999999986],
                  [-71.62450499999998, 41.36086999999999],
                  [-71.48329499999998, 41.371722],
                  [-71.41840362548828, 41.472652435302685],
                  [-71.40377044677729, 41.58932113647459],
                  [-71.40930175781249, 41.66264343261718],
                  [-71.35005659791048, 41.7278345896374],
                  [-71.29121696732477, 41.70266554785448],
                  [-71.22479768283088, 41.71049765010409],
                  [-71.26139199999999, 41.75230099999998],
                  [-71.32789599999997, 41.78050099999999],
                  [-71.38169999999998, 41.89319899999999],
                  [-71.38140099999997, 42.01879799999999],
                  [-71.79924199999998, 42.00806499999999],
                  [-71.79276699999998, 41.80700099999999],
                  [-71.78967799999998, 41.72473399999999],
                  [-71.78967156483328, 41.72456918396718],
                  [-71.78699399999998, 41.655991999999976]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US44",
            STATE: "44",
            NAME: "Rhode Island",
            CENSUSAREA: 1033.814,
            gx_id: "40",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-72.43297199999998, 43.11965499999999],
                [-72.45688999999999, 43.146557999999985],
                [-72.43522099999997, 43.258482999999984],
                [-72.39546199999998, 43.31299399999999],
                [-72.41337699999998, 43.36274099999998],
                [-72.38089399999998, 43.49339399999999],
                [-72.37312599999998, 43.579419],
                [-72.33238199999998, 43.599363999999994],
                [-72.32773438916804, 43.615662856925255],
                [-72.30286699999998, 43.70271799999999],
                [-72.23271299999998, 43.748285999999986],
                [-72.18484699999998, 43.80469799999998],
                [-72.18791599999999, 43.85612599999998],
                [-72.12100199999998, 43.918955999999994],
                [-72.11698499999999, 43.99447999999999],
                [-72.03373899999998, 44.07882999999999],
                [-72.04008199999998, 44.15574899999999],
                [-72.06616599999998, 44.18977299999998],
                [-72.06777399999999, 44.27097599999999],
                [-72.03313599999998, 44.32036499999999],
                [-71.81247299999998, 44.358477],
                [-71.79068799999999, 44.40025999999999],
                [-71.70804099999998, 44.41197699999999],
                [-71.64588999999998, 44.47514099999999],
                [-71.59947999999999, 44.48645499999999],
                [-71.55856499999999, 44.56557199999999],
                [-71.56177199999998, 44.650223999999994],
                [-71.62517999999999, 44.74397799999999],
                [-71.57170599999998, 44.79482999999999],
                [-71.55680499999998, 44.848807999999984],
                [-71.49391999999999, 44.91092299999999],
                [-71.53697999999997, 44.99417699999999],
                [-71.50248699999999, 45.01336699999999],
                [-72.31007299999999, 45.003821999999985],
                [-72.84563299999998, 45.016659],
                [-73.34312399999999, 45.01083999999998],
                [-73.35411199999999, 44.98406199999998],
                [-73.352886, 44.980643999999984],
                [-73.33848199999997, 44.924111999999994],
                [-73.38135899999999, 44.84502099999999],
                [-73.33544299999998, 44.80460199999999],
                [-73.36556099999997, 44.74178599999998],
                [-73.38981999999999, 44.61721],
                [-73.29988499999997, 44.47665199999999],
                [-73.29603099999999, 44.42833899999998],
                [-73.33357499999998, 44.37228799999998],
                [-73.31102499999999, 44.274239999999985],
                [-73.39080499999999, 44.18907199999998],
                [-73.43773999999998, 44.04500599999998],
                [-73.41077599999998, 44.026943999999986],
                [-73.39725599999998, 43.90566799999999],
                [-73.39587799999998, 43.90304399999999],
                [-73.39275099999998, 43.822195999999984],
                [-73.35202527972044, 43.77364807793444],
                [-73.35059299999999, 43.77193899999998],
                [-73.42790999999997, 43.634427999999986],
                [-73.30207599999999, 43.62436399999999],
                [-73.24682099999998, 43.52577999999998],
                [-73.25649299999998, 43.25924899999998],
                [-73.278673, 42.83340999999999],
                [-73.26495699999998, 42.74593999999998],
                [-72.45851899999998, 42.726852999999984],
                [-72.54278399999998, 42.80848199999999],
                [-72.55283399999998, 42.884967999999986],
                [-72.53455399999999, 42.949893999999986],
                [-72.47382699999999, 42.97204499999999],
                [-72.46090499999998, 43.035961],
                [-72.46025199999998, 43.04067099999998],
                [-72.43297199999998, 43.11965499999999]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US50",
            STATE: "50",
            NAME: "Vermont",
            CENSUSAREA: 9216.657,
            gx_id: "46",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-122.51597899999999, 48.32041899999999],
                  [-122.58516199999997, 48.35330399999998],
                  [-122.58503799999998, 48.39516599999999],
                  [-122.66465899999997, 48.401507999999986],
                  [-122.67373099999998, 48.35468299999998],
                  [-122.76993899999997, 48.227548],
                  [-122.67955599999998, 48.15511299999999],
                  [-122.60956799999998, 48.15186],
                  [-122.60734199999997, 48.03099199999999],
                  [-122.52121899999997, 47.972996999999985],
                  [-122.47265999999998, 47.98844899999999],
                  [-122.43103499999997, 47.91473199999999],
                  [-122.35074099999997, 47.953234999999985],
                  [-122.37625899999999, 48.03445699999999],
                  [-122.44841899999997, 48.054322999999975],
                  [-122.55820499999999, 48.119579],
                  [-122.60640599999996, 48.20826199999999],
                  [-122.66838499999997, 48.22396699999998],
                  [-122.61846599999997, 48.294159],
                  [-122.51953499999995, 48.28831399999999],
                  [-122.51597899999999, 48.32041899999999]
                ]
              ],
              [
                [
                  [-122.51332847757499, 47.44910589548769],
                  [-122.52812849999998, 47.34554199999998],
                  [-122.49312249999998, 47.33025299999999],
                  [-122.40176711225298, 47.38132506668929],
                  [-122.43993069156998, 47.41700728953889],
                  [-122.43338549999999, 47.46642999999999],
                  [-122.474683522932, 47.511067515155986],
                  [-122.51332847757499, 47.44910589548769]
                ]
              ],
              [
                [
                  [-122.74304899999997, 48.661990999999986],
                  [-122.87593799999996, 48.71211999999999],
                  [-122.91825199999997, 48.713504999999984],
                  [-123.04865199999999, 48.62100199999999],
                  [-123.17842499999998, 48.62211499999999],
                  [-123.16323399999999, 48.52954399999999],
                  [-123.03915599999998, 48.46000299999999],
                  [-122.92690099999997, 48.46087399999998],
                  [-122.87413499999998, 48.41819599999998],
                  [-122.80250899999997, 48.43309799999999],
                  [-122.81633199999997, 48.487840999999996],
                  [-122.77120599999998, 48.56242599999998],
                  [-122.80021699999999, 48.60168999999999],
                  [-122.74304899999997, 48.661990999999986]
                ]
              ],
              [
                [
                  [-117.04051399999997, 47.52235099999999],
                  [-117.04110699999997, 48.124903999999994],
                  [-117.03517799999999, 48.37087799999999],
                  [-117.03235099999998, 48.99918799999998],
                  [-118.19682401700898, 49.00040683675768],
                  [-118.64179715745578, 49.00071304463818],
                  [-118.83689846669598, 49.000307715095786],
                  [-119.42867799999996, 49.00025299999999],
                  [-120.00119899999997, 48.99941799999999],
                  [-120.71660399999998, 49.00018799999999],
                  [-121.75125199999998, 48.99739899999998],
                  [-122.09835699999998, 49.002146],
                  [-122.75801999999997, 49.002356999999996],
                  [-122.81722599999999, 48.955969999999986],
                  [-122.74659599999997, 48.93073099999998],
                  [-122.78565899999998, 48.88506599999998],
                  [-122.72268499999998, 48.852855],
                  [-122.69867532205697, 48.800522313485],
                  [-122.64744299999997, 48.77399799999999],
                  [-122.53580299999999, 48.776127999999986],
                  [-122.50030799999999, 48.65616299999999],
                  [-122.42527099999997, 48.59952200000001],
                  [-122.47843099999997, 48.559302999999986],
                  [-122.48350099999999, 48.49243],
                  [-122.53735499999996, 48.46674899999999],
                  [-122.615182994129, 48.52142664818919],
                  [-122.67892799999998, 48.43946599999998],
                  [-122.58160748285299, 48.429244309178586],
                  [-122.50743699999998, 48.364666],
                  [-122.40871799999996, 48.32641299999999],
                  [-122.37169299999998, 48.287838999999984],
                  [-122.40651599999998, 48.251829999999984],
                  [-122.53099599999999, 48.24982099999999],
                  [-122.53721999999996, 48.18374499999999],
                  [-122.47853499999998, 48.18808699999999],
                  [-122.39612099999998, 48.229233],
                  [-122.36507799999997, 48.125822],
                  [-122.28108699999997, 48.049792999999994],
                  [-122.23176099999998, 48.02987599999999],
                  [-122.22634599999998, 47.976416999999984],
                  [-122.30704799999998, 47.94911699999999],
                  [-122.33994399999997, 47.84671799999999],
                  [-122.39204399999998, 47.80771799999999],
                  [-122.37313999999999, 47.729218999999986],
                  [-122.42984099999997, 47.65891899999999],
                  [-122.34293699999998, 47.59121999999998],
                  [-122.40983899999999, 47.56891999999999],
                  [-122.39653799999996, 47.51521999999999],
                  [-122.32573399999997, 47.391521000000004],
                  [-122.32483299999997, 47.348520999999984],
                  [-122.42353499999997, 47.31912099999999],
                  [-122.44419999999998, 47.266722999999985],
                  [-122.52758640656299, 47.29153068305899],
                  [-122.59082859332698, 47.17810719592878],
                  [-122.67813030766298, 47.10386636798919],
                  [-122.71199659862398, 47.12768088331279],
                  [-122.54752144369499, 47.285343947397386],
                  [-122.57373899999999, 47.31841899999998],
                  [-122.53051385441297, 47.469040932619684],
                  [-122.49488199999998, 47.51026499999998],
                  [-122.54311799999998, 47.556326],
                  [-122.49393299999997, 47.588962999999985],
                  [-122.51827699999997, 47.651319999999984],
                  [-122.48849099999998, 47.74360499999998],
                  [-122.51398599999997, 47.88080699999998],
                  [-122.63635999999997, 47.866186],
                  [-122.65772199999998, 47.93115599999997],
                  [-122.71808199999997, 47.98773899999998],
                  [-122.66986799999997, 48.01721699999998],
                  [-122.69846499999998, 48.103101999999986],
                  [-122.77055899999996, 48.053431999999994],
                  [-122.87628199999997, 48.110876999999995],
                  [-122.87764099999997, 48.04702499999999],
                  [-122.97941299999998, 48.095939999999985],
                  [-123.16439999999997, 48.16589399999999],
                  [-123.24861499999999, 48.11574499999998],
                  [-123.39504799999997, 48.11424299999998],
                  [-123.59083899999997, 48.134948999999985],
                  [-123.70274299999997, 48.16678299999998],
                  [-123.77812199999997, 48.15546599999999],
                  [-123.91558899999997, 48.15935199999999],
                  [-124.05073399999996, 48.17774699999998],
                  [-124.10177299999998, 48.21688299999998],
                  [-124.23858199999998, 48.26247099999999],
                  [-124.38087399999999, 48.28469899999999],
                  [-124.59733077079797, 48.38188249016759],
                  [-124.71694699999999, 48.38977599999999],
                  [-124.65893999999999, 48.331056999999994],
                  [-124.70415299999996, 48.184421999999984],
                  [-124.73174599999999, 48.169996999999974],
                  [-124.68710099999997, 48.09865699999999],
                  [-124.67242699999998, 47.964413999999984],
                  [-124.62551199999997, 47.887962999999985],
                  [-124.48973699999996, 47.81698799999998],
                  [-124.43054599999996, 47.746248999999985],
                  [-124.35595499999997, 47.54569799999998],
                  [-124.31937899999997, 47.355559],
                  [-124.23634899999998, 47.28728699999999],
                  [-124.17674499999997, 47.092998999999985],
                  [-124.12205699999998, 47.04164999999998],
                  [-124.02634499999996, 47.030186999999984],
                  [-123.99161199999999, 46.98021499999999],
                  [-123.89824499999999, 46.971926999999994],
                  [-124.04927899999997, 46.891253],
                  [-124.13822499999999, 46.90553399999998],
                  [-124.10807799999998, 46.836387999999985],
                  [-124.09651499999998, 46.74620199999999],
                  [-124.02241299999997, 46.708972999999986],
                  [-123.87667999999998, 46.73065700000001],
                  [-123.85135599999997, 46.702559999999984],
                  [-123.96064199999999, 46.636363999999986],
                  [-123.89425399999998, 46.537027999999985],
                  [-123.94366699999998, 46.47719699999998],
                  [-124.02603199999997, 46.462977999999985],
                  [-124.06462399999998, 46.32689899999998],
                  [-123.98520399999997, 46.30903899999998],
                  [-123.90930599999999, 46.24549099999999],
                  [-123.72427299999997, 46.301160999999986],
                  [-123.66950099999998, 46.26683199999999],
                  [-123.54765899999998, 46.25910899999999],
                  [-123.479644, 46.26913099999998],
                  [-123.42762899999997, 46.22934799999999],
                  [-123.43084699999997, 46.18182699999999],
                  [-123.37143299999998, 46.14637199999998],
                  [-123.28016599999997, 46.14484299999999],
                  [-123.16641399999999, 46.18897299999999],
                  [-123.11590399999999, 46.185267999999986],
                  [-122.90411899999997, 46.083734],
                  [-122.81399799999997, 45.96098399999998],
                  [-122.78502599999997, 45.86769899999998],
                  [-122.79560499999997, 45.80999999999999],
                  [-122.76010799999996, 45.734412999999996],
                  [-122.76380999999998, 45.65713799999999],
                  [-122.67500799999996, 45.61803899999999],
                  [-122.47465899999999, 45.57830499999999],
                  [-122.38030199999997, 45.575940999999986],
                  [-122.33150199999999, 45.54824099999998],
                  [-122.24899299999997, 45.54774499999998],
                  [-122.18369499999999, 45.57769599999998],
                  [-122.10167499999997, 45.583515999999996],
                  [-121.90826699999997, 45.65439899999999],
                  [-121.81130399999996, 45.706760999999986],
                  [-121.73510399999999, 45.69403899999999],
                  [-121.53310599999999, 45.72654099999999],
                  [-121.40173899999996, 45.692886999999985],
                  [-121.33776999999996, 45.704949],
                  [-121.21577899999997, 45.67123799999998],
                  [-121.18384099999996, 45.60644099999999],
                  [-121.08493299999999, 45.647892999999996],
                  [-120.94397699999999, 45.656444999999984],
                  [-120.93163687078533, 45.649815914313166],
                  [-120.91587599999997, 45.64134500000001],
                  [-120.85567399999998, 45.67154499999999],
                  [-120.68936999999998, 45.71584699999998],
                  [-120.67393845261509, 45.726611942640865],
                  [-120.66886899999999, 45.73014699999998],
                  [-120.65967136566475, 45.730840574331125],
                  [-120.55946499999997, 45.73834799999999],
                  [-120.50586299999999, 45.70004799999998],
                  [-120.40395999999997, 45.69924899999999],
                  [-120.21075399999998, 45.725950999999974],
                  [-120.17045299999997, 45.76195099999998],
                  [-119.96574399999999, 45.82436499999999],
                  [-119.77292699999998, 45.845578],
                  [-119.67322470961265, 45.85650179010483],
                  [-119.66987699999999, 45.85686699999999],
                  [-119.62339299999996, 45.905638999999994],
                  [-119.36439599999999, 45.921604999999985],
                  [-119.25714999999997, 45.939925999999986],
                  [-119.12611999999997, 45.932858999999986],
                  [-118.98712899999997, 45.99985499999999],
                  [-118.12619699999996, 46.00028199999998],
                  [-117.47514799999998, 45.99789299999998],
                  [-116.91598899999997, 45.995412999999985],
                  [-116.95954799999997, 46.099057999999985],
                  [-116.92395799999998, 46.17091999999999],
                  [-116.98462999999997, 46.292704999999984],
                  [-117.05598299999997, 46.34553099999999],
                  [-117.03981299999997, 46.42542499999998],
                  [-117.03939799999998, 46.70018599999998],
                  [-117.03949954586702, 46.727448795835436],
                  [-117.03982799999997, 46.81544299999999],
                  [-117.03994499999999, 47.477822999999994],
                  [-117.04015038579671, 47.49390450448341],
                  [-117.04051399999997, 47.52235099999999]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US53",
            STATE: "53",
            NAME: "Washington",
            CENSUSAREA: 66455.521,
            gx_id: "48",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-120.16897399999996, 33.91908999999999],
                  [-120.12181699999996, 33.89571199999999],
                  [-119.97369099999999, 33.942481],
                  [-120.07360899999998, 34.024477],
                  [-120.24848399999996, 33.99932899999999],
                  [-120.16897399999996, 33.91908999999999]
                ]
              ],
              [
                [
                  [-119.87632899999998, 34.03208699999999],
                  [-119.87335799999997, 33.98037499999999],
                  [-119.72120599999997, 33.95958299999999],
                  [-119.66282499999998, 33.985888999999986],
                  [-119.68650699999999, 34.01980499999999],
                  [-119.78979799999996, 34.05725999999999],
                  [-119.87632899999998, 34.03208699999999]
                ]
              ],
              [
                [
                  [-118.49629799999998, 32.85157199999999],
                  [-118.42563399999997, 32.800594999999994],
                  [-118.36998399999997, 32.83927299999999],
                  [-118.49681099999997, 32.93384699999999],
                  [-118.54006899999997, 32.98093299999999],
                  [-118.57352199999998, 32.96918299999999],
                  [-118.52453099999998, 32.89548799999999],
                  [-118.49629799999998, 32.85157199999999]
                ]
              ],
              [
                [
                  [-118.48876999999997, 33.356649],
                  [-118.46536799999997, 33.326055999999994],
                  [-118.37476799999999, 33.320064999999985],
                  [-118.31021299999998, 33.33579499999998],
                  [-118.36830099999999, 33.40710999999999],
                  [-118.50021199999998, 33.44959199999999],
                  [-118.48876999999997, 33.356649]
                ]
              ],
              [
                [
                  [-119.56497099999999, 33.24743999999999],
                  [-119.47602899999997, 33.21552],
                  [-119.45846599999999, 33.25466099999999],
                  [-119.54384199999997, 33.280328999999995],
                  [-119.56497099999999, 33.24743999999999]
                ]
              ],
              [
                [
                  [-123.04525399999997, 42.00304899999999],
                  [-123.15490799999999, 42.00803599999998],
                  [-123.23076199999998, 42.00384499999999],
                  [-123.62455399999999, 41.99983699999999],
                  [-123.6772972910234, 41.99840793200385],
                  [-123.72815599999997, 41.997006999999996],
                  [-124.21160499999996, 41.99845999999999],
                  [-124.20340199999997, 41.94096399999999],
                  [-124.21959199999998, 41.846431999999986],
                  [-124.25599399999997, 41.78301399999999],
                  [-124.14347899999999, 41.70928399999999],
                  [-124.13555199999998, 41.65730699999999],
                  [-124.08198699999998, 41.547760999999994],
                  [-124.06307599999997, 41.43957899999998],
                  [-124.10698599999998, 41.229677999999986],
                  [-124.1438, 41.144686],
                  [-124.15362199999998, 41.05354999999999],
                  [-124.11216499999998, 41.02817299999998],
                  [-124.15832199999997, 40.87606899999999],
                  [-124.32940399999998, 40.616429999999994],
                  [-124.40959099999998, 40.43807599999999],
                  [-124.37359899999998, 40.392922999999975],
                  [-124.34785299999999, 40.31463399999998],
                  [-124.36341399999999, 40.26097399999999],
                  [-124.18787399999998, 40.130541999999984],
                  [-124.11054899999998, 40.10376499999999],
                  [-124.07998299999997, 40.029772999999985],
                  [-124.03590399999999, 40.01331899999999],
                  [-123.93004699999999, 39.909696999999994],
                  [-123.90766399999998, 39.86302799999999],
                  [-123.85171399999999, 39.83204099999998],
                  [-123.82954499999997, 39.72307099999999],
                  [-123.8246749798411, 39.71793179175886],
                  [-123.79265899999999, 39.68412199999999],
                  [-123.76647499999997, 39.55280299999999],
                  [-123.81468999999998, 39.44653799999998],
                  [-123.82630599999997, 39.36870999999999],
                  [-123.80384799999999, 39.27877099999999],
                  [-123.69396899999998, 39.05736299999998],
                  [-123.72536699999999, 38.91743799999999],
                  [-123.64738699999997, 38.845471999999994],
                  [-123.44177399999997, 38.69974399999999],
                  [-123.33189899999996, 38.565541999999986],
                  [-123.24979699999997, 38.51104499999999],
                  [-123.12882499999998, 38.45041799999999],
                  [-123.06826499999997, 38.35986499999999],
                  [-123.07468399999998, 38.32257399999999],
                  [-123.00412199999997, 38.29701199999999],
                  [-122.96856899999997, 38.24287899999999],
                  [-122.94907399999997, 38.15406000000001],
                  [-123.01153299999999, 38.00343799999999],
                  [-122.93971099999999, 38.031907999999994],
                  [-122.82138299999997, 37.99673499999997],
                  [-122.70263999999999, 37.89381999999999],
                  [-122.65651899999997, 37.90451899999999],
                  [-122.50538299999998, 37.82212799999999],
                  [-122.47647302766799, 37.83251342297159],
                  [-122.47230271468098, 37.90257295281689],
                  [-122.49030157306197, 37.96475085777849],
                  [-122.49128332020997, 38.10808728036549],
                  [-122.40357975474198, 38.15063005527501],
                  [-122.314567190962, 38.11528681547359],
                  [-122.26286134225498, 38.044600353310486],
                  [-122.41372459154199, 37.937261634008784],
                  [-122.38918067184198, 37.91009970500169],
                  [-122.30998564930697, 37.892755341020695],
                  [-122.303931499613, 37.830086541874195],
                  [-122.33079021269099, 37.783830407356994],
                  [-122.26410135933297, 37.764666941934294],
                  [-122.24682600988, 37.721929686736786],
                  [-122.163049471057, 37.66793308622779],
                  [-122.14701412599798, 37.58841078082039],
                  [-122.11134365405897, 37.507579502467784],
                  [-122.16844912476597, 37.504143349397495],
                  [-122.262697738869, 37.5728662966529],
                  [-122.36021887729099, 37.59250141798518],
                  [-122.38607178896098, 37.637662214885495],
                  [-122.37041125718397, 37.71757233990209],
                  [-122.40745179565398, 37.811440911176796],
                  [-122.51448299999998, 37.78082899999999],
                  [-122.49678399999996, 37.686432999999994],
                  [-122.51668899999997, 37.52133999999999],
                  [-122.45208699999998, 37.48054],
                  [-122.40084999999998, 37.35922499999998],
                  [-122.41845199999997, 37.24852099999999],
                  [-122.40507299999997, 37.19579099999999],
                  [-122.28488199999997, 37.10174699999998],
                  [-122.20617999999999, 37.01394899999999],
                  [-122.10597599999998, 36.955951],
                  [-121.97277099999997, 36.95415099999999],
                  [-121.93006899999999, 36.97814999999999],
                  [-121.86226599999998, 36.931551999999975],
                  [-121.78827799999996, 36.80399399999999],
                  [-121.82505199999999, 36.65720700000001],
                  [-121.87136399999997, 36.60455899999999],
                  [-121.92386599999999, 36.63455899999999],
                  [-121.97042699999997, 36.582753999999994],
                  [-121.93250799999997, 36.55993499999998],
                  [-121.9416, 36.48560199999999],
                  [-121.90181299999999, 36.38187899999999],
                  [-121.89471399999996, 36.31780599999999],
                  [-121.81373399999997, 36.234235],
                  [-121.71717599999997, 36.19514599999999],
                  [-121.62963399999997, 36.11445199999999],
                  [-121.57460199999997, 36.02515599999999],
                  [-121.50311199999999, 36.00029899999999],
                  [-121.46226399999998, 35.885617999999994],
                  [-121.33244899999997, 35.78310599999999],
                  [-121.28497299999998, 35.674108999999994],
                  [-121.16671199999998, 35.63539899999999],
                  [-121.10159499999997, 35.54881399999999],
                  [-121.00335899999997, 35.460709999999985],
                  [-120.90793699999998, 35.449068999999994],
                  [-120.86920899999997, 35.403276000000005],
                  [-120.86719999999998, 35.327154],
                  [-120.89678999999997, 35.24787699999999],
                  [-120.85604699999998, 35.20648699999999],
                  [-120.78607599999997, 35.17766599999999],
                  [-120.69890599999998, 35.17119199999999],
                  [-120.63578699999997, 35.12380499999999],
                  [-120.62993099999998, 35.06151499999999],
                  [-120.67083499999997, 34.90411499999999],
                  [-120.60989799999999, 34.84275099999999],
                  [-120.63741499999999, 34.75589499999999],
                  [-120.60196999999998, 34.692094999999995],
                  [-120.64573899999998, 34.58103499999999],
                  [-120.51142099999998, 34.522952999999994],
                  [-120.47137599999996, 34.447846],
                  [-120.30182199999997, 34.46707699999998],
                  [-120.14116499999999, 34.47340499999999],
                  [-120.00807699999997, 34.46044700000001],
                  [-119.87397099999997, 34.40879499999999],
                  [-119.79477099999997, 34.41759699999998],
                  [-119.70906699999999, 34.39539699999999],
                  [-119.67186599999997, 34.41609599999999],
                  [-119.55945899999999, 34.41339499999999],
                  [-119.46103599999998, 34.37406399999999],
                  [-119.27014399999997, 34.25290299999999],
                  [-119.21644099999999, 34.14610499999999],
                  [-119.13016899999998, 34.10010199999999],
                  [-119.08853599999999, 34.09830999999999],
                  [-118.95472199999998, 34.04816699999999],
                  [-118.85465299999998, 34.03421499999999],
                  [-118.80511399999997, 34.00123899999999],
                  [-118.74495199999998, 34.03210299999999],
                  [-118.56923499999998, 34.041639999999994],
                  [-118.51951399999997, 34.027508999999995],
                  [-118.44240999999997, 33.94031199999999],
                  [-118.39210699999998, 33.84091499999999],
                  [-118.42840699999998, 33.77471499999999],
                  [-118.41121099999997, 33.74198499999999],
                  [-118.25868699999997, 33.703741000000015],
                  [-118.18136699999997, 33.71736699999999],
                  [-118.18083099999998, 33.763071999999994],
                  [-118.08889599999999, 33.72981699999999],
                  [-117.92709099999999, 33.60552099999999],
                  [-117.78488799999997, 33.54152499999999],
                  [-117.72648599999998, 33.48342699999999],
                  [-117.64558199999998, 33.44072799999999],
                  [-117.59587999999998, 33.38662899999999],
                  [-117.50564999999997, 33.33406299999999],
                  [-117.32835899999998, 33.121841999999994],
                  [-117.28076999999998, 33.012342999999994],
                  [-117.25166999999998, 32.87434599999999],
                  [-117.28217, 32.83954699999999],
                  [-117.26106999999999, 32.80314799999999],
                  [-117.24606899999999, 32.66935199999999],
                  [-117.19676699999998, 32.68885099999999],
                  [-117.13946399999999, 32.627053999999994],
                  [-117.12486199999998, 32.53415599999999],
                  [-116.62704999999998, 32.57626099999999],
                  [-116.04661999999998, 32.623352999999994],
                  [-115.46516399999997, 32.6671],
                  [-114.71963299999999, 32.71876299999999],
                  [-114.68877899999997, 32.73767499999999],
                  [-114.61837299999998, 32.728244999999994],
                  [-114.52685599999997, 32.75709399999999],
                  [-114.53166899999997, 32.79118499999999],
                  [-114.46897099999997, 32.84515499999999],
                  [-114.46444799999998, 32.913129],
                  [-114.50612999999997, 33.01700999999999],
                  [-114.57165299999997, 33.03662399999999],
                  [-114.67080299999999, 33.037983999999994],
                  [-114.70789599999999, 33.097432],
                  [-114.67872899999998, 33.16294799999999],
                  [-114.67703199999998, 33.270169999999986],
                  [-114.73122299999996, 33.30243399999999],
                  [-114.70093799999997, 33.33701399999999],
                  [-114.72287199999997, 33.39877899999999],
                  [-114.62963999999997, 33.42813799999999],
                  [-114.55889799999997, 33.53181899999998],
                  [-114.53152299999996, 33.675107999999994],
                  [-114.49648899999997, 33.69690099999999],
                  [-114.52959699999997, 33.84806299999999],
                  [-114.50301699999997, 33.86799799999999],
                  [-114.53367942794698, 33.92607205327779],
                  [-114.46026439542898, 33.996648850930995],
                  [-114.41590799999997, 34.10763599999999],
                  [-114.25414099999998, 34.17383099999999],
                  [-114.16653599999997, 34.24964699999999],
                  [-114.13828199999998, 34.30323],
                  [-114.17690899999997, 34.34930599999999],
                  [-114.22610699999997, 34.36591599999999],
                  [-114.34261499999997, 34.451442000000014],
                  [-114.38669899999998, 34.45791099999999],
                  [-114.38083799999997, 34.529723999999995],
                  [-114.47161999999997, 34.712965999999994],
                  [-114.55268199999998, 34.766870999999995],
                  [-114.58684199999998, 34.83567199999999],
                  [-114.630682, 34.86635199999999],
                  [-114.63301299999998, 35.00208499999999],
                  [-114.80502999999997, 35.140283999999994],
                  [-115.50083199999997, 35.69338199999999],
                  [-116.09721599999999, 36.158345999999995],
                  [-116.375875, 36.37256199999999],
                  [-116.54198299999999, 36.49995199999999],
                  [-117.00089499999997, 36.84769399999998],
                  [-117.50090899999998, 37.22028199999998],
                  [-117.58141799999997, 37.278935999999995],
                  [-117.87592699999998, 37.497266999999994],
                  [-118.62158999999998, 38.03438899999998],
                  [-118.74659799999998, 38.12492599999999],
                  [-119.09716099999997, 38.37285299999999],
                  [-119.58767899999998, 38.71473399999999],
                  [-120.00101399999998, 38.99957399999999],
                  [-120.00574599999999, 39.22521],
                  [-120.00131900843897, 39.722416320206285],
                  [-120.00050199999997, 39.77995599999999],
                  [-119.99592599999997, 40.49990099999999],
                  [-119.99935799999997, 40.87310099999999],
                  [-119.99939129912376, 40.89356856160969],
                  [-119.99986599999997, 41.183973999999985],
                  [-119.99828699999999, 41.74989199999999],
                  [-119.99916799999998, 41.99453999999999],
                  [-120.50106899999999, 41.99378499999998],
                  [-120.69221899999997, 41.993677],
                  [-121.24761599999998, 41.997054],
                  [-121.30998099999996, 41.997612],
                  [-121.34051699999999, 41.99622],
                  [-121.37610099999998, 41.99702599999999],
                  [-121.43960999999999, 41.997079999999976],
                  [-121.52024999999998, 41.99798299999999],
                  [-122.00031899999996, 42.00396699999998],
                  [-122.15540799999997, 42.00742899999997],
                  [-123.04525399999997, 42.00304899999999]
                ]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US06",
            STATE: "6",
            NAME: "California",
            CENSUSAREA: 155779.22,
            gx_id: "5",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-106.50058899999998, 36.99376799999999],
                [-105.62746999999997, 36.995678999999996],
                [-105.15504227164197, 36.99533914636009],
                [-105.02922799999997, 36.99272899999998],
                [-104.64502899999997, 36.99337799999999],
                [-104.51925699999998, 36.993766],
                [-103.73324699999999, 36.99801599999999],
                [-103.002199, 37.00010399999999],
                [-102.69814199999998, 36.995148999999984],
                [-102.18427099999997, 36.99359299999999],
                [-102.04223999999998, 36.99308299999999],
                [-102.04195199999997, 37.02474199999999],
                [-102.04192099999997, 37.032177999999995],
                [-102.04198299999997, 37.10655099999999],
                [-102.04209199999998, 37.12502099999999],
                [-102.04196299999998, 37.258163999999994],
                [-102.04181699999997, 37.30948999999999],
                [-102.04384399999998, 37.92810199999999],
                [-102.04464399999998, 38.045531999999994],
                [-102.04526299999999, 38.50539499999999],
                [-102.04511199999999, 38.52378399999999],
                [-102.04510199999997, 38.674946],
                [-102.04512699999997, 38.68672499999998],
                [-102.045212, 38.69756699999999],
                [-102.04657099999999, 39.04703799999999],
                [-102.04718860926897, 39.133146562416286],
                [-102.04844899999999, 39.30313799999998],
                [-102.04895999999997, 39.37371199999998],
                [-102.04936999999998, 39.41820999999998],
                [-102.049679, 39.50618299999999],
                [-102.05059399999999, 39.67559399999998],
                [-102.05131799999997, 39.83331099999999],
                [-102.05174399999997, 40.00307799999999],
                [-102.05192199999998, 40.235343999999984],
                [-102.051553251676, 40.349213986395284],
                [-102.05139843250699, 40.6975418168734],
                [-102.05129199999998, 40.749590999999995],
                [-102.05161399999999, 41.00237699999999],
                [-102.92556799999998, 41.00228],
                [-102.94482999999997, 41.00230299999998],
                [-103.04344399999997, 41.002343999999994],
                [-103.05953799999997, 41.002368],
                [-103.077804, 41.002297999999996],
                [-103.39699099999997, 41.00255799999999],
                [-103.42197499999997, 41.00200699999998],
                [-103.97137299999999, 41.00152399999999],
                [-104.01822299999998, 41.001616999999975],
                [-104.03923799999997, 41.001501999999995],
                [-104.05324899999998, 41.001405999999974],
                [-104.85527299999998, 40.99804799999999],
                [-105.73042099999999, 40.99688599999999],
                [-106.21757299999997, 40.997733999999994],
                [-106.43956299999998, 41.001977999999994],
                [-106.53483785734517, 41.00229149152823],
                [-107.24119399999996, 41.00280399999999],
                [-108.25064899999997, 41.00011399999999],
                [-109.05007599999998, 41.000658999999985],
                [-109.04845499999999, 40.82608099999999],
                [-109.04837287727699, 40.66260181369999],
                [-109.05094599999997, 40.44436799999999],
                [-109.05097299999997, 40.18084899999998],
                [-109.05076499999997, 39.36667699999999],
                [-109.05243599999997, 38.99998499999999],
                [-109.05323299999998, 38.942466999999986],
                [-109.059541, 38.719888],
                [-109.06000692624244, 38.39930089875762],
                [-109.05464799999999, 38.244920999999984],
                [-109.04176199999998, 38.16468999999999],
                [-109.04180599999998, 37.604170999999994],
                [-109.04191499999997, 37.53065299999999],
                [-109.04313699999997, 37.499991999999985],
                [-109.04580999999999, 37.37499299999999],
                [-109.04597799999999, 37.20183099999999],
                [-109.04515599999998, 37.11206399999998],
                [-109.04505799999997, 37.07466099999999],
                [-109.04522299999996, 36.99908399999999],
                [-108.62030899999998, 36.99928699999998],
                [-108.37920295280998, 36.99945894507209],
                [-108.25063499999997, 36.99956099999999],
                [-108.00062299999998, 37.00000099999999],
                [-107.42091299999997, 37.000004999999994],
                [-106.87729199999997, 37.000139],
                [-106.75059099999997, 36.992461],
                [-106.66134399999997, 36.99324299999999],
                [-106.61715899999997, 36.99296699999999],
                [-106.50058899999998, 36.99376799999999]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US08",
            STATE: "8",
            NAME: "Colorado",
            CENSUSAREA: 103641.888,
            gx_id: "6",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-73.49332711441826, 41.04817307133559],
                [-73.43506299999999, 41.05669599999999],
                [-73.37229581647638, 41.104020182173805],
                [-73.26235799999998, 41.11749599999999],
                [-73.17777428627419, 41.166696891877386],
                [-73.13025299999998, 41.146796999999985],
                [-73.05064999999996, 41.210196999999994],
                [-73.01494799999996, 41.20429699999999],
                [-72.90820020655858, 41.28293191230638],
                [-72.88144499999999, 41.24259699999999],
                [-72.75444405700557, 41.26691339778368],
                [-72.57113599999998, 41.26809799999999],
                [-72.54723499999999, 41.25049899999999],
                [-72.45192499999999, 41.27888499999999],
                [-72.38662899999999, 41.26179799999999],
                [-72.20402199999998, 41.299096999999996],
                [-72.134221, 41.29939799999999],
                [-71.94565199999998, 41.33779899999999],
                [-71.86051349672418, 41.32024831782729],
                [-71.8295953412471, 41.34454408411419],
                [-71.83964899999998, 41.41211899999998],
                [-71.79768299999999, 41.41670899999998],
                [-71.78699399999998, 41.655991999999976],
                [-71.78967156483328, 41.72456918396718],
                [-71.78967799999998, 41.72473399999999],
                [-71.79276699999998, 41.80700099999999],
                [-71.79924199999998, 42.00806499999999],
                [-71.80064999999998, 42.02356899999999],
                [-72.06349599999999, 42.027346999999985],
                [-72.13568699999996, 42.030244999999994],
                [-72.69592699999998, 42.036787999999994],
                [-72.77475678567848, 42.00212911378219],
                [-72.813541, 42.03649399999999],
                [-72.86361899999999, 42.037708999999985],
                [-72.99954899999999, 42.03865299999999],
                [-73.43281199999998, 42.050586999999986],
                [-73.48731399999998, 42.049637999999995],
                [-73.52001699999998, 41.641197],
                [-73.53006699999999, 41.527194],
                [-73.53414999999998, 41.478059999999985],
                [-73.53426899999997, 41.47639399999999],
                [-73.54472799999998, 41.36637499999999],
                [-73.54897299999999, 41.32629699999998],
                [-73.55096099999999, 41.29542199999999],
                [-73.48270899999997, 41.21275999999999],
                [-73.727775, 41.10069599999998],
                [-73.71687499999999, 41.087595999999984],
                [-73.67997299999998, 41.04179699999999],
                [-73.65557099999997, 41.00769699999999],
                [-73.65877199999998, 40.993496999999984],
                [-73.65733599999999, 40.985170999999994],
                [-73.49332711441826, 41.04817307133559]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US09",
            STATE: "9",
            NAME: "Connecticut",
            CENSUSAREA: 4842.355,
            gx_id: "7",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-75.70735222602659, 38.635359213275684],
                [-75.69352099999998, 38.46012799999999],
                [-75.42872799999999, 38.45267099999999],
                [-75.04893899999998, 38.451263],
                [-75.06550999999999, 38.66103],
                [-75.08215299999996, 38.77215699999999],
                [-75.19055199999998, 38.806860999999984],
                [-75.31228199999998, 38.92459399999999],
                [-75.31835399999999, 38.98819099999999],
                [-75.39627699999998, 39.057883999999994],
                [-75.41062499999998, 39.15624599999999],
                [-75.39301499999998, 39.204511999999994],
                [-75.43902699999998, 39.313384],
                [-75.51299599999999, 39.36615299999999],
                [-75.58943899999998, 39.46081199999999],
                [-75.56303399999999, 39.56223999999999],
                [-75.61187299999999, 39.597407999999994],
                [-75.58714699999999, 39.651011999999994],
                [-75.50974199999999, 39.686113000000006],
                [-75.459439, 39.765812999999994],
                [-75.41504099999999, 39.80178599999999],
                [-75.49884299999997, 39.83331199999999],
                [-75.61725099999998, 39.833999],
                [-75.70120799999997, 39.80260599999999],
                [-75.788359, 39.72181099999998],
                [-75.78865799999998, 39.65821100000001],
                [-75.74579299999996, 39.11493499999998],
                [-75.74381099999997, 39.094674],
                [-75.72202799999998, 38.82207799999999],
                [-75.70735222602659, 38.635359213275684]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US10",
            STATE: "10",
            NAME: "Delaware",
            CENSUSAREA: 1948.543,
            gx_id: "8",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-76.90939499999998, 38.892811999999985],
                [-77.04099899999999, 38.99510999999999],
                [-77.11989999999997, 38.934310999999994],
                [-77.03169799999996, 38.850512],
                [-77.03859799999998, 38.79151299999998],
                [-76.90939499999998, 38.892811999999985]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US09",
            STATE: "9",
            NAME: "Connecticut",
            CENSUSAREA: 4842.355,
            gx_id: "7",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#00824E",
            fillOpacity: 0.5
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [-75.70735222602659, 38.635359213275684],
                [-75.69352099999998, 38.46012799999999],
                [-75.42872799999999, 38.45267099999999],
                [-75.04893899999998, 38.451263],
                [-75.06550999999999, 38.66103],
                [-75.08215299999996, 38.77215699999999],
                [-75.19055199999998, 38.806860999999984],
                [-75.31228199999998, 38.92459399999999],
                [-75.31835399999999, 38.98819099999999],
                [-75.39627699999998, 39.057883999999994],
                [-75.41062499999998, 39.15624599999999],
                [-75.39301499999998, 39.204511999999994],
                [-75.43902699999998, 39.313384],
                [-75.51299599999999, 39.36615299999999],
                [-75.58943899999998, 39.46081199999999],
                [-75.56303399999999, 39.56223999999999],
                [-75.61187299999999, 39.597407999999994],
                [-75.58714699999999, 39.651011999999994],
                [-75.50974199999999, 39.686113000000006],
                [-75.459439, 39.765812999999994],
                [-75.41504099999999, 39.80178599999999],
                [-75.49884299999997, 39.83331199999999],
                [-75.61725099999998, 39.833999],
                [-75.70120799999997, 39.80260599999999],
                [-75.788359, 39.72181099999998],
                [-75.78865799999998, 39.65821100000001],
                [-75.74579299999996, 39.11493499999998],
                [-75.74381099999997, 39.094674],
                [-75.72202799999998, 38.82207799999999],
                [-75.70735222602659, 38.635359213275684]
              ]
            ]
          },
          properties: {
            GEO_ID: "0400000US10",
            STATE: "10",
            NAME: "Delaware",
            CENSUSAREA: 1948.543,
            gx_id: "8",
            strokeColor: "#fff",
            strokeWidth: 1,
            "stroke-opacity": 1,
            fillColor: "#88c936",
            fillOpacity: 0.5
          }
        }
      ]
    };
    if (localStorage.agecheck == undefined) {
      this.agecheckpop = true;
    } else {
      if (
        localStorage.selecteccity != null &&
        localStorage.selecteccity != undefined
      ) {
        setTimeout(function() {
          self.selectedAddress = {
            title: localStorage.selecteccity,
            rtitle: localStorage.selecteccity,
            type: localStorage.selectetype,
             state:localStorage.selectedstate,
            lat: localStorage.lat,
            lng: localStorage.lng
          };

          self.$refs.townTypeahead.inputValue = localStorage.selecteccity;
          //self.$refs.clusterRef
          // self.getMarkers(localStorage.selecteccity);
        }, 500);
      } else {
        if (navigator.geolocation) {
          this.setMylocation();
        }
        //  this.getMarkers('');
      } /**/
    }

    this.mapfeatures = mapdata;

    this.setUsa();
  },
  methods: {
    searchTogle(call_from='location'){
      if(call_from=="location"){
        this.is_show_location = true;
        this.is_show_namesearch =false;
      }else{
        
        this.is_show_location = false;
        this.is_show_namesearch =true;
      }
    },
    exitPage() {
      window.location = "https://google.com";
    },
    codeLatLng(lat, lng) {
      var geocoder;
      var selectedcity;

      geocoder = new google.maps.Geocoder();

      var latlng = new google.maps.LatLng(lat, lng);
      geocoder.geocode({ latLng: latlng }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[1]) {
            //formatted address
            //  console.log(results[0]);
            for (var i = 0; i < results[0].address_components.length; i++) {
              for (
                var b = 0;
                b < results[0].address_components[i].types.length;
                b++
              ) {
                //there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
                if (results[0].address_components[i].types[b] == "locality") {
                  //this is the object you are looking for

                  selectedcity = results[0].address_components[i].long_name;

                  break;
                }
              }
            }

            //  alert("address = " + address);
          } else {
            //  alert("No results found");
          }
        } else {
          //  alert("Geocoder failed due to: " + status);
        }
      });
      var self = this;
      self.fromlocation = 1;

      setTimeout(function() {
        self.$refs.townTypeahead.inputValue = selectedcity;

        //  self.getMarkers(selectedcity);
      }, 1000); /* */
    },
      setMylocationOnMove() {
      navigator.geolocation.getCurrentPosition(position => {
                  

        if (position) {

             self.currentLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };


             self.currentLocationmarker = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };

        
        }
      });
    },
    setMylocation() {
      navigator.geolocation.getCurrentPosition(position => {
                  

        if (position) {

          this.codeLatLng(position.coords.latitude, position.coords.longitude);
          if (!this.clickedalready) {
            this.filternearbylocation(
              position.coords.latitude,
              position.coords.longitude,
              100
            );
          }
          var self = this;
          setTimeout(function() {
            self.$refs.mapRef.$mapPromise.then(map => {
              if (self.locationnearfound) {
                map.panTo({
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                });

                   localStorage.selecteccity = "";
        localStorage.selectetype = "";
        localStorage.selectedstate = "";
        localStorage.type = "City";

        localStorage.lat = position.coords.latitude;
        localStorage.lng = position.coords.longitude; 

                setTimeout(function(){

                    map.setZoom(15);

                },100)
              } else {
                self.setLogoLocation();
              }


              self.currentLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };

                     self.currentLocationmarker = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };


              
                 
            });
          }, 200);
        }
      });
    },
    clearMarkers() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
    },
    filternearbylocation(lat, lng, dist) {
      this.datastarts = true;
      var self = this;
      //  this.clearMarkers();
      this.$refs.clusterRef.$clusterObject.clearMarkers();
      //    console.log('I AM HIT');
       //this.markers = [];
      setTimeout(function() {

        _.each(json, function(item, idx) {
          if (
            geodist(
              { lat: lat, lon: lng },
              { lat: item.latitude, lon: item.longitude },
              { limit: dist }
            )
          ) {
            self.markers.push(item);
            self.locationnearfound = true;
            self.clickedalready = true;
          }
        });
               self.listmarkers = [];
        self.listmarkers =  self.markers;
        self.datastarts = false;
      }, 100);
    },
    filternearbyname(city, state) {
      this.datastarts = true;
      this.cityclicked = true;
      var self = this;
      //  this.clearMarkers();
      this.$refs.clusterRef.$clusterObject.clearMarkers();
      //    console.log('I AM HIT');
      this.markers = [];
      setTimeout(function() {
        //  console.log('I AM HIT STARTS');

        if (city == "") {
          self.markers = _.where(json, {
            state: state
          });
        } else {
          console.log(state); 
          self.markers = _.where(json, {
            city: city,
            state:state
          });
        }
        self.listmarkers = [];
        self.listmarkers =  self.markers;

        self.datastarts = false;
      //  self.cityclicked = false;
      }, 100);
    },
    filternearby(lat, lng, dist) {
      this.datastarts = true;
      var self = this;
      //  this.clearMarkers();
      // this.$refs.clusterRef.$clusterObject.clearMarkers();
      //    console.log('I AM HIT');
      //  this.markers = [];
      setTimeout(function() {
        //  console.log('I AM HIT STARTS');

      /*  var limitist = _.filter(json, function(item) {
          return geodist(
            { lat: lat, lon: lng },
            { lat: item.latitude, lon: item.longitude },
            { limit: dist }
          );
        });

        var findnotexisting = _.filter(limitist, function(item) {
          return _.where(self.markers, { id: item.id }).length == 0;
        });

        self.markers.push(findnotexisting);
         */
        _.each(json, function(item, idx) {
          var checkexisting = _.findWhere(self.markers, { id: item.id });
          if (
            checkexisting == undefined &&
            geodist(
              { lat: lat, lon: lng },
              { lat: item.latitude, lon: item.longitude },
              { limit: dist }
            )
          ) {
            self.markers.push(item);
          }
        });

      self.listmarkers = [];
        self.listmarkers =  self.markers;

        self.datastarts = false;
      }, 100);
    },
    openTel(tel){

//     window.postMessage(tel, "*")
    },
    setAge() {
      localStorage.agecheck = true;
      this.agecheckpop = false;
      if (navigator.geolocation) {
        this.setMylocation();
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    setLogoLocation() {
      this.selectedAddress = {
        title: "USA",
        rtitle: "USA",
        type: "USA",
        lat: 37.0902,
        lng: -95.7129
      };

        localStorage.selecteccity = "USA";
        localStorage.selectetype = "USA",
        localStorage.selectedstate = "USA",
        localStorage.type = "USA",

        localStorage.lat = 37.0902;
        localStorage.lng = -95.7129;  


      this.defaultType = "List";
      this.$refs.townTypeahead.inputValue = "USA";

 
          
    },
    getCneterpoint(map) {
      var bounds = map.getBounds();
      var center = bounds.getCenter();
      var ne = bounds.getNorthEast();
      // r = radius of the earth in statute miles
      var r = 3963.0;
      // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
      var lat1 = center.lat() / 57.2958;
      var lon1 = center.lng() / 57.2958;
      var lat2 = ne.lat() / 57.2958;
      var lon2 = ne.lng() / 57.2958;
      var dis =
        r *
        Math.acos(
          Math.sin(lat1) * Math.sin(lat2) +
            Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)
        );
      dis = dis / 4;

      this.filternearby(center.lat(), center.lng(), dis);

      /*
if(this.googlecircle){
  this.googlecircle.setMap(null);
}
          this.googlecircle = new google.maps.Circle({
    'center':{lat: center.lat(), lng: center.lng()},
    'clickable':false,
    'fillColor':"#00FFFF",
    'fillOpacity':0, 
    'map':map,
    'radius':500000, 
    'strokeColor':'#88c936',
    'strokeOpacity':'0.5'
});*/

      this.$refs.townTypeahead.inputValue = "";
    },
    setUsa() {
      var self = this;

      setTimeout(() => {
        //   this.getMarkers("");

        self.$refs.mapRef.$mapPromise.then(map => {
          var features = [];

          if (map.getZoom() >= 6) {
            map.data.addGeoJson(self.mapfeatures, {
              idPropertyName: "STATE"
            });

            self.toggleBodyClass("addClass", "hideMarkers");

            // self.$refs.clusterRef.$clusterObject.clearMarkers();
          }
          map.data.revertStyle();
          map.data.setStyle(function(feature) {
            return {
              fillColor: "#88c936",
              fillOpacity: 0.5,
              strokeColor: "#88c936",
              strokeWeight: 1,
              strokeOpacity: 0
            };
          });

          google.maps.event.addListener(map, "dragend", function() {
           //    self.clearMarker();
            if (self.googlecircle) {
              self.googlecircle.setMap(null);
            }
            if (
              map.getZoom() >= 6 &&
              map.getZoom() <= 11 &&
              !self.datastarts &&
              !self.cityclicked
            ) {
              self.datastarts = true;
              setTimeout(function() {
                self.getCneterpoint(map);
              }, 100);
            }
          });
          google.maps.event.addListener(map, "zoom_changed", function() {
                  if (self.markerClicked == true) {


                   }else{
                      self.$refs.brandTypeahead.inputValue = '';
                       
                      self.clearMarker();
                   }
        //    self.clearMarker();
            map.data.forEach(function(feature) {
              map.data.remove(feature);
            });

            map.data.revertStyle();
            map.data.setStyle(function(feature) {
              return {
                fillColor: "#88c936",
                fillOpacity: 0.5,
                strokeColor: "#88c936",
                strokeWeight: 1,
                strokeOpacity: 0
              };
            });

            if (self.googlecircle) {
              self.googlecircle.setMap(null);
            }

            if (
              map.getZoom() >= 6 &&
              map.getZoom() <= 11 &&
              !self.datastarts &&
              !self.cityclicked
            ) {
              self.datastarts = true;
              setTimeout(function() {
                self.getCneterpoint(map);
              }, 100);
            }

            if (map.getZoom() >= 6) {
              //  self.zoomswitcher = center.lat()+"|"+center.lng()+"|"+dis;
              //  self.getMarkersradius(center.lat(),center.lng(),dis);
              self.hidelist = true;
              self.toggleBodyClass("removeClass", "hideMarkers");

              //                self.$refs.clusterRef.$clusterObject.clearMarkers();

              //self.markers = result.data;
            } else {
              self.hidelist = true;
              map.data.addGeoJson(self.mapfeatures, {
                idPropertyName: "STATE"
              });
              self.toggleBodyClass("addClass", "hideMarkers");

              //   console.log();
              //   self.$refs.clusterRef.$clusterObject.clearMarkers();
              // self.$refs.clusterRef.$clusterObject.clearMarkers();
            }
          });
          map.data.addListener("click", function(event) {
            /*    self.$refs.mapRef.setZoom(6);

                self.$refs.mapRef.panTo({
                  lat:event.latLng.lat(),
                  lng:event.latLng.lng()
                });
*/
            if (this.googlecircle) {
              this.googlecircle.setMap(null);
            }

               setTimeout(function(){

        if (map.getZoom() <= 6) {

              self.selectedAddress = {
              title: event.feature.j.NAME,
              rtitle: event.feature.j.NAME,
              type: "STATE",
              lat: event.latLng.lat(),
              lng: event.latLng.lng()
            };
            self.$refs.townTypeahead.inputValue = event.feature.j.NAME;
                     }

            },100)

         
          });
          map.data.addListener("mouseover", function(event) {
            map.data.revertStyle();
            map.data.overrideStyle(event.feature, { strokeColor: "#76c215",strokeOpacity:0.8 });
          });

          map.data.addListener("mouseout", function(event) {
            map.data.revertStyle();
          });
        });
      }, 100);
    },
    updateMarkers(markers) {
      this.markers = markers;
    },
    getMarkersradius(latitude, longitude, dist) {
      this.markers = [];
      var self = this;
      setTimeout(function() {
        axios({
          method: "GET",
          url: RADIUS_API_URL.replace(":latitude", latitude)
            .replace(":longitude", longitude)
            .replace(":dist", dist)
        }).then(
          result => {
            if (result.data.length > 0) {
              self.$refs.clusterRef.$clusterObject.clearMarkers();

              self.updateMarkers(result.data);
            }

            self.datastarts = false;

            self.bindEvents = true;
          },
          error => {}
        );
      }, 100);
    },
    getMarkers(query) {
      this.markers = [];
      var self = this;
      self.datastarts = true;

      setTimeout(function() {
        axios({
          method: "GET",
          url: MARKERS_API_URL.replace(":query", query)
        }).then(
          result => {
            self.markers = result.data;
            self.datastarts = false;

            if (self.defaultType == "Map") {
            } else {
              self.$refs.clusterRef.$clusterObject.clearMarkers();
            }

            if (result.data.length == 0) {
              if (self.fromlocation == 1) {
                self.displaySelectLocation = false;
                localStorage.selecteccity = query;
                self.fromlocation = 0;

                self.$refs.townTypeahead.inputValue = "USA";

                self.$refs.mapRef.panTo({
                  lat: 37.0902,
                  lng: -95.7129
                });

                self.selectedAddress = {
                  title: "USA",
                  rtitle: "USA",
                  type: "USA",
                  lat: 37.0902,
                  lng: -95.7129
                };

                self.setUsa();
              } else {
                self.displaySelectLocation = false;
                localStorage.selecteccity = query;
              }
            } else {
              self.displaySelectLocation = false;
              localStorage.selecteccity = query;
            }

            self.bindEvents = true;
          },
          error => {}
        );
      }, 100);
    },
    deleteMarker(i) {
      this.markers.splice(i, 1);
    },
    onClusterClick(){
      
        return true;
    },
    setbrandevent($event){

      this.selectedBrand = {
        item:$event,
        random:Math.random()
      }

      console.log(this.selectedBrand);

    },
    onMapClick(marker) {
      //console.log(marker);
      this.markerClicked = true;
      this.selectedMarker = marker;
     
    /*

        var checkexisting = _.findWhere(this.markers, { isActive: true });
    if(checkexisting)  checkexisting.isActive = false;

      marker.isActive = true;
      var self = this;

      this.$refs.mapRef.$mapPromise.then(map => {
             map.panTo({
            lat: Number(marker.latitude),
            lng: Number(marker.longitude)
          });

        setTimeout(function() {

              map.setZoom(19);  

       
       map.panBy(0, 120);    
           self.markerClicked = false; 
        }, 100);
      });*/
      return false;
    },
    setMarker(item) {
      this.markerClicked = true;
      this.selectedMarker = item;
     
     /* item.isActive = true;
     



      this.$refs.mapRef.$mapPromise.then(map => {

       this.animateMapZoomTo(map, 17);

        map.panTo({
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        });
        map.panBy(0, 80);
      });

      this.markerClicked = false; */

      return false;
    },
    geolocation: function() {
      var self = this;

      navigator.geolocation.getCurrentPosition(
        position => {
          if (position) {
            self.currentLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };

            self.currentLocationmarker = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
          }
        },
        function(error) {
          if (error) {
            self.getMarkers("");
          }
        }
      );
    },
    clearMarker() {
      this.markerClicked = false;

      this.selectedMarker = null;
      this.markers.forEach(item => {
        item.isActive = false;
      });
    },
    clearMarkerMap(event) {
      if (this.markerClicked == true) {
      } else {
        this.selectedMarker = null;
        this.markers.forEach(item => {
          item.isActive = false;
        });
      }
    },
    switchType() {
      if (this.defaultType == "List") {
        this.defaultType = "Map";
    

      } else {
        this.defaultType = "List";

          var self = this;
    setTimeout(function(){

            if (
        localStorage.selecteccity !='' && localStorage.selecteccity != null &&
        localStorage.selecteccity != undefined
      ) {
          self.selectedAddress = {
            title: localStorage.selecteccity,
            rtitle: localStorage.selecteccity,
            type: localStorage.selectetype,
            state:localStorage.selectedstate,
            lat: localStorage.lat, 
            lng: localStorage.lng
          };


        }
    },200)
      }
    },
    getAddresses(query) {
      this.addresses = cities;
    },
    setMobileMenu(){
      if(this.mobilebrowse){
        this.mobilebrowse = false;
      }else{
        this.mobilebrowse = true;
      }
      
    },
    showVendors(vendorIds){

      
         this.clearMarker();
var stores = _.filter(json, function (item) {
  return vendorIds.indexOf(item.id) !== -1;
});
      this.storeSeleector = stores;
      this.isOffers = false;


    },
    selectOffer(id){

       var self = this;


      var item = _.findWhere(json, { id: id });

      this.selectedMarker = item;
      item.isActive = true;
      this.markerClicked = true;
      var self = this;
     console.log( item.id);

        this.selectedMarker.products = null

       this.productsloaded = false;
       axios({
          method: "GET",
          url: 'https://qanbes.com/content/wp-json/dokan/v1/stores/'+this.selectedMarker.id+'/products'}).then(
          result => {
           this.selectedMarker.products = result.data;
          this.productsloaded = true;
          })



      var checkexisting = _.findWhere(self.markers, { id: item.id });
      this.listmarkers = [];
      this.listmarkers.push(item);
  //    console.log(this.listmarkers);
       this.$refs.townTypeahead.inputValue = '';
        localStorage.selecteccity = '';
         

      if (checkexisting == undefined) this.markers.push(item);


   //   var checkexisting2 = _.findWhere(self.markers, { id: item.id });

     // this.markers = _.uniq(this.markers, 'id');



      this.$refs.mapRef.$mapPromise.then(map => {

           map.panTo({
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        });


        map.setZoom(19);

      });


             setTimeout(function() {
        self.markerClicked = false; 
      }, 100);

    },
    selectbrandalt(item){
       this.selectedMarker = item;
      item.isActive = true;
      this.markerClicked = true;
      var self = this;
     console.log(item.id);

        this.selectedMarker.products = null

       this.productsloaded = false;
       axios({
          method: "GET",
          url: 'https://qanbes.com/content/wp-json/dokan/v1/stores/'+this.selectedMarker.id+'/products'}).then(
          result => {
           this.selectedMarker.products = result.data;
          this.productsloaded = true;
          })



      var jsondata = self.markers;
      if(self.markers.length == 0) jsondata = json;
      var checkexisting = _.findWhere(jsondata, { id: item.id });
      this.listmarkers = [];
      this.listmarkers.push(item);
  //    console.log(this.listmarkers);
       this.$refs.townTypeahead.inputValue = '';
        localStorage.selecteccity = '';
         

      if (checkexisting == undefined) this.markers.push(item);


   //   var checkexisting2 = _.findWhere(self.markers, { id: item.id });

     // this.markers = _.uniq(this.markers, 'id');



      this.$refs.mapRef.$mapPromise.then(map => {

           map.panTo({
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        });


        map.setZoom(19);

      });

             setTimeout(function() {
        self.markerClicked = false; 
      }, 100);

    },
    getBrands(query) {
      var updatedjson = json;

    
      if (localStorage.selectetype == "State" || localStorage.selectetype == "STATE" ) { 


          updatedjson = _.where(json, {
            state: localStorage.selecteccity
          });


        } else if ( (localStorage.selectetype == "CITY" || localStorage.selectetype == "City") && localStorage.selectedstatelocalStorage.selectedstate!= undefined && localStorage.selecteccity!= undefined) {




          updatedjson = _.where(json, { 
            state: localStorage.selectedstate,
            city: localStorage.selecteccity
          });


        }
                         

        if( localStorage.selectedstate== 'undefined' || localStorage.selectedstate== undefined){

           console.log("localStorage.selectedstatelocalStorage.selectedstate");
      console.log(localStorage.selectedstate);
            console.log(localStorage.selectetype)


           updatedjson = this.markers;
        }
     

      this.brand = updatedjson;
    },    
    animateMapZoomTo(map, targetZoom, commandedZoom) {
  var currentZoom = commandedZoom || map.getZoom();
  var self = this;
  if (currentZoom != targetZoom) {
    google.maps.event.addListenerOnce(map, 'zoom_changed', function(event) {
      self.animateMapZoomTo(map, targetZoom, currentZoom + (targetZoom > currentZoom ? 1 : -1));
    });
    setTimeout(function() {
      map.setZoom(currentZoom + (targetZoom > currentZoom ? 1 : -1))
    }, 250);
  }
},
  animateMapZoomToPin(map, targetZoom, commandedZoom) {
  var currentZoom = commandedZoom || map.getZoom();
  var self = this;
  if (currentZoom != targetZoom) {
    google.maps.event.addListenerOnce(map, 'zoom_changed', function(event) {
      self.animateMapZoomTo(map, targetZoom, currentZoom + (targetZoom > currentZoom ? 1 : -1));
    });
    setTimeout(function() {
      map.setZoom(currentZoom + (targetZoom > currentZoom ? 1 : -1))
    }, 50);
  }
}
  },
  watch: {
    selectedMarker:_.debounce(function(item) {
      var self = this;

      if(item !=null && item.id!=null && item.id!=''){
              this.storeSeleector = null;
        self.showSlider = false;
         axios({
          method: "GET",
          url: 'https://qanbes.com/content/wp-json/api/v2/offers?vendor='+item.id}).then(
          result => {
            if(result.data.length > 0){
             self.offerbanner= result.data;
            }

            self.showSlider = true;
          })


        this.selectedMarker.products = null

       this.productsloaded = false;
         axios({
          method: "GET",
          url: 'https://qanbes.com/content/wp-json/dokan/v1/stores/'+this.selectedMarker.id+'/products'}).then(
          result => {
           this.selectedMarker.products = result.data;
           this.productsloaded = true;
          })

      this.selectedMarker.isActive = true;
      this.markerClicked = true;
      var jsondata = this.markers;
      if(self.markers.length == 0) jsondata = json;
      var checkexisting = _.findWhere(jsondata, { id: item.id });
      this.listmarkers = [];
      this.listmarkers.push(item);
     
      if (checkexisting == undefined) this.markers.push(item);

      var curmap;
      this.$refs.mapRef.$mapPromise.then(map => {

           map.panTo({
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        });
       // map.panBy(0, 120);
        map.setZoom(18);
        map.panBy(0, 120);

      });

             setTimeout(function() {
          self.markerClicked = false; 
      }, 3000);



      }else{
           this.showSlider = false;

          axios({
          method: "GET",
          url: 'https://qanbes.com/content/wp-json/api/v2/offers'}).then(
          result => {
           this.offerbanner= result.data;
           this.showSlider = true;           

          })

        
      }
        

     }, 500),
    addressSearch: _.debounce(function(addr) {
      this.getAddresses(addr);
       this.getBrands(addr);
    }, 500),
    brandSearch: _.debounce(function(addr) {
      this.getBrands(addr);
    }, 500),
    selectedBrand: _.debounce(function(item) {


      this.selectedMarker = item.item;
     
      /* item.isActive = true;
      this.markerClicked = true;
      var self = this;

      var jsondata = self.markers;
      if(self.markers.length == 0) jsondata = json;
      var checkexisting = _.findWhere(jsondata, { id: item.id });
      this.listmarkers = [];
      this.listmarkers.push(item);
  //    console.log(this.listmarkers);
       this.$refs.townTypeahead.inputValue = '';
        localStorage.selecteccity = '';
         

      if (checkexisting == undefined) this.markers.push(item);


   //   var checkexisting2 = _.findWhere(self.markers, { id: item.id });

     // this.markers = _.uniq(this.markers, 'id');



      this.$refs.mapRef.$mapPromise.then(map => {

           map.panTo({
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        });


        map.setZoom(19);

      });

             setTimeout(function() {
        self.markerClicked = false; 
      }, 100);*/
    }, 500),
    zoomswitcher: _.debounce(function(item) {
      var expl = item.split("|");

      this.getMarkersradius(
        parseFloat(expl[0]),
        parseFloat(expl[1]),
        parseFloat(expl[2])
      );
    }, 200),
    selectedAddress: _.debounce(function(item) {
     this.$refs.brandTypeahead.inputValue = '';
      /* First animate and then Panto and then get the data (to fix the flickering issue and loading issue ) */
        var self = this;
         var $map;
          this.$refs.mapRef.$mapPromise.then(map => {
            $map = map;
          if (item.type == "city" || item.type == "City") {
            this.animateMapZoomTo(map, 10);
          }
         if (item.type == "State" || item.type == "STATE") {
            map.data.forEach(function(feature) {
              map.data.remove(feature);
            });
             this.animateMapZoomTo(map, 6);
             setTimeout(function(){

               var featurecollection = [];
                    featurecollection.type = "FeatureCollection";
                    featurecollection.features = [];
                    _.each(self.mapfeatures.features, function(iteml, idx) {
                      if (iteml.properties.NAME == item.rtitle) {
                        featurecollection.features.push(iteml);
                      }
                    });
                    map.data.addGeoJson(featurecollection, {
                      idPropertyName: "STATE"
                    });
                    map.data.revertStyle();

                    map.data.setStyle(function(feature) {
                      return {
                        fillColor: "#88c936",
                        fillOpacity: 0,
                        strokeColor: "#88c936",
                        strokeWeight: 2,
                        strokeOpacity: 0.6
                      };
                    }); 
             },1000)
                 
          }
            if (item.title == "USA" || item.title == null) {
             map.setZoom(4);

            }
          });
           
            setTimeout(function(){ 
              $map.panTo({
            lat: Number(item.lat),
            lng: Number(item.lng)
          });  
          
          },200)
             setTimeout(function(){ 
                self.cityclicked = false;
             },2000);

      /*
          this.$refs.mapRef.$mapPromise.then(map => {
                  if (item.type == "city" || item.type == "City") {

                  //  map.setZoom(10);
                 this.animateMapZoomTo(map, 10);

                  }

     
      


            if (this.defaultType == "Map") {
        } else {
          this.$refs.mapRef.$mapPromise.then(map => {
            if (item.title == "USA" || item.title == null) {
              map.setZoom(4);
            } else {

        
            var self = this;
            setTimeout(function(){

             if (item.type != undefined) {
                if (item.type == "USA") {
                  map.setZoom(4);
                } else {
                  if (item.type == "State" || item.type == "STATE") {
                    //dra polyligne
                    var featurecollection = [];
                    featurecollection.type = "FeatureCollection";
                    featurecollection.features = [];
                    _.each(self.mapfeatures.features, function(iteml, idx) {
                      if (iteml.properties.NAME == item.rtitle) {
                        featurecollection.features.push(iteml);
                      }
                    });
                  //  map.setZoom(6);
                     self.animateMapZoomTo(map, 6);
                    //this.mapfeatures = featurecollection;
                    map.data.addGeoJson(featurecollection, {
                      idPropertyName: "STATE"
                    });
                    map.data.revertStyle();

                    map.data.setStyle(function(feature) {
                      return {
                        fillColor: "#88c936",
                        fillOpacity: 0,
                        strokeColor: "#88c936",
                        strokeWeight: 2,
                        strokeOpacity: 0.6
                      };
                    }); 
                  } else {
                    map.setZoom(10);
                  }
                }
              } else {
                map.setZoom(10);
              }
              self.cityclicked = false;
            },100)

             
            }
       
          });
        }

          }); */

      if (item.rtitle != "USA") {  
        if (item.type == "State" || item.type == "STATE") {
            this.cityclicked = true;
          this.filternearbyname("", item.rtitle);
            this.cityclicked = true;
        } else if (item.type == "City" || item.type == "CITY") {
        //  console.log(item);
          this.filternearbyname(item.rtitle, item.state);
            this.cityclicked = true;
        } else {
          this.filternearby(item.lat, item.lng, 300);
        }

        // this.getMarkers(item.rtitle);
        localStorage.selecteccity = item.rtitle;
        localStorage.selectetype = item.type;
        localStorage.selectedstate = item.state;

        localStorage.lat = item.lat;
        localStorage.lng = item.lng;

        
      } else {
        this.$refs.mapRef.$mapPromise.then(map => {
          map.panTo({
            lat: Number(item.lat),
            lng: Number(item.lng)
          });

        map.setZoom(4);

        });
      }
    }, 200),
    mylocationFormated: function() {
      if (this.mylocationFormated != null) {
        this.selectedAddress = this.mylocationFormated;
      }
    },
    markers: function(items) {
      if (this.markers.length == 0) {
        // disaply here select city popup
      }
    },
    currentLocation: function(item) {
      if (item != undefined && item != null) {
        this.codeLatLng(item.lat, item.lng);
      }
    },
        currentLocationmarker: function(item) {
      if (item != undefined && item != null) {
       // this.codeLatLng(item.lat, item.lng);
      }
    },
    previoushover: function() {
      if (this.previoushover) {
        interval = setInterval(() => {
          this.$refs.slick.prev();
        }, 200);
      } else {
        this.$refs.slick.pause();
        clearInterval(interval);
      }
    },
    nexthover: function() {
      if (this.nexthover) {
        rinterval = setInterval(() => {
          this.$refs.slick.next();
        }, 200);
      } else {
        clearInterval(rinterval);

        this.$refs.slick.pause();
      }
    }
  },
  props: {
    msg: String
  }
};
</script>


